export const DEFAULT_LOCALE = 'en';

export const translations = {
  en: {
    appName: 'PlayHouse',
    accessTitle: 'Access Control',
    accessSubtitle: 'Secure sign-in for staff and managers.',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
    usernamePlaceholder: 'Enter your username',
    passwordPlaceholder: 'Enter your password',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    loginSuccess: 'Signed in successfully.',
    logoutSuccess: 'Logged out.',
    loginInvalid: 'Invalid username or password.',
    loginMissing: 'Enter your username and password.',
    loginFailed: 'Login failed. Try again.',
    renewPasswordTitle: 'Set a new password',
    renewPasswordSubtitle: 'Your account requires a new password before you can continue.',
    newPasswordLabel: 'New password',
    newPasswordPlaceholder: 'Enter your new password',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Re-enter your new password',
    renewPasswordSubmit: 'Update password',
    renewingPassword: 'Updating password...',
    renewPasswordSuccess: 'Password updated successfully.',
    renewPasswordMissing: 'Enter and confirm your new password.',
    renewPasswordMismatch: 'Passwords do not match.',
    renewPasswordInvalid: 'Password does not meet requirements.',
    renewPasswordFailed: 'Password update failed. Try again.',
    toastDismiss: 'Dismiss notification',
    toastRegionLabel: 'Notifications',
    checkingSession: 'Checking session...',
    activeSession: 'Active session',
    logout: 'Log out',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    navAccountMenu: 'Account menu',
    backToList: 'Back to list',
    cancel: 'Cancel',
    roleStaff: 'Staff',
    roleManager: 'Manager',
    roleAdmin: 'Admin',
    roleSuperuser: 'Superuser',
    rbacTitle: 'Role-based access',
    rbacSubtitle: 'Choose a workspace to verify your access.',
    rbacStaffTitle: 'Staff workspace',
    rbacStaffDescription: 'Daily check-ins, visits, and guest support.',
    rbacManagerTitle: 'Manager console',
    rbacManagerDescription: 'Team oversight, schedules, and approvals.',
    rbacAdminTitle: 'Admin settings',
    rbacAdminDescription: 'System configuration and permissions.',
    rbacSuperuserTitle: 'Superuser controls',
    rbacSuperuserDescription: 'Platform-wide controls and elevated access.',
    rbacOpen: 'Open',
    rbacRestricted: 'Restricted',
    rbacCheckingAccess: 'Checking access...',
    rbacAccessGranted: 'Access granted.',
    rbacAccessDenied: 'You do not have access to that area.',
    rbacAccessFailed: 'Unable to verify access. Try again.',
    rbacSelectedLabel: 'Selected area',
    bootstrapTitle: 'First-run setup',
    bootstrapSubtitle:
      'Create the admin account and your business profile to finish setup.',
    bootstrapSectionAdmin: 'Admin account',
    bootstrapSectionOrganization: 'Business profile',
    bootstrapOrgName: 'Business name',
    bootstrapOrgNamePlaceholder: 'Shown to staff in the navigation bar',
    bootstrapBusinessType: 'Business type',
    bootstrapOwnerName: 'Owner or manager',
    bootstrapOwnerNamePlaceholder: 'Primary contact for this venue',
    bootstrapOrgEmail: 'Business email (optional)',
    bootstrapOrgEmailPlaceholder: 'contact@example.com',
    bootstrapOrgPhone: 'Phone (optional)',
    bootstrapOrgPhonePlaceholder: 'Include country code if needed',
    bootstrapOrgWebsite: 'Website (optional)',
    bootstrapOrgWebsitePlaceholder: 'https://example.com',
    bootstrapOrgAddress: 'Address (optional)',
    bootstrapOrgAddressPlaceholder: 'Street, neighborhood, city',
    organizationBusinessType_children_playhouse: "Children's playhouse",
    organizationBusinessType_gym: 'Gym / fitness',
    organizationBusinessType_game_nets: 'Trampoline / nets park',
    organizationBusinessType_workspace: 'Cowork / workspace',
    organizationBusinessType_boardgame_cafe: 'Board game café',
    organizationSettingsTitle: 'Business profile',
    organizationSettingsSubtitle: 'Venue branding, ownership, and public contact info.',
    organizationLogoLabel: 'Logo',
    organizationLogoUpload: 'Upload logo',
    organizationLogoUploading: 'Uploading…',
    organizationLogoHint: 'JPEG, PNG, or WebP. Maximum 2 MB.',
    organizationLogoUploadFailed: 'Logo upload failed. Try another file.',
    organizationBusinessTypeLabel: 'Business type',
    organizationBusinessTypeChoose: 'Select type…',
    organizationBusinessTypeUnset: 'Not set',
    organizationBusinessTypeLockedHint: 'Locked after initial setup.',
    organizationBusinessTypeFirstHint: 'Select once — it locks after saving.',
    organizationNameLabel: 'Business name',
    organizationOwnerLabel: 'Owner / manager',
    organizationEmailLabel: 'Email',
    organizationPhoneLabel: 'Phone',
    organizationWebsiteLabel: 'Website',
    organizationAddressLabel: 'Address',
    organizationSave: 'Save business profile',
    bootstrapEmailLabel: 'Email (optional)',
    bootstrapEmailPlaceholder: 'name@example.com',
    bootstrapCreate: 'Create superuser',
    bootstrapCreating: 'Creating...',
    bootstrapSuccess: 'Superuser created. Please sign in.',
    bootstrapAlreadyExists: 'A superuser already exists. Please sign in.',
    bootstrapUsernameTaken: 'That username is already taken.',
    bootstrapInvalid: 'Check the form and try again.',
    bootstrapFailed: 'Bootstrap failed. Try again.',
    bootstrapStatusFailed: 'Unable to check setup status.',
    bootstrapRequiredNotice: 'Initial setup required to manage admin access.',
    bootstrapStart: 'Start setup',
    bootstrapBackToLogin: 'Back to sign in',
    branchInitPageSubtitle: 'Create your first branch to continue.',
    branchInitWaitingSubtitle: 'Branch setup is required before you can use the app.',
    branchInitWaitingTitle: 'Waiting for branch setup',
    branchInitWaitingMessage: 'An administrator must create the first branch before you can continue.',
    branchInitTitle: 'First branch',
    branchInitSubtitle: 'Every venue needs at least one branch before staff can use the app.',
    branchInitNameLabel: 'Branch name',
    branchInitNamePlaceholder: 'e.g. Main location',
    branchInitCreate: 'Create branch',
    branchInitCreating: 'Creating...',
    branchInitSuccess: 'Branch created. Welcome!',
    branchInitFailed: 'Could not create branch. Try again.',
    branchInitNameRequired: 'Enter a branch name.',
    branchInitNameExists: 'A branch with this name already exists.',
    branchSelectorTitle: 'Choose a branch',
    branchSelectorSubtitle: 'Select the branch you want to work in.',
    branchSelectorListLabel: 'Your branches',
    branchSelectorLoading: 'Loading branches...',
    branchSelectorLoadFailed: 'Could not load branches.',
    branchSelectorEmpty: 'No branches available.',
    branchSelectorSelecting: 'Switching branch...',
    branchAccessWaitingTitle: 'Branch access required',
    branchAccessWaitingSubtitle: 'An administrator must assign you to a branch before you can continue.',
    branchAccessWaitingHeading: 'Waiting for branch access',
    branchAccessWaitingMessage:
      'You are signed in, but no branch has been assigned to your account yet. Contact an administrator.',
    navActiveBranch: 'Active branch',
    branchesTitle: 'Branches',
    branchesSubtitle: 'Manage locations and branch status.',
    branchesListLabel: 'Branches',
    branchesTotal: 'Total',
    branchesEmpty: 'No branches yet.',
    branchesLoading: 'Loading branches...',
    branchesListLoadFailed: 'Could not load branches.',
    branchesStatusLoadFailed: 'Could not load branch status.',
    branchesCreateButton: 'Add branch',
    branchesCreateTitle: 'New branch',
    branchesNameLabel: 'Branch name',
    branchesNamePlaceholder: 'Branch name',
    branchesStatusLabel: 'Status',
    branchesStatusActive: 'Active',
    branchesStatusInactive: 'Inactive',
    branchesSaveButton: 'Save',
    branchesSaving: 'Saving...',
    branchesCreateSuccess: 'Branch created.',
    branchesCreateFailed: 'Could not create branch.',
    branchesUpdateSuccess: 'Branch updated.',
    branchesUpdateFailed: 'Could not update branch.',
    branchesDeleteButton: 'Delete',
    branchesDeleting: 'Deleting...',
    branchesDeleteConfirm: 'Delete this branch? This cannot be undone.',
    branchesDeleteSuccess: 'Branch deleted.',
    branchesDeleteFailed: 'Could not delete branch.',
    branchesDeleteLastBranch: 'Cannot delete the last branch. At least one branch is required.',
    branchesDeactivateButton: 'Deactivate',
    branchesDeactivating: 'Deactivating...',
    branchesDeactivateSuccess: 'Branch deactivated.',
    branchesDeactivateFailed: 'Could not deactivate branch.',
    branchesActivateButton: 'Activate',
    branchesActivating: 'Activating...',
    branchesActivateSuccess: 'Branch activated.',
    branchesActivateFailed: 'Could not activate branch.',
    branchesNameExists: 'A branch with this name already exists.',
    branchesDetailEmpty: 'Select a branch to view details.',
    branchSettingsEyebrow: 'Current branch',
    branchSettingsTitle: 'Branch settings',
    branchSettingsSubtitle: 'Configure options for your currently active branch.',
    branchSettingsTabGeneral: 'General',
    branchSettingsTabCounters: 'Counters',
    branchSettingsTabPaymentTypes: 'Payment types',
    branchSettingsTabDevices: 'Devices',
    branchScopeLabel: 'Branch availability',
    branchScopeAll: 'All branches',
    branchScopeThisBranch: 'This branch only',
    branchScopeFilterActiveBranch: 'Show items for active branch',
    branchSettingsGeneralTitle: 'Branch overview',
    branchSettingsGeneralSubtitle:
      'These settings apply only to the branch you are working in right now.',
    branchSettingsOperationalTitle: 'Operational settings',
    branchSettingsOperationalSubtitle:
      'Active hours, locker limits, and exit barcode input for this branch.',
    branchSettingsLoading: 'Loading branch settings...',
    branchSettingsLoadFailed: 'Could not load branch settings.',
    branchSettingsSaveFailed: 'Could not save branch settings.',
    branchSettingsSaveSuccess: 'Branch settings saved.',
    branchSettingsExitBarcodeInputModeLabel: 'Exit barcode input mode',
    branchSettingsExitBarcodeInputModeHint:
      'How staff verify visit barcodes at exit for this branch (not entry).',
    branchSettingsChildExitModeLabel: 'Child exit mode',
    branchSettingsChildExitModeHint:
      'Whether child exit is recorded separately or together with the visit exit',
    branchSettingsChildExitModeOptSeparate: 'Separate',
    branchSettingsChildExitModeOptWithVisit: 'With visit',
    branchSettingsExitPaymentModeLabel: 'Exit / payment mode',
    branchSettingsExitPaymentModeHint:
      'Whether exit is decoupled from payment or recorded together with payment',
    branchSettingsExitPaymentModeOptMultiStep: 'Multi-step payments',
    branchSettingsExitPaymentModeOptExitOnPayment: 'Exit on payment',
    branchSettingsBranchNameLabel: 'Branch name',
    branchSettingsManageBranchesLink: 'Manage all branches',
    branchSettingsManageBranchesHint:
      'Create branches, rename them, or change status across your organization.',
    branchSettingsPaymentTypesTitle: 'Payment types',
    branchSettingsPaymentTypesPlaceholder:
      'Per-branch payment types will be configured here in a future update.',
    branchSettingsDevicesTitle: 'Devices',
    branchSettingsDevicesPlaceholder:
      'Device bindings for this branch will be configured here after device integration is available.',
    branchDevicesTabSubtitle: 'Bind discovered hardware to counters for this branch.',
    branchDevicesCreateButton: 'Add binding',
    branchDevicesCreateTitle: 'New device binding',
    branchDevicesEditTitle: 'Edit device binding',
    branchDevicesEditButton: 'Edit',
    branchDevicesDeleteButton: 'Delete',
    branchDevicesDeleteConfirm: 'Remove this device binding? This cannot be undone.',
    branchDevicesSaveButton: 'Save',
    branchDevicesSaving: 'Saving...',
    branchDevicesCreating: 'Creating...',
    branchDevicesLoading: 'Loading device bindings...',
    branchDevicesEmpty: 'No device bindings yet.',
    branchDevicesListLoadFailed: 'Could not load device bindings.',
    branchDevicesCreateSuccess: 'Device binding created.',
    branchDevicesCreateFailed: 'Could not create device binding.',
    branchDevicesUpdateSuccess: 'Device binding updated.',
    branchDevicesUpdateFailed: 'Could not update device binding.',
    branchDevicesDeleteSuccess: 'Device binding removed.',
    branchDevicesDeleteFailed: 'Could not remove device binding.',
    branchDevicesCounterLabel: 'Counter',
    branchDevicesCounterRequired: 'Select a counter.',
    branchDevicesNoCounters: 'No active counters',
    branchDevicesRoleLabel: 'Role',
    branchDevicesRolePrinter: 'Printer',
    branchDevicesRoleLockerset: 'Lockerset',
    branchDevicesRolePos: 'POS',
    branchDevicesDeviceLabel: 'Device',
    branchDevicesDeviceRequired: 'Select a device.',
    branchDevicesNoDevices: 'No discovered devices available',
    branchDevicesSharedLabel: 'Allow shared binding (same device on multiple counters)',
    branchDevicesSharedBadge: 'Shared',
    branchDevicesFilterCounterLabel: 'Filter by counter',
    branchDevicesFilterAllCounters: 'All counters',
    branchDevicesUnknownCounter: 'Unknown counter',
    branchDevicesStatusActive: 'Active',
    branchDevicesStatusUnbound: 'Unbound',
    branchDevicesStatusMissing: 'Missing',
    branchDevicesTypePrinter: 'Printer',
    branchDevicesTypeLockersetController: 'Lockerset controller',
    branchDevicesTypePos: 'POS',
    branchDevicesInventoryTitle: 'Discovered inventory',
    branchDevicesInventorySubtitle:
      'Devices reported by branch drivers. Bind them to counters above.',
    branchDevicesInventoryLoading: 'Loading discovered devices...',
    branchDevicesInventoryEmpty: 'No devices discovered yet. Connect a driver and wait for inventory.',
    branchDevicesInventoryLoadFailed: 'Could not load discovered devices.',
    branchDevicesRediscoverButton: 'Re-discover devices',
    branchDevicesRediscovering: 'Re-discovering...',
    branchDevicesRediscoverSuccess: 'Device inventory updated from connected drivers.',
    branchDevicesRediscoverFailed: 'Could not re-discover devices. Ensure a driver is connected.',
    branchDevicesRediscoverNoDrivers: 'No connected drivers for this branch.',
    branchDevicesDiscoveredBadge: 'From driver report',
    branchesQuotaExceeded: 'Branch limit reached — upgrade your plan to add more.',
    counterSetupBannerTitle: 'No counters configured',
    counterSetupBannerMessage:
      'Entry and exit are blocked until at least one active counter is defined for this branch.',
    counterSetupBannerAdminAction: 'Manage counters',
    counterSetupBannerStaffHint: 'Ask an administrator to add a counter for this branch.',
    activeCounterLabel: 'Active counter',
    activeCounterChangeButton: 'Change',
    counterSelectionTitle: 'Choose a counter',
    counterSelectionSubtitle: 'Select the counter you are working at.',
    counterSelectionLoading: 'Loading counters...',
    counterSelectionLoadFailed: 'Could not load counters.',
    counterSelectionEmpty: 'No active counters available.',
    counterSelectionSelecting: 'Setting counter...',
    counterGateHintNoCounters:
      'Entry and exit are unavailable until counters are configured for this branch.',
    counterGateHintSelectCounter: 'Select your active counter before starting entry or exit.',
    counterGateHintInactiveCounter:
      'Your selected counter is inactive. Choose an active counter to start entry or exit.',
    countersTabTitle: 'Counters',
    countersTabSubtitle: 'Define checkout stations for this branch.',
    countersCreateButton: 'Add counter',
    countersCreateTitle: 'New counter',
    countersEditTitle: 'Edit counter',
    countersEditButton: 'Edit',
    countersNameLabel: 'Counter name',
    countersNamePlaceholder: 'e.g. Front desk',
    countersNameRequired: 'Enter a counter name.',
    countersStatusLabel: 'Status',
    countersStatusActive: 'Active',
    countersStatusInactive: 'Inactive',
    countersSaveButton: 'Save',
    countersSaving: 'Saving...',
    countersCreating: 'Creating...',
    countersLoading: 'Loading counters...',
    countersEmpty: 'No counters yet.',
    countersListLoadFailed: 'Could not load counters.',
    countersCreateSuccess: 'Counter created.',
    countersCreateFailed: 'Could not create counter.',
    countersUpdateSuccess: 'Counter updated.',
    countersUpdateFailed: 'Could not update counter.',
    countersDeleteButton: 'Delete',
    countersDeleteConfirm: 'Delete this counter? This cannot be undone.',
    countersDeleteSuccess: 'Counter deleted.',
    countersDeleteFailed: 'Could not delete counter.',
    countersDeleteInUse: 'Counter is in use and cannot be deleted.',
    countersDeactivateButton: 'Deactivate',
    countersActivateButton: 'Activate',
    countersNameExists: 'A counter with this name already exists in this branch.',
    adminUsersTitle: 'Admin management',
    adminUsersSubtitle: 'Create, update, and deactivate admin accounts.',
    adminUsersUsername: 'Admin username',
    adminUsersUsernamePlaceholder: 'e.g., admin.jane',
    adminUsersPassword: 'Admin password',
    adminUsersPasswordPlaceholder: 'Set a temporary password',
    adminUsersEmail: 'Admin email',
    adminUsersEmailPlaceholder: 'name@example.com',
    adminUsersActive: 'Active',
    adminUsersCreate: 'Create admin',
    adminUsersCreating: 'Creating...',
    adminUsersListLabel: 'Admins',
    adminUsersTotalLabel: 'Total',
    adminUsersEmpty: 'No admin users yet.',
    adminUsersEdit: 'Edit',
    adminUsersDeactivate: 'Deactivate',
    adminUsersActivate: 'Activate',
    adminUsersSave: 'Save changes',
    adminUsersCancel: 'Cancel',
    adminUsersPasswordReset: 'Reset password',
    adminUsersPasswordResetPlaceholder: 'Leave blank to keep current',
    adminUsersStatusActive: 'Active',
    adminUsersStatusInactive: 'Inactive',
    adminUsersStatusAll: 'All statuses',
    adminUsersStatusLabel: 'Status',
    adminUsersSearchLabel: 'Search',
    adminUsersSearchPlaceholder: 'Search by username',
    adminUsersFilterApply: 'Apply filters',
    adminUsersFilterClear: 'Clear filters',
    adminUsersNoEmail: 'No email on file',
    adminUsersCreated: 'Admin created.',
    adminUsersUpdated: 'Admin updated.',
    adminUsersDeactivated: 'Admin deactivated.',
    adminUsersFailed: 'Unable to manage admin users.',
    adminUsersInvalid: 'Check the admin form and try again.',
    adminUsersUsernameTaken: 'That username is already taken.',
    adminUsersNotFound: 'Admin user not found.',
    teamUsersTitle: 'Staff & manager management',
    teamUsersSubtitle: 'Create, update, and deactivate staff or manager accounts.',
    teamUsersUsername: 'Username',
    teamUsersUsernamePlaceholder: 'e.g., staff.sam',
    teamUsersPassword: 'Password',
    teamUsersPasswordPlaceholder: 'Set a temporary password',
    teamUsersEmail: 'Email',
    teamUsersEmailPlaceholder: 'name@example.com',
    teamUsersRole: 'Role',
    teamUsersRoleStaff: 'Staff',
    teamUsersRoleManager: 'Manager',
    teamUsersActive: 'Active',
    teamUsersCreate: 'Create user',
    teamUsersCreating: 'Creating...',
    teamUsersListLabel: 'Team users',
    teamUsersTotalLabel: 'Total',
    teamUsersEmpty: 'No staff or manager users yet.',
    teamUsersEdit: 'Edit',
    teamUsersDeactivate: 'Deactivate',
    teamUsersActivate: 'Activate',
    teamUsersSave: 'Save changes',
    teamUsersCancel: 'Cancel',
    teamUsersPasswordReset: 'Reset password',
    teamUsersPasswordResetPlaceholder: 'Leave blank to keep current',
    teamUsersStatusActive: 'Active',
    teamUsersStatusInactive: 'Inactive',
    teamUsersStatusAll: 'All statuses',
    teamUsersStatusLabel: 'Status',
    teamUsersRoleLabel: 'Role',
    teamUsersRoleAll: 'All roles',
    teamUsersSearchLabel: 'Search',
    teamUsersSearchPlaceholder: 'Search by username',
    teamUsersFilterApply: 'Apply filters',
    teamUsersFilterClear: 'Clear filters',
    teamUsersNoEmail: 'No email on file',
    teamUsersCreated: 'User created.',
    teamUsersUpdated: 'User updated.',
    teamUsersDeactivated: 'User deactivated.',
    teamUsersFailed: 'Unable to manage staff or manager users.',
    teamUsersInvalid: 'Check the user form and try again.',
    teamUsersUsernameTaken: 'That username is already taken.',
    teamUsersNotFound: 'User not found.',
    teamUsersInvalidRole: 'Select a valid role.',
    teamUsersForbidden: 'You do not have access to manage team users.',
    branchAccessLabel: 'Branch access',
    branchAccessHint: 'Select which branches this user can access.',
    branchAccessLoading: 'Loading branches...',
    branchAccessEmpty: 'No active branches available.',
    branchAccessLoadFailed: 'Unable to load branch access.',
    branchAccessAdminImplicit: 'Admin users have access to all branches automatically.',
    branchAccessInvalidBranch: 'One or more selected branches are invalid.',
    auditLogsTitle: 'Audit log',
    auditLogsSubtitle: 'Review critical actions across the system.',
    auditLogsStartDate: 'Start date',
    auditLogsEndDate: 'End date',
    auditLogsUser: 'User',
    auditLogsUserPlaceholder: 'e.g., admin.user',
    auditLogsAction: 'Action',
    auditLogsActionPlaceholder: 'e.g., user_password_reset',
    auditLogsModule: 'Module',
    auditLogsModulePlaceholder: 'e.g., users',
    auditLogsUserAll: 'All users',
    auditLogsActionAll: 'All actions',
    auditLogsModuleAll: 'All modules',
    auditLogsApply: 'Apply filters',
    auditLogsClear: 'Clear',
    auditLogsListLabel: 'Logs',
    auditLogsTotalLabel: 'Total',
    auditLogsEmpty: 'No audit logs found.',
    auditLogsDate: 'Timestamp',
    auditLogsActor: 'Actor',
    auditLogsActionType: 'Action',
    auditLogsModuleLabel: 'Module',
    auditLogsEntity: 'Entity',
    auditLogsUnknownUser: 'System',
    auditLogsUnknownDate: 'Unknown time',
    auditLogsFailed: 'Unable to load audit logs.',
    auditLogsInvalid: 'Check the filter values and try again.',
    auditLogsForbidden: 'You do not have access to audit logs.',
    auditActionAdminUserCreated: 'Admin created',
    auditActionAdminUserUpdated: 'Admin updated',
    auditActionAdminUserDeactivated: 'Admin deactivated',
    auditActionStaffManagerUserCreated: 'Staff/manager created',
    auditActionStaffManagerUserUpdated: 'Staff/manager updated',
    auditActionStaffManagerUserDeactivated: 'Staff/manager deactivated',
    auditActionUserPasswordReset: 'Password reset',
    auditActionSessionTimeoutUpdated: 'Session timeout updated',
    auditActionCustomerCreated: 'Customer created',
    auditActionCustomerUpdated: 'Customer updated',
    auditActionCustomerDeleted: 'Customer deleted',
    auditActionCustomerBanned: 'Customer banned',
    auditActionCustomerUnbanned: 'Customer unbanned',
    auditActionCustomerImportedBulk: 'Customers imported in bulk',
    auditActionChildCreated: 'Child created',
    auditActionChildUpdated: 'Child updated',
    auditActionChildDeleted: 'Child deleted',
    auditActionVisitCreated: 'Visit created',
    auditActionVisitStarted: 'Visit play started',
    auditActionVisitSessionCreated: 'Visit session created',
    auditActionVisitOpened: 'Visit opened',
    auditActionVisitChildExited: 'Visit child exited',
    auditActionVisitChildAdded: 'Visit child added mid-visit',
    auditActionVisitExited: 'Visit play exited',
    auditActionVisitSessionExited: 'Visit session exited',
    auditActionPricingPlanCreated: 'Pricing plan created',
    auditActionPricingPlanUpdated: 'Pricing plan updated',
    auditActionPricingPlanDeleted: 'Pricing plan deleted',
    auditActionDiscountCreated: 'Discount created',
    auditActionDiscountActivated: 'Discount activated',
    auditActionDiscountDeactivated: 'Discount deactivated',
    auditActionPaymentTypeCreated: 'Payment type created',
    auditActionPaymentTypeUpdated: 'Payment type updated',
    auditActionPaymentTypeActivated: 'Payment type activated',
    auditActionPaymentTypeDeactivated: 'Payment type deactivated',
    auditActionPaymentTypeDeleted: 'Payment type deleted',
    auditActionPaymentRecorded: 'Payment recorded',
    auditActionReceiptPrinted: 'Receipt printed',
    auditActionTransactionChargePriceCorrected: 'Transaction charge price corrected',
    auditActionTransactionChargeAutoRounded: 'Transaction charge auto-rounded',
    auditActionTransactionChargeAutoRoundReverted: 'Transaction charge auto-round reverted',
    auditActionSystemSettingsUpdated: 'System settings updated',
    auditActionVisitChildBarcodeVerified: 'Visit child barcode verified',
    auditActionVisitChildBarcodeBypass: 'Visit child barcode bypass',
    auditActionDiscountApplied: 'Discount applied',
    auditActionFinancialAccountCreated: 'Financial account created',
    auditActionFinancialAccountUpdated: 'Financial account updated',
    auditActionFinancialAccountActivated: 'Financial account activated',
    auditActionFinancialAccountDeactivated: 'Financial account deactivated',
    auditActionUtilitySetCreated: 'Utility set created',
    auditActionUtilitySetUpdated: 'Utility set updated',
    auditActionUtilitySetDeleted: 'Utility set deleted',
    auditActionUtilityCreated: 'Utility created',
    auditActionUtilityUpdated: 'Utility updated',
    auditActionUtilityDeactivated: 'Utility deactivated',
    auditActionUtilityActivated: 'Utility activated',
    auditActionUtilityDeleted: 'Utility deleted',
    auditActionIntegrationCreated: 'Integration created',
    auditActionIntegrationUpdated: 'Integration updated',
    auditActionIntegrationDeleted: 'Integration deleted',
    auditActionDriverSetupCodeCreated: 'Driver setup code created',
    auditActionDriverSetupCodeRevoked: 'Driver setup code revoked',
    auditActionDriverRegistered: 'Driver registered',
    auditActionDriverDisabled: 'Driver disabled',
    auditActionDriverEnabled: 'Driver enabled',
    auditActionDriverDeleted: 'Driver deleted',
    auditActionDriverApiKeyRotated: 'Driver API key rotated',
    auditActionDriverHealthStatusChanged: 'Driver health status changed',
    auditActionGiftCardTypeCreated: 'Gift card type created',
    auditActionGiftCardTypeUpdated: 'Gift card type updated',
    auditActionGiftCardInstanceIssued: 'Gift card issued',
    auditActionGiftCardBatchIssued: 'Gift card batch issued',
    auditActionGiftCardPurchased: 'Gift card purchased',
    auditActionGiftCardInstanceMapped: 'Gift card mapped to customer',
    auditActionBranchCreated: 'Branch created',
    auditActionBranchUpdated: 'Branch updated',
    auditActionBranchDeleted: 'Branch deleted',
    auditActionCounterCreated: 'Counter created',
    auditActionCounterUpdated: 'Counter updated',
    auditActionCounterDeleted: 'Counter deleted',
    auditActionUserBranchAccessUpdated: 'User branch access updated',
    auditModuleUsers: 'Users',
    auditModuleCustomers: 'Customers',
    auditModuleVisits: 'Visits',
    auditModuleSettings: 'Settings',
    auditModulePricing: 'Pricing',
    auditModuleDiscounts: 'Discounts',
    auditModuleFinancial: 'Financial settings',
    auditModuleUtilities: 'Utilities',
    auditModuleIntegrations: 'Integrations',
    auditModuleBranches: 'Branches',
    entryStartTitle: 'Customer entry',
    entryStartButton: 'Customer entry',
    entryModalTitle: 'Start entry flow',
    entryStageCustomer: 'Customer',
    entryStageChildren: 'Children',
    entryStagePricing: 'Pricing',
    entryStageLockers: 'Lockers',
    receiptTitle: 'Visit receipt',
    receiptCustomer: 'Customer:',
    receiptPhone: 'Phone:',
    receiptEntryTime: 'Entry:',
    receiptExpectedExit: 'Expected exit:',
    receiptChildrenSection: 'Children',
    receiptVisitQrSection: 'Visit QR',
    receiptPaymentSection: 'Payment on entry',
    receiptLockersSection: 'Lockers',
    receiptLockersLoadFailed: 'Could not load locker list for receipt.',
    receiptPreviewLoading: 'Loading receipt preview…',
    receiptPreviewLoadFailed: 'Could not load receipt preview from the server.',
    receiptThermalRequiresDriver:
      'Thermal receipts print through the on-site integration driver. In Settings → Entry & visit, set Printer to Driver.',
    receiptFooter: 'Please keep this receipt until all children have exited.',
    receiptExitTitle: 'Exit receipt',
    receiptActualExit: 'Actual exit:',
    receiptSettlementSection: 'Settlement',
    receiptExitLockersSection: 'Released utilities',
    receiptExitFooter: 'Thank you. Please retain this receipt for your records.',
    receiptExitChildStay: 'Stay time:',
    receiptExitTableName: 'Name',
    receiptExitTableAge: 'Age',
    receiptExitTableStay: 'Stay',
    receiptEntryTableNotes: 'Notes',
    exitReceiptPreviewHint:
      'Thermal receipt prints on your connected station printer (via on-site driver). Tap Print when ready.',
    receiptQrMissing: 'QR unavailable',
    entryReceiptTitle: 'Print receipt',
    entryReceiptSubtitle: 'Print a receipt with one visit QR (faster customer exit lookup).',
    entryReceiptPrint: 'Print',
    entryReceiptSkip: 'Skip',
    entryReceiptPrinting: 'Preparing print…',
    exitBarcodeLabel: 'Scan or paste visit QR',
    exitBarcodePlaceholder: 'Scan or paste barcode…',
    exitBarcodeVerified: 'Verified',
    exitBarcodeScan: 'Verify',
    exitBarcodeBypass: 'Bypass (manager)',
    exitBarcodeBypassTitle: 'Bypass barcode verification?',
    exitBarcodeBypassBody:
      'Only use if you have verified the customer by other means. This action is logged.',
    exitBarcodeBypassReasonLabel: 'Reason (required)',
    exitBarcodeBypassConfirm: 'Confirm bypass',
    exitBarcodeBypassCancel: 'Cancel',
    activeSessionsChildExitNeedBarcode: 'Verify barcode before exit.',
    exitBarcodeMismatch: 'Barcode does not match this child.',
    exitBarcodeVerifyFailed: 'Could not verify barcode. Try again.',
    exitBarcodeEmpty: 'Enter or scan the barcode first.',
    exitChildScanTitle: 'Verify exit',
    exitChildScanSubtitle: 'Choose how to read the QR code for this child.',
    exitChildScanChooseCamera: 'Use camera',
    exitChildScanChooseBarcode: 'Barcode scanner / paste',
    exitChildScanBack: 'Back',
    exitChildScanCameraHint: 'Point the camera at the QR code on the receipt.',
    exitChildScanCameraPermissionDenied:
      'Camera access was denied. Allow camera in the browser settings, or use the barcode scanner option if enabled.',
    exitChildScanCameraNoDevice: 'No camera was found on this device.',
    exitChildScanVerifying: 'Verifying…',
    exitChildScanVerifiedExitFailedIntro:
      'Barcode verified, but exit could not be completed:',
    exitChildScanExitRetryHint: 'Close this dialog and tap Exit again.',
    exitChildScanVerifyChildNotFound: 'This child was not found for this visit.',
    exitChildScanExitChildNotFound: 'Could not find this child to exit.',
    exitChildScanExitNeedsVerify: 'Barcode verification is still required before exit.',
    exitChildScanExitBypassNotAllowed: 'Manager approval is required to bypass at exit.',
    exitLookupByQr: 'Scan visit QR',
    exitLookupByQrBack: 'Back to search',
    exitLookupByQrHint: 'Point the camera at the visit QR on the entry receipt.',
    exitCustomerQrLookupFailed: 'Could not look up this QR. Try again or use phone.',
    exitCustomerQrInvalid: 'This QR is not valid.',
    exitCustomerQrNotFound: 'Visit not found.',
    exitCustomerQrNotActive: 'No active session for this QR.',
    exitCustomerQrMismatch: 'QR does not match customer phone.',
    entryProgressLabel: 'Entry steps',
    entryClose: 'Close',
    entryPhoneLabel: 'Customer phone',
    entryLookupLabel: 'Phone or name',
    entryLookupPlaceholder: 'Search by phone or customer name',
    entryLookupQueryRequired: 'Enter a phone number or name to search.',
    entryLookupHint: 'Type a phone number or first/last name. Pick a suggestion or tap Find.',
    entryMultipleMatches: 'Several customers match. Choose one from the list or refine your search.',
    entryTooManyMatches: 'Too many matches. Type more letters or digits to narrow the search.',
    entryPhonePlaceholder: 'Enter phone number',
    entryLookupButton: 'Continue',
    entryLookupLoading: 'Searching...',
    entryLookupFound: 'Customer found.',
    entryLookupNotFound: 'No customer found. Create a new customer to continue.',
    entryLookupFailed: 'Unable to find customer. Try again.',
    entryPhoneRequired: 'Enter a phone number.',
    entryPhoneInvalid: 'Enter a valid phone number (11 digits starting with 0, or 10 digits).',
    entryCustomerFound: 'Customer ready',
    entryCustomerReady: 'Review details before selecting children.',
    entryCustomerReviewBeforeChildren: 'Review details and select children. Customer is saved when you complete pricing.',
    entryCustomerNameLabel: 'Name',
    entryCustomerPhoneLabel: 'Phone',
    entryCustomerCodeLabel: 'Customer ID',
    entryContinueButton: 'Continue entry',
    entryCreateButton: 'Create customer',
    entryCreateTitle: 'Create customer',
    entryCreateSubtitle: 'Add the customer before starting entry.',
    entryCreateSubmit: 'Save customer',
    entryCreateSaving: 'Saving...',
    entryCreateSuccess: 'Customer created.',
    entryCreateFailed: 'Unable to create customer.',
    entryCreatePhoneExists: 'Phone already exists. Try another.',
    entryCreateMissing: 'Fill in all required fields.',
    entryBackToLookup: 'Back to lookup',
    exitStartTitle: 'Customer exit',
    exitStartButton: 'Customer exit',
    exitStartSearchByPhone: 'Search by phone or name',
    exitLookupLabel: 'Phone or name',
    exitLookupPlaceholder: 'Search by phone or customer name',
    exitStartScanQr: 'Scan QR',
    exitModalTitle: 'Exit flow',
    exitLookupNotFound: 'No active visit found for this phone or name.',
    exitLookupFailed: 'Unable to search. Try again.',
    exitPhoneRequired: 'Enter a phone number or name.',
    entryEditButton: 'Edit customer',
    entryEditTitle: 'Edit customer',
    entryEditSubtitle: 'Update details before continuing.',
    entryEditSave: 'Save changes',
    entryEditSaving: 'Saving...',
    entryEditSuccess: 'Customer updated.',
    entryEditFailed: 'Unable to update customer.',
    entryEditPhoneExists: 'Phone already exists. Try another.',
    entryEditMissing: 'Last name and phone are required.',
    entryEditCancel: 'Cancel',
    entryChildrenTitle: 'Select children',
    entryChildrenSubtitle: 'Add children if they are part of this visit.',
    entryDurationTitle: 'Expected duration',
    entryDurationBack: 'Back to children',
    entryDurationContinue: 'Start entry',
    entryDurationMinutesSuffix: 'minutes',
    entryPaymentPaid: 'Paid',
    entryEnteredButton: 'Enter without pay',
    entryEnteredSubmitting: 'Recording entry...',
    entryEnteredSuccess: 'Visit recorded without payment.',
    entryEnteredActionsHint: 'Records the visit without taking payment at the counter.',
    entryCustomerBannedBlocked: 'This customer is banned. You cannot start a visit.',
    entryCustomerOpenVisitBlocked:
      'This customer already has an open visit. Close it before starting a new one.',
    entryLockersTitle: 'Locker assignment',
    entryLockersSubtitle:
      'Choose a locker area and how many lockers you need. Review the summary, then tap Done—or skip if no lockers are needed.',
    entryLockersPrepareHint:
      'Choose lockers before payment. They are assigned automatically when you start the visit below.',
    entryLockersAssignedDone: 'Lockers assigned for this visit.',
    entryLockersLoading: 'Loading locker sets...',
    entryLockersNoSets: 'No locker sets configured.',
    entryLockersSetLabel: 'Locker set',
    entryLockersSetPlaceholder: 'Select set',
    entryLockersSetFallback: 'Locker set {id}',
    entryLockersSetAvailable: 'Available: {count}',
    entryLockersQuantityDecrease: 'Decrease quantity',
    entryLockersQuantityIncrease: 'Increase quantity',
    entryLockersSummaryTitle: 'Assignment summary',
    entryLockersSummaryTotal: 'Total: {count} lockers from {sets} areas',
    entryLockersSummaryTotalSingleLocker: 'Total: {count} locker from {sets} areas',
    entryLockersSummaryTotalSingleArea: 'Total: {count} lockers from {sets} area',
    entryLockersSummaryTotalSingleLockerSingleArea: 'Total: {count} locker from {sets} area',
    entryLockersWarningInsufficient: 'You selected more than available in {set} (only {available} available).',
    entryLockersCountLabel: 'Count',
    entryLockersAddSet: 'Add set',
    entryLockersRemoveRow: 'Remove',
    entryLockersSkip: 'Skip',
    entryLockersDone: 'Done',
    entryLockersAssigning: 'Assigning...',
    entryLockersErrorMaxExceeded: 'Maximum lockers per customer exceeded.',
    entryLockersErrorInsufficient: 'Not enough lockers available in this set.',
    entryLockersErrorVisitNotFound: 'Visit not found.',
    entryLockersErrorNoContiguous: 'No contiguous lockers available in this set.',
    entryLockersErrorGeneric: 'Locker assignment failed.',
    entryDiscountLabel: 'Discount code',
    entryDiscountPlaceholder: 'Enter discount code',
    entryDiscountApply: 'Apply',
    entryDiscountRemove: 'Remove discount',
    entryPriceLabel: 'Calculated price',
    entryPricePlaceholder: '—',
    entryPriceLoading: 'Calculating...',
    entryPriceUnavailable: 'Unavailable',
    entryDiscountedPriceLabel: 'Discounted price',
    entryDiscountedPricePlaceholder: '—',
    entryFinalPriceLabel: 'Final price',
    entryFinalPricePlaceholder: '—',
    entryPaymentTypeLabel: 'Payment type',
    entryPaymentTypePlaceholder: 'Select payment type',
    entryPaymentTypeCash: 'Cash',
    entryPaymentTypeCard: 'Card',
    entryPaymentTypeOnline: 'Online',
    entryPaymentTypeOther: 'Other',
    entryDurationOption30: '30 minutes',
    entryDurationOption45: '45 minutes',
    entryDurationOption60: '1 hour',
    entryDurationOption120: '2 hours',
    entryExpectedDurationLabel: 'Expected duration (minutes)',
    entryExpectedDurationPlaceholder: 'e.g., 90',
    entryExpectedDurationRequired: 'Enter the expected duration to continue.',
    entryChildrenEmpty: 'No children on file yet. You can continue without adding any.',
    entryChildrenLoading: 'Loading children...',
    entryChildrenLoadFailed: 'Unable to load children.',
    entryChildAddButton: 'Add child',
    entryChildEditButton: 'Edit',
    entryChildAgeYears: '{age} years old',
    entryChildAgeMonths: '{months} months old',
    entryChildAgeMonthSingular: '{months} month old',
    entryChildAgeYearSingular: '{age} year old',
    entryChildAgeYearSingularMonthSingular: '{age} year and {months} month old',
    entryChildAgeYearSingularMonthPlural: '{age} year and {months} months old',
    entryChildAgeYearsMonthSingular: '{age} years and {months} month old',
    entryChildAgeYearsMonthPlural: '{age} years and {months} months old',
    entryChildSelectionRequired: 'Select at least one child to continue.',
    entryVisitRequiresCustomer: 'Select or create a customer before starting a visit.',
    entryVisitEntryPrerequisites:
      'Select a customer and at least one child before starting the visit (paid or unpaid).',
    entryChildSpecialConditionsBadge: 'Special conditions',
    entryChildFormTitle: 'Add child',
    entryChildFormEditTitle: 'Edit child',
    entryChildFormSubtitle: 'Add a child before starting entry.',
    entryChildFormEditSubtitle: 'Correct child details before starting entry.',
    entryChildFormSave: 'Save child',
    entryChildFormCancel: 'Cancel',
    entryChildFormMissing: 'First name, last name, and birthday are required.',
    entryChildCreating: 'Saving...',
    entryChildEditing: 'Saving...',
    entryChildCreateSuccess: 'Child added.',
    entryChildCreateFailed: 'Unable to add child.',
    entryChildUpdateFailed: 'Unable to update child.',
    entryChildFirstNameLabel: 'First name',
    entryChildLastNameLabel: 'Last name',
    entryChildGenderLabel: 'Gender',
    entryChildGenderPlaceholder: 'Select gender',
    entryChildGenderMale: 'Male',
    entryChildGenderFemale: 'Female',
    entryChildGenderOther: 'Other',
    entryChildGenderUnspecified: 'Unspecified',
    entryChildGenderRequired: 'Select a gender for this child.',
    entryChildBirthdayLabel: 'Birthday',
    entryChildSpecialConditionsLabel: 'Special conditions (optional)',
    entryFirstNameLabel: 'First name',
    entryLastNameLabel: 'Last name',
    entryEmergencyNameLabel: 'Emergency contact name',
    entryEmergencyPhoneLabel: 'Emergency contact phone',
    entryEmergencyPhoneInvalid:
      'Enter a valid emergency phone number (11 digits starting with 0, or 10 digits).',
    entryOptionalSuffix: ' (optional)',
    entryNotesLabel: 'Notes (optional)',
    entrySuggestionsLabel: 'Suggestions',
    entrySuggestionsLoading: 'Loading suggestions...',
    entrySuggestionsEmpty: 'No matches yet.',
    entrySessionStarting: 'Starting entry...',
    entrySessionStarted: 'Entry session started.',
    entrySessionFailed: 'Unable to start entry. Try again.',
    entrySessionActiveExists: 'An active session already exists for this visit.',
    entryVisitOpening: 'Opening visit...',
    entryVisitOpenFailed: 'Unable to open the visit. Try again.',
    entryVisitTimeNotAllowed:
      'Entry is not allowed at this time — it is outside the visit hours set under System settings (Entry & visit).',
    entryVisitPending: 'Payment is required before opening the visit.',
    entryVisitCreateFailed: 'Unable to start a visit right now.',
    activeSessionsTitle: 'Active sessions',
    activeSessionsSubtitle: 'Monitor guests currently on-site.',
    activeSessionsGuestsInside: 'Guests inside',
    activeSessionsChildrenInside: 'Children inside',
    activeSessionsListLabel: 'Active sessions',
    activeSessionsTotalLabel: 'Total',
    activeSessionsLoading: 'Loading active sessions...',
    activeSessionsEmpty: 'No active sessions right now.',
    activeSessionsLoadFailed: 'Unable to load active sessions.',
    activeSessionsCustomerLabel: 'Customer',
    activeSessionsPhoneLabel: 'Phone',
    activeSessionsEntryCounterLabel: 'Entry counter',
    activeSessionsEntryLabel: 'Entry time',
    activeSessionsLockersLabel: 'Locker(s)',
    activeSessionsWristbandLabel: 'Wristband',
    activeSessionsStatusLabel: 'Visit status',
    activeSessionsActionsLabel: 'Actions',
    activeSessionsManageLockers: 'Manage lockers',
    activeSessionsManageWristband: 'Manage wristband',
    activeSessionsManageChildren: 'Manage children',
    activeSessionsExitAction: 'Exit',
    activeSessionsViewProfile: 'View profile',
    activeSessionsCaptionLockers: 'Lockers',
    activeSessionsCaptionWristband: 'Wristband',
    activeSessionsCaptionChildren: 'Children',
    activeSessionsCaptionProfile: 'Profile',
    activeSessionsCaptionExit: 'Exit',
    activeSessionsModalClose: 'Close',
    activeSessionsLockersModalTitle: 'Manage lockers',
    activeSessionsLockersAssignLabel: 'Assign lockers',
    activeSessionsLockersRelease: 'Release',
    activeSessionsLockersPlaceholder: 'Locker management will be available here.',
    sessionLockersSummaryMain: '{total} lockers',
    sessionLockersSummaryMainSingular: '{total} locker',
    sessionLockersSummaryAvailable: '{total} available',
    sessionLockersAddMore: 'Add more',
    sessionLockersHideAdd: 'Hide',
    sessionLockersReleaseAll: 'Release all',
    sessionLockersReleaseAllConfirm:
      'Release all lockers assigned to this visit? This cannot be undone from here.',
    sessionLockersReleaseAllSuccess: 'All lockers released.',
    sessionLockersReleaseAllError: 'Could not release all lockers.',
    sessionLockersReleaseOneError: 'Could not release locker.',
    sessionLockersReleaseOneSuccess: 'Locker released.',
    sessionLockersNoAssignments: 'No lockers assigned to this visit yet.',
    sessionLockersAssignedSectionTitle: 'Assigned lockers',
    sessionLockersAddSectionTitle: 'Add lockers',
    sessionLockersAssignSelected: 'Assign selected',
    sessionLockersGroupCount: '{count} lockers',
    sessionLockersGroupCountSingular: '{count} locker',
    sessionLockersUnknownSet: 'Locker area',
    sessionLockersAssignPartialError:
      'Incomplete: {done} of {total} locker set(s) were assigned before an error. {detail}',
    sessionLockersDone: 'Done',
    activeSessionsWristbandModalTitle: 'Manage wristband',
    activeSessionsWristbandPlaceholder: 'Wristband management will be available here.',
    activeSessionsChildrenModalTitle: 'Manage children',
    activeSessionsChildrenPlaceholder: 'Session children management will be available here.',
    activeSessionsChildrenLoading: 'Loading session children...',
    activeSessionsChildrenEmpty: 'No children recorded for this visit.',
    activeSessionsChildrenLoadFailed: 'Unable to load session children.',
    sessionAddChildButton: 'Add child',
    sessionAddChildTitle: 'Add child to this visit',
    sessionAddChildFirstName: 'First name',
    sessionAddChildLastName: 'Last name',
    sessionAddChildBirthday: 'Birthday',
    sessionAddChildBirthdayRequired: 'Birthday is required.',
    sessionAddChildGenderRequired: 'Select a gender for this child.',
    sessionAddChildSpecialConditions: 'Special conditions (optional)',
    sessionAddChildSubmit: 'Add child',
    sessionAddChildCancel: 'Cancel',
    sessionAddChildSaving: 'Saving…',
    sessionAddChildSuccess: 'Child added to the visit.',
    sessionAddChildFailed: 'Could not add the child.',
    sessionAddChildVisitNotPlay: 'Play has not started for this visit (or session ended).',
    sessionAddChildMismatch: 'Selected child cannot be added.',
    sessionAddChildVisitNotFound: 'Visit not found.',
    sessionAddChildValidation: 'Check first and last name.',
    sessionAddChildTabRegistered: 'Registered child',
    sessionAddChildTabNew: 'New child',
    sessionAddChildLoadingRegistered: 'Loading registered children…',
    sessionAddChildRegisteredLoadFailed: 'Could not load this customer’s children.',
    sessionAddChildRegisteredAllOnVisit:
      'Every registered child is already on this visit. Use New child to enter someone else.',
    sessionAddChildRegisteredHint:
      'Pick a saved profile that is not already active on this visit.',
    activeSessionsChildActive: 'Active',
    activeSessionsChildExited: 'Exited',
    activeSessionsChildExitAction: 'Mark exit',
    activeSessionsChildExitLoading: 'Saving...',
    activeSessionsChildAlreadyExited: 'Child is already exited.',
    activeSessionsChildSessionInactive: 'Session is no longer active.',
    activeSessionsChildExitSuccess: 'Child marked as exited.',
    activeSessionsChildExitFailed: 'Unable to mark child exit.',
    childCardAgeLabel: 'Age',
    childCardGenderLabel: 'Gender',
    childCardSpecialConditionsLabel: 'Special conditions',
    childCardNoSpecialConditions: 'None',
    childCardNotSpecified: 'Not specified',
    childrenListNameColumn: 'Child',
    childrenListStatusColumn: 'Status',
    activeSessionsExitModalTitle: 'Exit session',
    activeSessionsExitPlaceholder: 'Exit workflow will be available here.',
    activeSessionsExitExpected: 'Expected duration',
    activeSessionsExitTotal: 'Total stay',
    activeSessionsExitExtra: 'Extra time',
    activeSessionsExitPricingBase: 'Entry charge',
    activeSessionsExitPricingBasePaid: 'Entry charge (paid)',
    activeSessionsExitPricingBasePending: 'Entry charge (pending)',
    activeSessionsExitPricingBeforeDiscount: 'Total before discount',
    activeSessionsExitPricingDiscount: 'Discount',
    activeSessionsExitPricingFinal: 'Total after discount',
    activeSessionsExitPricingAdditional: 'Extra charge after entry',
    activeSessionsExitPricingPaid: 'Paid amount',
    activeSessionsExitPricingRemaining: 'Remaining balance',
    activeSessionsExitPricingBreakdown: 'Breakdown',
    activeSessionsExitPricingPerChild: 'Per-child totals',
    activeSessionsExitPricingMinutes: 'Minutes',
    activeSessionsExitPricingBilledMinutesHint: 'min billed',
    activeSessionsExitPricingTier: 'Tier',
    activeSessionsExitPricingChildren: 'Children',
    activeSessionsExitPricingAmount: 'Amount',
    activeSessionsExitPricingLoading: 'Calculating pricing...',
    exitFlowContinueToPayment: 'Continue to payment',
    exitFlowBackToDetails: 'Back',
    activeSessionsExitConfirm: 'Confirm exit',
    activeSessionsExitSubmitting: 'Exiting...',
    activeSessionsExitRequiresPayment: 'This visit must be checked out with payment.',
    activeSessionsExitPaymentDoesNotSettle: 'Payment does not settle the visit balance.',
    activeSessionsExitCheckoutConfirm: 'Record payment and exit',
    activeSessionsExitCheckoutSubmitting: 'Recording payment and exiting…',
    activeSessionsExitCompleted: 'Exit recorded.',
    activeSessionsExitSuccess: 'Session exited.',
    activeSessionsExitLockersOpened: 'Lockers opened and released',
    activeSessionsExitFailed: 'Unable to exit session.',
    activeSessionsExitPreviewFailed: 'Unable to load exit pricing.',
    activeSessionsExitPlanMissing: 'No active default pricing plan found.',
    activeSessionsExitPlanMultiple: 'Multiple pricing plans match this time.',
    activeSessionsExitMissingEntry: 'Entry time is missing.',
    activeSessionsExitStepsMissing: 'Pricing steps are not defined.',
    activeSessionsExitChildrenActive: 'Exit all children before closing the session.',
    sessionExitChildActionsColumn: 'Action',
    exitPaymentsPricingDetailsToggle: 'Pricing details (breakdown & per child)',
    exitAssignedUtilitiesTitle: 'Assigned utilities',
    exitUtilitiesLoading: 'Loading utilities...',
    exitUtilitiesEmpty: 'No utilities assigned for this visit.',
    exitUtilitiesLoadFailed: 'Unable to load utility assignments.',
    exitReviewTitle: 'Review & confirm',
    exitReviewBack: 'Back',
    exitReviewPrintReceipt: 'Print receipt',
    exitReceiptTitle: 'Exit complete',
    exitReceiptDisabledHint:
      'Exit receipts are turned off in Settings. Close this step when you are finished—no receipt will be printed.',
    systemSettingsExitReceiptEnabledLabel: 'Offer exit receipt after checkout',
    systemSettingsExitReceiptEnabledHint:
      'When off, staff skip the exit receipt preview and print step after closing a visit. Entry receipts are unchanged.',
    systemSettingsReceiptPreviewEnabledLabel: 'Confirm receipts before printing',
    systemSettingsReceiptPreviewEnabledHint:
      'When on, staff see a confirmation step before a receipt job is sent to the on-site printer driver.',
    entryReceiptAutoPrintHint: 'The receipt will print automatically. You can skip if you do not need a copy.',
    receiptAutoPrinting: 'Printing…',
    exitReceiptReportIntro:
      'The session was closed successfully. Below is a summary of the final amount, payments, and any utilities that were released.',
    exitReceiptPaymentsSum: 'Payments total',
    exitReceiptDone: 'Done',
    exitFreedUtilitiesTitle: 'Freed utilities',
    exitFreedUtilitiesEmpty: 'No utility releases recorded for this exit.',
    exitFlowNextButton: 'Next',
    activeSessionsExitInactive: 'Session is already closed.',
    activeSessionsValuePlaceholder: '—',
    activeSessionsCustomerFallback: 'Unknown',
    activeSessionsReprintEntry: 'Reprint entry receipt',
    activeSessionsCaptionReprintEntry: 'Reprint',
    activeSessionsReprintEntrySuccess: 'Entry receipt sent to printer.',
    activeSessionsReprintEntryFailed: 'Could not reprint the entry receipt.',
    customersTitle: 'Customer management',
    customersSubtitle: 'Review customers and their visit history.',
    customersListLabel: 'Customers',
    customersListLoading: 'Loading customers...',
    customersListEmpty: 'No customers found.',
    customersListError: 'Unable to load customers.',
    customersListTotal: 'Total',
    customersListEmptyFiltered: 'No customers match the current filters on this page.',
    customersImportButton: 'Import customers',
    customersImportTitle: 'Import customers',
    customersImportIntro: 'Upload an Excel file with customer first name, last name, and phone.',
    customersImportLimitHint: 'Maximum {limit} customers per import.',
    customersImportDownloadTemplate: 'Download Excel template',
    customersImportDownloading: 'Downloading template...',
    customersImportDownloadFailed: 'Unable to download import template.',
    customersImportDropTitle: 'Drag and drop your Excel file here',
    customersImportDropHint: 'or click to browse (.xlsx only)',
    customersImportPhoneHint: 'Format the phone column as Text in Excel to keep leading zeros.',
    customersImportSelectedFile: 'Selected: {name}',
    customersImportInvalidFile: 'Please choose a valid Excel file (.xlsx).',
    customersImportFileLabel: 'Excel file (.xlsx)',
    customersImportSubmit: 'Import',
    customersImportImporting: 'Importing...',
    customersImportCancel: 'Close',
    customersImportFailed: 'Customer import failed.',
    customersImportSuccessSummary: 'Imported {accepted} customers. Skipped {skipped} duplicates.',
    customersImportSkippedDetails: 'Skipped rows',
    customersImportSkippedRow: 'Row {row}: {reason}',
    customersFilterSearch: 'Search',
    customersSearchAction: 'Search',
    customersFilterSearchPlaceholder: 'Name, code, or phone…',
    customersFilterStatus: 'Status',
    customersFilterStatusAll: 'All',
    customersFilterStatusActive: 'Active',
    customersFilterStatusBanned: 'Banned',
    customersFilterClear: 'Clear filters',
    customersNameFallback: 'Unnamed customer',
    customersProfileTitle: 'Customer profile',
    customersProfileLoading: 'Loading customer profile...',
    customersProfileLoadFailed: 'Unable to load customer profile.',
    customersBack: 'Back to list',
    customersTabDetails: 'Profile',
    customersTabVisits: 'Visits',
    customersTabPendingPayments: 'Unpaid & pending',
    customersVisitStatusLeftUnpaid: 'Left unpaid',
    customersPendingTitle: 'Unpaid and pending transactions',
    customersPendingLoading: 'Loading unpaid transactions...',
    customersPendingEmpty: 'No unpaid balance on file.',
    customersPendingFailed: 'Unable to load unpaid transactions.',
    customersPendingExpand: 'Details & pay',
    customersPendingCollapse: 'Hide',
    customersPendingTxnLabel: 'Transaction',
    customersPendingVisitShort: 'Visit',
    customersPendingAutoBadge: 'Auto-closed',
    customersPendingChargesToggle: 'Charge lines',
    pendingTransactionAdjustPriceButton: 'Adjust price',
    pendingTransactionChargeNotAdjustable:
      'This line cannot be adjusted (for example, a payment was recorded after it).',
    pendingTransactionChargeNotFound: 'Charge not found.',
    pendingTransactionPriceCorrectionDisabled: 'Price correction is disabled in settings.',
    pendingTransactionPriceCorrectionForbidden: 'You do not have permission to correct prices.',
    customersChildrenTitle: 'Children',
    customersChildrenEmpty: 'No children recorded.',
    customersChildEdit: 'Edit',
    customersChildDelete: 'Delete',
    customersChildDeleteConfirm: 'Delete this child?',
    customersChildEditTitle: 'Edit child',
    customersChildEditSave: 'Save changes',
    customersChildEditCancel: 'Cancel',
    customersChildUpdateSuccess: 'Child updated.',
    customersChildUpdateFailed: 'Unable to update child.',
    customersChildDeleteSuccess: 'Child deleted.',
    customersChildDeleteFailed: 'Unable to delete child.',
    customersChildBirthdayUnknown: 'Birthday not set',
    customersDeleteButton: 'Delete customer',
    customersDeleteTitle: 'Delete customer',
    customersDeletePrompt:
      'This action removes the customer {name} and all their info and cannot be undone.',
    customersDeleteCancel: 'Cancel',
    customersDeleteConfirm: 'Delete',
    customersDeleteDeleting: 'Deleting...',
    customersDeleteSuccess: 'Customer deleted.',
    customersDeleteFailed: 'Unable to delete customer.',
    customersBanButton: 'Ban customer',
    customersUnbanButton: 'Unban customer',
    customersBanTitle: 'Ban customer',
    customersBanPrompt: 'Provide a reason for banning {name}.',
    customersBanReasonLabel: 'Ban reason',
    customersBanReasonPlaceholder: 'Explain why this customer is banned',
    customersBanConfirm: 'Ban customer',
    customersBanCancel: 'Cancel',
    customersBanSubmitting: 'Banning...',
    customersBanSuccess: 'Customer banned.',
    customersBanFailed: 'Unable to ban customer.',
    customersUnbanSuccess: 'Customer unbanned.',
    customersUnbanFailed: 'Unable to unban customer.',
    customersStatusLabel: 'Status',
    customersStatusAllowed: 'Allowed',
    customersStatusBanned: 'Banned',
    customersEmergencyContact: 'Emergency contact',
    customersNotes: 'Notes',
    customersNotesEmpty: 'No notes.',
    customersMetadata: 'Metadata',
    customersCreatedAtLabel: 'Created',
    customersUpdatedAtLabel: 'Updated',
    customersDetailsShowMore: 'Show more details',
    customersDetailsShowLess: 'Show fewer details',
    customersBanReasonMissing: 'No reason provided',
    customersVisitsLabel: 'Visits',
    customersVisitsLoading: 'Loading visits...',
    customersVisitsFailed: 'Unable to load visits.',
    customersVisitsEmpty: 'No visits recorded.',
    customersVisitIdLabel: 'Visit ID',
    customersVisitStatusLabel: 'Status',
    customersVisitOpenedLabel: 'Opened',
    customersVisitClosedLabel: 'Closed',
    customersVisitStatusPending: 'Pending payment',
    customersVisitStatusOpen: 'Open',
    customersVisitStatusClosed: 'Closed',
    paginationPrevious: 'Previous',
    paginationNext: 'Next',
    paginationPageLabel: 'Page',
    paginationPageSizeLabel: 'Page size',
    dropdownNoOptions: 'No options found',
    navDashboard: 'Dashboard',
    navEntryPage: 'New entry',
    navExitPage: 'Customer exit',
    entryPageTitle: 'New customer entry',
    entryPageSubtitle: 'Look up a customer, then complete children and payment in one place.',
    entryPageBackToDashboard: 'Back to dashboard',
    exitPageSubtitle: 'Find the active visit by phone, then complete checkout.',
    exitPageBackToDashboard: 'Back to dashboard',
    navFinancialManagement: 'Financial management',
    navDailySalesSummary: 'Daily sales summary',
    navCustomers: 'Customers',
    navPricing: 'Pricing',
    navDiscounts: 'Discounts',
    navSalesReports: 'Sales reports',
    navFinancialSettings: 'Financial settings',
    navUtilities: 'Utilities',
    navIntegrations: 'Integrations',
    navDrivers: 'Drivers',
    navSystemSettings: 'System settings',
    navUserManagement: 'User management',
    navBranches: 'Branches',
    navBranchSettings: 'Branch settings',
    navAuditLogs: 'Audit logs',
    navSectionBusiness: 'Business',
    navSectionAdmin: 'Admin',
    navAriaLabel: 'Main navigation',
    entitlementsUpgradeTitle: 'Upgrade required',
    entitlementsLockedBadge: 'Upgrade plan',
    entitlementsLockedNavHint: 'Upgrade your plan to access this area.',
    entitlementsQuotaLocked: 'Quota reached — upgrade plan to add more.',
    entitlementsFeatureRequired: 'This feature is not included on your {plan} plan.',
    entitlementsQuotaReached:
      'You have reached the limit ({current} of {cap}) on your {plan} plan.',
    entitlementsQuotaUsage: '{current} of {cap} used',
    entitlementsUpgradeHint: 'Contact your administrator to upgrade your plan.',
    entitlementsPlanUnknown: 'current',
    systemSettingsTitle: 'System settings',
    systemSettingsSubtitle: 'Configuration and operational controls.',
    systemSettingsThemeTitle: 'Interface theme',
    systemSettingsThemeSubtitle:
      'Choose the color theme for the staff console. This applies to everyone using this site.',
    systemSettingsThemeVibrantLabel: 'Vibrant sage & rose',
    systemSettingsThemeVibrantDescription:
      'Bright greens, rose, and coral — a fresh, energetic default.',
    systemSettingsThemeWarmLabel: 'Warm brown & cream',
    systemSettingsThemeWarmDescription:
      'Gold and cream tones with a classic, welcoming feel.',
    systemSettingsThemeCoolLabel: 'Cool blue & coral',
    systemSettingsThemeCoolDescription:
      'Calming blues with soft coral accents.',
    systemSettingsThemeVibrantDarkLabel: 'Moonlit sage & rose',
    systemSettingsThemeVibrantDarkDescription:
      'Soft charcoal greens and blush accents—steady contrast all day.',
    systemSettingsThemeWarmDarkLabel: 'Toasted walnut & cream',
    systemSettingsThemeWarmDarkDescription:
      'Warm cocoa panels and muted gold accents for low glare.',
    systemSettingsThemeCoolDarkLabel: 'Twilight blue & blush',
    systemSettingsThemeCoolDarkDescription:
      'Quiet navy surfaces with lavender and coral highlights.',
    systemSettingsHint: 'More system settings will be available here soon.',
    systemSettingsEntryVisitTitle: 'Entry & visit',
    systemSettingsEntryVisitSubtitle: 'Default duration and allowed visit window.',
    systemSettingsFlowTypeTitle: 'Entry & exit flow layout',
    systemSettingsFlowTypeSubtitle: 'Choose wizard steps or a single-page layout for staff.',
    systemSettingsEntryFlowTypeLabel: 'Entry flow',
    systemSettingsExitFlowTypeLabel: 'Exit flow',
    systemSettingsFlowTypeWizard: 'Wizard',
    systemSettingsFlowTypeSinglePage: 'Single page',
    systemSettingsEntryFlowTypeHint:
      'Wizard uses step-by-step screens. Single page shows customer lookup and visit details on one page.',
    systemSettingsExitFlowTypeHint:
      'Wizard splits lookup and checkout into steps. Single page shows them together.',
    systemSettingsFinancialTitle: 'Credits & payable display',
    systemSettingsFinancialSubtitle:
      'Customer wallet credits and how “Payable now” appears when credits are off.',
    systemSettingsCreditSystemEnabledLabel: 'Customer credit wallet',
    systemSettingsCreditSystemEnabledHint:
      'When enabled, overpayments become wallet credit and can apply at checkout. When disabled, no credit is issued or consumed.',
    systemSettingsCreditSystemEnabled: 'Enabled',
    systemSettingsCreditSystemDisabled: 'Disabled',
    systemSettingsPayableOverpayDisplayLabel: 'Payable when overpaid (credits off)',
    systemSettingsPayableOverpayDisplayHint:
      'If the customer paid more than the visit total and credits are disabled, show either zero or the raw negative balance in “Payable now”.',
    systemSettingsPayableOverpayDisplayHintWhenCreditOn:
      'Not used while the credit wallet is enabled.',
    systemSettingsPayableOverpayDisplayZero: 'Show zero',
    systemSettingsPayableOverpayDisplayNegative: 'Show negative balance',
    entrySinglePageSectionCustomer: 'Customer',
    entrySinglePageSectionChildren: 'Children',
    entrySinglePageSectionPayment: 'Duration & payment (In case of early pay)',
    entrySinglePageChangeCustomer: 'Change customer',
    systemSettingsExpectedDurationLabel: 'Default expected duration (minutes)',
    systemSettingsExpectedDurationHint: 'Used when starting a new visit session.',
    systemSettingsChildGenderRequiredLabel: 'Require child gender at entry',
    systemSettingsChildGenderRequiredHint:
      'When on, staff must pick boy or girl; when off, unnamed children can be saved as unspecified.',
    systemSettingsDurationOptionsLabel: 'Expected duration options (minutes)',
    systemSettingsDurationOptionsHint: 'Comma-separated values shown during entry.',
    systemSettingsActiveTimeLabel: 'Allowed active time window',
    systemSettingsActiveTimeStartLabel: 'Start time',
    systemSettingsActiveTimeEndLabel: 'End time',
    systemSettingsActiveTimeAllDay: 'Allow visits all day',
    systemSettingsReceiptSectionTitle: 'Receipts',
    systemSettingsReceiptSectionSubtitle:
      'Entry and exit printing, paper size, browser or on-premises driver, and optional preview before print.',
    systemSettingsExitVisitQrSectionTitle: 'Visit QR at exit',
    systemSettingsExitVisitQrSectionIntro:
      'When a visit is checked out, staff look up the session by scanning the visit QR (from the entry receipt or customer phone). Choose how that scan is captured.',
    systemSettingsEntryVisitQrSectionTitle: 'Visit QR at entry',
    systemSettingsEntryVisitQrSectionIntro:
      'When staff assign lockers at entry, the visit QR on the receipt can be scanned later at checkout. Choose how that QR is captured during entry workflows.',
    systemSettingsEntryBarcodeInputModeLabel: 'How staff scan the visit QR at entry',
    systemSettingsEntryBarcodeInputModeHint:
      'Camera for phone-displayed QR, USB scanner or manual entry for printed slips, or both so staff can choose each time.',
    systemSettingsReceiptGenerationLabel: 'Offer printed receipt after entry (visit QR)',
    systemSettingsReceiptGenerationHint:
      'When enabled, staff see a print step after locker assignment. The receipt includes one visit QR (visit id, phone, and time) for exit lookup—not a separate QR per child.',
    systemSettingsReceiptPaperSizeLabel: 'Receipt paper / layout',
    systemSettingsReceiptPaperSizeHint:
      'Sets the width and typography used when printing the entry receipt (browser print). Match your printer paper.',
    systemSettingsReceiptPaperSizeOptTHERMAL_80: 'Thermal 80 mm',
    systemSettingsReceiptPaperSizeOptTHERMAL_58: 'Thermal 58 mm',
    systemSettingsReceiptPaperSizeOptA4: 'A4 / full width',
    systemSettingsReceiptPrintMethodLabel: 'Receipt printing',
    systemSettingsReceiptPrintMethodHint:
      'Browser print uses the system print dialog. Driver print sends the receipt to your on-premises Pilche driver (thermal) when implemented; prototype queues on the server.',
    systemSettingsReceiptPrintBrowser: 'Browser print',
    systemSettingsReceiptPrintDriver: 'On-premises driver (thermal)',
    systemSettingsReceiptRenderingModeLabel: 'Receipt rasterization',
    systemSettingsReceiptRenderingModeHint:
      'When printing via driver: Server uses HTML→PDF (legacy). Driver renders from JSON locally (recommended for simpler server stack).',
    systemSettingsReceiptRenderingServer: 'Render on server (legacy)',
    systemSettingsReceiptRenderingDriver: 'Render on driver (JSON template)',
    systemSettingsReceiptFooterTextLabel: 'Receipt footer text',
    systemSettingsReceiptFooterTextPlaceholder: 'Enter custom footer text (max 2 lines)',
    systemSettingsReceiptFooterTextHint: 'Max 2 lines, {lines}/2 lines, {chars}/300 characters',
    systemSettingsReceiptFooterTextTooLong: 'Receipt footer text must be 300 characters or fewer.',
    systemSettingsReceiptFooterTextTooManyLines: 'Receipt footer text must be at most 2 lines.',
    receiptPrintFailed: 'Could not send the receipt to the printer.',
    receiptPrintFallbackPrompt:
      'Printing via the driver failed. Print using the browser instead?',
    systemSettingsBarcodeInputModeLabel: 'How staff scan the visit QR at exit',
    systemSettingsBarcodeInputModeHint:
      'Camera for phone-displayed QR, USB scanner or manual entry for printed slips, or both so staff can choose each time.',
    systemSettingsBarcodeInputModeOptCamera: 'Camera only',
    systemSettingsBarcodeInputModeOptUsbScanner: 'USB scanner / manual entry only',
    systemSettingsBarcodeInputModeOptBoth: 'Camera and USB scanner / manual entry (staff chooses)',
    systemSettingsPricingTitle: 'Pricing',
    systemSettingsPricingSubtitle: 'Pricing tier settings for walk-in plans.',
    systemSettingsPricingTierLabel: 'Pricing tier count',
    systemSettingsPricingTierHint: 'The final tier is treated as N+.',
    systemSettingsPricingTierBasisLabel: 'Tier basis',
    systemSettingsPricingTierBasisHint: 'Choose what each tier represents.',
    systemSettingsExpectedDurationError: 'Enter a valid duration.',
    systemSettingsDurationOptionsError: 'Enter at least one valid duration.',
    systemSettingsPricingTierError: 'Enter a tier count between 1 and 4.',
    systemSettingsPriceCorrectionBoundsError: 'Bounds percent must be between 0 and 100.',
    systemSettingsPricingTierBasisError: 'Select a tier basis.',
    systemSettingsUtilitiesTitle: 'Utilities (lockers)',
    systemSettingsUtilitiesSubtitle: 'Locker assignment limits.',
    systemSettingsUtilitiesMaxLockersLabel: 'Max lockers per customer',
    systemSettingsUtilitiesMaxLockersHint: 'Maximum number of lockers that can be assigned to one customer at a time. Choose Unlimited for no limit.',
    systemSettingsUtilitiesMaxLockersUnlimited: 'Unlimited',
    systemSettingsUtilitiesMaxLockersError: 'Enter at least 1.',
    systemSettingsActiveTimeError: 'Start and end time are required.',
    systemSettingsActiveTimeOrderError: 'End time must be after start time.',
    systemSettingsSave: 'Save settings',
    systemSettingsSaving: 'Saving...',
    systemSettingsSaveSuccess: 'Settings updated.',
    systemSettingsSaveFailed: 'Unable to update settings.',
    systemSettingsLoadFailed: 'Unable to load settings.',
    systemSettingsLoading: 'Loading settings...',
    utilitiesTitle: 'Utilities',
    utilitiesSubtitle: 'Manage physical resources. Utility types are system-defined; add utilities with a type and manage them.',
    utilitiesTypesLabel: 'Utility types',
    utilitiesTypesLoading: 'Loading utility types...',
    utilitiesTypesEmpty: 'No utility types found.',
    utilitiesTypesLoadFailed: 'Unable to load utility types.',
    utilitiesTypesSchema: 'Properties',
    utilitiesTypeHardware: 'Hardware integration',
    utilitiesTypeNoHardware: 'No hardware',
    utilitiesPropRequired: 'required',
    utilitiesListLabel: 'Utilities',
    utilitiesSearchPlaceholder: 'Search by number or set...',
    utilitiesListLoading: 'Loading utilities...',
    utilitiesListEmpty: 'No utilities found.',
    utilitiesListLoadFailed: 'Unable to load utilities.',
    utilitiesTotal: 'Total',
    utilitiesCreateButton: 'Add utility',
    utilitiesCreateTitle: 'Add utility',
    utilitiesCreateSuccess: 'Utility added.',
    utilitiesCreateFailed: 'Unable to add utility.',
    utilitiesBulkCreateSuccess: 'Created {{count}} utilities.',
    utilitiesBulkCreateFailed: 'Unable to create utilities.',
    utilitiesAddSingleTab: 'Single',
    utilitiesAddBulkTab: 'Bulk',
    utilitiesStartNumberLabel: 'Start number',
    utilitiesEndNumberLabel: 'End number',
    utilitiesStartNumberPlaceholder: 'e.g. 101',
    utilitiesEndNumberPlaceholder: 'e.g. 120',
    utilitiesBulkRangeHint: 'Will create {{count}} utilities.',
    utilitiesEditTitle: 'Edit utility',
    utilitiesEditButton: 'Edit',
    utilitiesUpdateSuccess: 'Utility updated.',
    utilitiesUpdateFailed: 'Unable to update utility.',
    utilitiesDeactivateButton: 'Deactivate',
    utilitiesDeactivating: 'Deactivating...',
    utilitiesDeactivateSuccess: 'Utility deactivated.',
    utilitiesDeactivateFailed: 'Unable to deactivate utility.',
    utilitiesActivateButton: 'Activate',
    utilitiesActivating: 'Activating...',
    utilitiesActivateSuccess: 'Utility activated.',
    utilitiesActivateFailed: 'Unable to activate utility.',
    utilitiesDeleteButton: 'Delete',
    utilitiesDeleting: 'Deleting...',
    utilitiesDeleteConfirm: 'Permanently delete this utility? This cannot be undone.',
    utilitiesDeleteSuccess: 'Utility deleted.',
    utilitiesDeleteFailed: 'Unable to delete utility.',
    utilitiesOpenButton: 'Open locker',
    utilitiesOpening: 'Opening...',
    utilitiesOpenSuccess: 'Locker opened.',
    utilitiesOpenFailed: 'Could not open locker. Check integration.',
    utilitiesOpenSentNoConfirm: 'Open request was sent. Many devices do not confirm to the browser (CORS). If the locker did not open, use REST by server or check the device.',
    utilitiesDetailLoading: 'Loading...',
    utilitiesDetailEmpty: 'Select a utility to view details.',
    utilitiesSetDropdownListSearchPlaceholder: 'Filter sets…',
    utilitiesSetDropdownNoResults: 'No matching sets.',
    utilitiesTypeLabel: 'Type',
    utilitiesTypePlaceholder: 'Select type',
    utilitiesSetLabel: 'Set',
    utilitiesSetPlaceholder: 'Select set',
    utilitiesSetNoOptions: 'No sets. Create one first.',
    utilitiesNumberLabel: 'Number',
    utilitiesNumberPlaceholder: 'e.g. 101',
    utilitiesStatusLabel: 'Status',
    utilitiesStatusPlaceholder: 'Select status',
    utilitiesStatusActive: 'Active',
    utilitiesStatusInactive: 'Inactive',
    utilitiesStatusOutOfService: 'Out of service',
    utilitiesActiveLabel: 'Active',
    utilitiesNoSet: '—',
    utilitiesCancel: 'Cancel',
    utilitiesSave: 'Save',
    utilitiesSaving: 'Saving...',
    utilitiesSetCreateButton: 'Add set',
    utilitiesSetsListLabel: 'Sets',
    utilitiesSetsEmpty: 'No sets yet.',
    utilitiesSetsFilterAll: 'All',
    utilitiesSetsFilterNoSet: 'No set',
    utilitiesSetEditButton: 'Edit',
    utilitiesSetDeleteButton: 'Delete',
    utilitiesTypeLocker: 'Locker',
    utilitiesSetCreateTitle: 'Add utility set',
    utilitiesSetCreateSuccess: 'Utility set added.',
    utilitiesSetCreateFailed: 'Unable to add utility set.',
    utilitiesSetEditTitle: 'Edit set',
    utilitiesSetUpdateSuccess: 'Set updated.',
    utilitiesSetUpdateFailed: 'Unable to update set.',
    utilitiesSetDeleteConfirm: 'Delete this set? All utilities in it will be permanently removed.',
    utilitiesSetDeleteSuccess: 'Set deleted.',
    utilitiesSetDeleteFailed: 'Unable to delete set.',
    utilitiesSetCreating: 'Adding...',
    utilitiesSetNameLabel: 'Name',
    utilitiesSetNamePlaceholder: 'e.g. Main lockers',
    utilitiesSetsLoadFailed: 'Unable to load utility sets.',
    utilitiesAddWizardTitle: 'Add utilities',
    utilitiesAddWizardStep1Title: 'Step 1 of 2: Utility set',
    utilitiesAddWizardStep1CreateSet: 'Create a new set',
    utilitiesAddWizardStep1ExistingSet: 'Add to an existing set',
    utilitiesAddWizardStep1Skip: 'Skip this step',
    utilitiesAddWizardStep2Title: 'Step 2 of 2: Add utilities',
    utilitiesAddWizardStep2SingleOnly:
      'Without a set you can only add a single utility (no bulk range).',
    utilitiesAddWizardNext: 'Next',
    utilitiesAddWizardBack: 'Back',
    integrationsOpenPageHint: 'Open integrations page',
    integrationsTitle: 'Integrations',
    integrationsSubtitle: 'Manage hardware integrations for utility sets and single utilities.',
    integrationsListLabel: 'Integrations',
    integrationsTotal: 'Total',
    integrationsListLoading: 'Loading integrations...',
    integrationsListEmpty: 'No integrations found.',
    integrationsListLoadFailed: 'Unable to load integrations.',
    integrationsAddButton: 'Add integration',
    integrationsCreateTitle: 'Add integration',
    integrationsEditTitle: 'Edit integration',
    integrationsCreateSuccess: 'Integration added.',
    integrationsCreateFailed: 'Unable to add integration.',
    integrationsUpdateSuccess: 'Integration updated.',
    integrationsUpdateFailed: 'Unable to update integration.',
    integrationsDeleteSuccess: 'Integration deleted.',
    integrationsDeleteFailed: 'Unable to delete integration.',
    integrationsEditButton: 'Edit',
    integrationsDeleteButton: 'Delete',
    integrationsSaving: 'Saving...',
    integrationsSave: 'Save',
    integrationsTargetLabel: 'Target',
    integrationsTargetTypeLabel: 'Target type',
    integrationsTargetSet: 'Utility set',
    integrationsTargetUtility: 'Single utility',
    integrationsUtilitySetLabel: 'Utility set',
    integrationsUtilitySetPlaceholder: 'Select set',
    integrationsUtilityLabel: 'Utility',
    integrationsUtilityPlaceholder: 'Select utility',
    integrationsUtilitySearchPlaceholder: 'Search by set or number...',
    integrationsProtocolTypeLabel: 'Protocol',
    integrationsProtocolRest: 'REST',
    integrationsProtocolRestByServer: 'REST by server',
    integrationsProtocolRestByDevice: 'REST by device',
    integrationsProtocolWebSocket: 'WebSocket (on-prem driver)',
    integrationsWebSocketDriverTitle: 'On-prem driver',
    integrationsSelectDriverLabel: 'Driver',
    integrationsSelectDriverPlaceholder: 'Select a driver',
    integrationsDriverLabel: 'Driver',
    integrationsDriversLoading: 'Loading drivers...',
    integrationsDriversLoadFailed: 'Unable to load drivers.',
    integrationsDriversEmptyHelp:
      'No drivers registered yet. Pair a driver with a setup code first, then select it here.',
    integrationsDriverStatusOnline: 'online',
    integrationsDriverStatusOffline: 'offline',
    integrationsDriverStatusUnhealthy: 'unhealthy',
    integrationsDriverStatusDisabled: 'disabled',
    integrationsDriverStatusPending: 'pending',
    integrationsDriverStatusDeleted: 'deleted',
    integrationsCommandOptionsLabel: 'Command options',
    integrationsCommandTimeoutLabel: 'Command timeout',
    integrationsCommandTimeoutHelp: 'Seconds to wait for the driver to respond (1–120).',
    integrationsTypeLabel: 'Integration type',
    integrationsTypeLockerRest: 'Locker REST',
    integrationsNameLabel: 'Name',
    integrationsNamePlaceholder: 'Optional label',
    integrationsLockerConfigTitle: 'Locker configuration',
    integrationsProtocolLabel: 'Protocol',
    integrationsBaseUrlLabel: 'Base URL',
    integrationsBaseUrlPlaceholder: 'https://locker-api.example.com',
    integrationsUrlPatternOpen: 'URL pattern (open)',
    integrationsUrlPatternPing: 'URL pattern (ping)',
    integrationsRangeMinLabel: 'Locker number range (min)',
    integrationsRangeMaxLabel: 'Locker number range (max)',
    integrationsEnabledActionsLabel: 'Enabled actions',
    integrationsEnabledActions: 'Enabled',
    integrationsActionOpen: 'Open',
    integrationsActionPing: 'Ping',
    integrationsDetailLoading: 'Loading...',
    integrationsDetailEmpty: 'Select an integration to view details.',
    integrationsAddWizardTitle: 'Add integration',
    integrationsAddWizardStep1Title: 'Step 1 of 2: Target & details',
    integrationsAddWizardStep2Title: 'Step 2 of 2: Configuration',
    integrationsConnectionTypeLabel: 'Connection type',
    integrationsWizardNext: 'Next',
    integrationsWizardBack: 'Back',
    integrationsDriverNameFallback: 'Unknown driver (ID {id})',
    integrationsNoDriver: 'No driver (deleted or unassigned). Use Edit to link a driver.',
    driversTitle: 'Drivers',
    driversSubtitle: 'Register on-prem drivers with setup codes, review health, and rotate API keys.',
    driversListLabel: 'Drivers',
    driversTotal: 'Total',
    driversListLoading: 'Loading drivers...',
    driversListEmpty: 'No drivers registered yet.',
    driversIntegrationsCount: 'Integrations',
    driversDetailLoading: 'Loading driver details...',
    driversDetailEmpty: 'Select a driver to view details.',
    driversDetailLoadFailed: 'Unable to load driver details.',
    driversGenerateSetupCode: 'Generate setup code',
    driversSetupModalTitle: 'Generate driver setup code',
    driversSetupNameLabel: 'Label (optional)',
    driversSetupNamePlaceholder: 'e.g. Store front desk',
    driversSetupExpiresLabel: 'Expires in (hours, 1–168)',
    driversSetupSubmit: 'Generate',
    driversSetupSubmitting: 'Generating...',
    driversSetupCodeFailed: 'Unable to create setup code.',
    driversSetupResultTitle: 'Setup code ready',
    driversSetupResultHint: 'Copy this code and enter it in the driver. It expires at the time shown below.',
    driversSetupCodeLabel: 'Setup code',
    driversSetupExpiresAt: 'Expires',
    driversCopyButton: 'Copy',
    driversCopySuccess: 'Copied to clipboard.',
    driversCopyFailed: 'Unable to copy.',
    driversDone: 'Done',
    driversRotateKeyButton: 'Rotate API key',
    driversRotating: 'Rotating...',
    driversRotateKeyFailed: 'Unable to rotate API key.',
    driversRotateConfirmTitle: 'Rotate API key?',
    driversRotateConfirmBody:
      'The current key stops working immediately. You must update the driver with the new key before it can connect.',
    driversRotateConfirmButton: 'Rotate key',
    driversRotateResultTitle: 'New API key',
    driversNewApiKeyLabel: 'API key',
    driversDisableButton: 'Disable driver',
    driversDisabling: 'Disabling...',
    driversDisableSuccess: 'Driver disabled.',
    driversDisableFailed: 'Unable to disable driver.',
    driversDisableConfirmTitle: 'Disable this driver?',
    driversDisableConfirmBody:
      'The driver will be disconnected. You can re-enable it from this screen while it remains in the list. Integrations linked to it may stop working.',
    driversDisableConfirmButton: 'Disable driver',
    driversPendingDetailHint:
      'This setup code is waiting for a driver to register. Enter the code in the driver before it expires.',
    driversPendingExpiredWarning: 'This setup code has expired and can no longer be used.',
    driversPendingCreatedLabel: 'Created',
    driversDeleteButton: 'Delete driver',
    driversDeleting: 'Deleting...',
    driversDeleteSuccess: 'Driver removed from the list.',
    driversDeleteFailed: 'Unable to delete driver.',
    driversDeleteConfirmTitle: 'Delete this driver?',
    driversDeleteConfirmBody:
      'The driver is removed from the list and cannot connect again. This is separate from disabling.',
    driversDeleteConfirmButton: 'Delete driver',
    driversPendingDeleteConfirmTitle: 'Remove this setup code?',
    driversPendingDeleteConfirmBody:
      'The code will be deleted and cannot be used to register a driver. You can generate a new setup code anytime.',
    driversPendingDeleteSuccess: 'Setup code removed.',
    driversPendingDeleteFailed: 'Unable to remove setup code.',
    driversEnableButton: 'Enable driver',
    driversEnabling: 'Enabling...',
    driversEnableSuccess: 'Driver enabled. It will show as offline until it connects.',
    driversEnableFailed: 'Unable to enable driver.',
    driversStatusLabel: 'Connection status',
    driversHealthyLabel: 'Healthy',
    driversYes: 'Yes',
    driversNo: 'No',
    driversHealthOverallLabel: 'Overall health',
    driversHealthOverallOk: 'OK',
    driversHealthOverallOffline: 'Offline',
    driversHealthOverallDegraded: 'Degraded',
    driversHealthOverallDisabled: 'Disabled',
    driversHeartbeatFreshLabel: 'Recent heartbeat',
    driversHeartbeatAgeLabel: 'Heartbeat age',
    driversHealthReasonLabel: 'Health reason',
    driversIntegrationsCountLabel: 'Linked integrations',
    driversApiKeyPrefixLabel: 'API key prefix',
    driversServerUrlLabel: 'Server URL',
    driversDriverVersionLabel: 'Driver version',
    driversRegisteredAtLabel: 'Registered',
    driversLastHeartbeatLabel: 'Last heartbeat',
    driversSetupCodeUsedLabel: 'Setup code used',
    driversLastHealthReportLabel: 'Last health report',
    driversDownloadButton: 'Download driver',
    driversDownloadModalTitle: 'Download driver',
    driversDownloadOptionsLoading: 'Loading download options...',
    driversDownloadOptionsEmpty: 'No driver downloads are available right now.',
    driversDownloadOptionsFailed: 'Unable to load driver download options.',
    driversDownloadFailed: 'Unable to start driver download.',
    driversDownloadVersionLabel: 'Version',
    driversFleetWarningHardTitle: 'Driver version no longer supported',
    driversFleetWarningHardMessage:
      '{count} driver(s) are below the minimum supported version ({minSupported}). Update them as soon as possible.',
    driversFleetWarningSoftTitle: 'Driver update available',
    driversFleetWarningSoftMessage:
      '{count} driver(s) can be updated to version {latest}.',
    driversFleetWarningDashboardAdminAction: 'Manage drivers',
    driversFleetWarningDashboardStaffHint:
      'Ask an administrator to update the on-site integration drivers.',
    driversFleetWarningDriversStaffHint:
      'Ask an administrator to download and install the latest driver version.',
    driversFleetWarningDriversAdminHint:
      'Use the Download driver button above to get the latest installer.',
    pricingPlansTitle: 'Walk-in pricing plans',
    pricingPlansSubtitle: 'Review walk-in pricing plans and their steps.',
    pricingPlansReadOnly: 'Managers can view plans but cannot edit them.',
    pricingPlanChipViewOnly: 'View only',
    pricingPlanChipNoActiveDefault: 'No active default',
    pricingPlansListLabel: 'Plans',
    pricingPlansTotal: 'Total',
    pricingPlansLoading: 'Loading pricing plans...',
    pricingPlansEmpty: 'No pricing plans found.',
    pricingPlansLoadFailed: 'Unable to load pricing plans.',
    pricingPlanCreateButton: 'Create plan',
    pricingPlanCreateTitle: 'Create walk-in plan',
    pricingPlanCreateCancel: 'Cancel',
    pricingPlanCreateConfirm: 'Create plan',
    pricingPlanCreateSubmitting: 'Creating...',
    pricingPlanCreateSuccess: 'Pricing plan created.',
    pricingPlanCreateFailed: 'Unable to create pricing plan.',
    pricingPlanDefaultInactiveWarning:
      'Automatic pricing will not work until a default plan is active.',
    pricingPlanActiveConflict: 'Only one default pricing plan can be active at a time.',
    pricingPlanActiveDefaultConflictTitle: 'Active default plan already exists',
    pricingPlanActiveDefaultConflictBody:
      'An active default plan is already in use ("{title}"). You can replace it with this plan or save this plan as inactive.',
    pricingPlanActiveDefaultConflictReplace: 'Replace active default',
    pricingPlanActiveDefaultConflictSaveInactive: 'Save as inactive',
    pricingPlanActiveDefaultConflictCancel: 'Back to editor',
    pricingPlanCheckOverlap: 'Check overlap',
    pricingPlanCheckOverlapChecking: 'Checking...',
    pricingPlanOverlapCheckClear: 'No overlap detected.',
    pricingPlanOverlapCheckConflict: 'This plan overlaps with existing plans.',
    pricingPlanOverlapCheckConflictWith: 'Overlaps with: {titles}.',
    pricingPlanOverlapCheckFailed: 'Unable to check overlap.',
    pricingPlanEditButton: 'Edit plan',
    pricingPlanCloneButton: 'Clone plan',
    pricingPlanCloneTitle: 'Clone walk-in plan',
    pricingPlanCloneTitleSuffix: '(copy)',
    pricingPlanBranchScopeLabel: 'Branch scope',
    pricingPlanScopeTenantWide: 'All branches',
    pricingPlanScopeBranchOnly: '{branch} only',
    pricingPlanScopeBranch: 'This branch',
    pricingPlanBranchScopedHint: 'This plan applies only to {branch}.',
    pricingPlanTenantWideHint: 'This plan applies to every branch.',
    pricingPlanDeleteButton: 'Delete plan',
    pricingPlanEditTitle: 'Edit walk-in plan',
    pricingPlanEditCancel: 'Cancel',
    pricingPlanEditConfirm: 'Save changes',
    pricingPlanEditSubmitting: 'Saving...',
    pricingPlanUpdateSuccess: 'Pricing plan updated.',
    pricingPlanUpdateFailed: 'Unable to update pricing plan.',
    pricingPlanDeleteTitle: 'Delete plan',
    pricingPlanDeletePrompt: 'Are you sure you want to delete this plan?',
    pricingPlanDeleteConfirm: 'Delete plan',
    pricingPlanDeleteCancel: 'Cancel',
    pricingPlanDeleteSubmitting: 'Deleting...',
    pricingPlanDeleteSuccess: 'Pricing plan deleted.',
    pricingPlanDeleteFailed: 'Unable to delete pricing plan.',
    pricingPlanDeleteDefaultActive: 'Active default plans cannot be deleted.',
    pricingPlanDefaultRequired: 'Create a default plan before adding other plans.',
    pricingPlanDefaultInvalid: 'Default plans must cover all dates and times.',
    pricingPlanOverlap: 'This plan overlaps an existing plan.',
    pricingPlanDetailLoading: 'Loading plan details...',
    pricingPlanDetailEmpty: 'Select a plan to view details.',
    pricingPlanDetailFailed: 'Unable to load plan details.',
    pricingPlanActive: 'Active',
    pricingPlanInactive: 'Inactive',
    pricingPlanDefault: 'Default',
    pricingPlanTierBasisLabel: 'Tier basis',
    pricingPlanTierBasisHint: 'Defines what each tier represents.',
    pricingTierBasisLegendPartySize:
      'Each column is a party-size band; the last column is the open-ended tier (e.g. 4+).',
    pricingTierBasisLegendGeneric: 'Each column is one pricing tier.',
    pricingDetailStepPrefix: 'Step',
    pricingDetailDurationFirst: 'first',
    pricingDetailDurationNext: 'next',
    pricingPlanTitleLabel: 'Plan title',
    pricingPlanTitlePlaceholder: 'e.g., Weekend walk-in',
    pricingPlanActiveLabel: 'Active plan',
    pricingPlanDefaultLabel: 'Default plan',
    pricingPlanAllDayLabel: 'All day',
    pricingPlanValidFromLabel: 'Valid from',
    pricingPlanValidToLabel: 'Valid to',
    pricingPlanStartTimeLabel: 'Start time',
    pricingPlanEndTimeLabel: 'End time',
    pricingPlanDateRangeLabel: 'Date range',
    pricingPlanDateRangeAny: 'Any date',
    pricingPlanDateOpen: 'Open',
    pricingPlanWeekdaysLabel: 'Weekdays',
    pricingPlanTimeLabel: 'Time',
    pricingPlanAllDay: 'All day',
    pricingPlanTimeUnset: 'Not set',
    pricingPlanValidationTitle: 'Enter a plan title.',
    pricingPlanValidationWeekdays: 'Select at least one weekday.',
    pricingPlanValidationDates: 'End date cannot be before start date.',
    pricingPlanValidationValidFromToday: 'Start date cannot be before today.',
    pricingPlanValidationTimes: 'Start and end time are required.',
    pricingPlanValidationTimesOrder: 'Start time must be before end time.',
    pricingPlanValidationStepsRequired: 'Add at least one time block.',
    pricingPlanValidationStepsLimit: 'A maximum of {limit} time blocks is allowed.',
    pricingPlanValidationSteps: 'Fill out all time block fields.',
    pricingPlanValidationTierBasis: 'Select a tier basis.',
    pricingPlanStepsTitle: 'Time blocks',
    pricingPlanStepsEmpty: 'No time blocks defined.',
    pricingPlanStepAdd: 'Add time block',
    pricingPlanStepRemove: 'Remove',
    pricingPlanStepActions: 'Actions',
    pricingPlanFinalStep: 'Remaining time (per hour)',
    pricingCurrencyRial: 'Rial',
    pricingStepOrder: 'Block',
    pricingStepDuration: 'Duration',
    pricingStepTimeUnit: 'Time unit',
    pricingTierLabel: 'Tier',
    pricingTierPartyWordSingular: 'Person',
    pricingTierPartyWordPlural: 'Persons',
    pricingTierBasisPartySize: 'Party size',
    pricingTierBasisUtilities: 'Utilities count',
    pricingTierBasisUnknown: 'Unknown',
    pricingStepRate1: '1 kid',
    pricingStepRate2: '2 kids',
    pricingStepRate3: '3+ kids',
    pricingStepMinutes: 'min',
    pricingStepUnitHours: 'Hours',
    pricingStepUnitMinutes: 'Minutes',
    pricingStepBlockCost: 'Cost of this block',
    pricingPerMinuteUnit: 'min',
    pricingPreviewTitle: 'Cost preview',
    pricingPreviewNote: 'Estimated cost for one person, based on the tiers above.',
    pricingBillingUnit_PER_MINUTE: 'Per minute',
    pricingBillingUnit_PER_HOUR: 'Per hour',
    pricingWeekdayMon: 'Mon',
    pricingWeekdayTue: 'Tue',
    pricingWeekdayWed: 'Wed',
    pricingWeekdayThu: 'Thu',
    pricingWeekdayFri: 'Fri',
    pricingWeekdaySat: 'Sat',
    pricingWeekdaySun: 'Sun',
    pricingWeekdaysNone: 'No weekdays',
    pricingPlanTierBasisImmutable: 'Tier basis cannot be changed once set.',
    pricingPlanTierBasisInvalid: 'Invalid tier basis.',
    pricingWizardStageGeneralTitle: 'Plan details',
    pricingWizardStageTiersTitle: 'Time blocks & tier rates',
    pricingWizardStepLabel: 'Time block',
    pricingWizardStepOf: 'of',
    pricingWizardLastStepBadge: 'Remaining time',
    pricingWizardNext: 'Continue',
    pricingWizardBack: 'Back',
    pricingWizardProgressAria: 'Wizard progress',
    pricingWizardFinalStepPerHourExplain:
      'After the blocks above, the remaining time is billed per hour. Enter the per-hour rates below.',
    pricingWizardNonFinalDurationExplain:
      'How long this block lasts. Customers pay pro-rata for the time they use: a 1-hour block at 120,000 bills 60,000 for 30 minutes. Everything after the blocks above is billed per hour.',
    pricingTierBasisLockedHint: 'Tier basis is fixed to party size for now.',
    discountsTitle: 'Discounts',
    discountsSubtitle: 'Review discount rules and eligibility.',
    discountsListLabel: 'Discounts',
    discountsTotal: 'Total',
    discountsLoading: 'Loading discounts...',
    discountsEmpty: 'No discounts found.',
    discountsLoadFailed: 'Unable to load discounts.',
    discountDetailTitle: 'Discount details',
    discountDetailEmpty: 'Select a discount to view details.',
    discountDetailLoading: 'Loading discount details...',
    discountDetailFailed: 'Unable to load discount details.',
    discountCodeLabel: 'Code',
    discountTypeLabel: 'Type',
    discountScopeLabel: 'Scope',
    discountAmountLabel: 'Price/Percent',
    discountStatusLabel: 'Status',
    discountActive: 'Active',
    discountInactive: 'Inactive',
    discountScopeGeneral: 'General',
    discountScopeCustomer: 'Customer-specific',
    discountTypePercent: 'Percent',
    discountTypeFixed: 'Fixed',
    discountCustomerLabel: 'Customer',
    discountCustomerAll: 'All customers',
    discountDateRangeLabel: 'Date range',
    discountDateOpen: 'Open',
    discountWeekdaysLabel: 'Weekdays',
    discountWeekdaysAll: 'All days',
    discountWeekdaysNone: 'No days',
    discountTimeLabel: 'Time window',
    discountTimeAllDay: 'All day',
    discountTimeUnset: 'Time not set',
    discountMinBasePriceLabel: 'Minimum base price',
    discountMinBasePriceNone: 'No minimum',
    discountUsageLimitLabel: 'Usage limit',
    discountUsageLimitPlaceholder: 'Total uses',
    discountUsageLimitNone: 'No limit',
    discountCodePlaceholder: 'Enter discount code',
    discountAmountPlaceholder: 'Enter amount',
    discountTypePlaceholder: 'Select type',
    discountScopePlaceholder: 'Select scope',
    discountCustomerSearchPlaceholder: 'Search customer by phone',
    discountCustomerNoResults: 'No customers found',
    discountCustomerLoading: 'Loading customers...',

    giftCardsTitle: 'Gift cards',
    giftCardsSubtitle: 'Manage gift card types and issued cards.',
    giftCardsTabInstances: 'Instances',
    giftCardsTabTypes: 'Types',
    giftCardsTabs: 'Gift card sections',
    giftCardsCreateType: 'Create type',
    giftCardsCreateInstance: 'Add instance',
    giftCardsInstancesListLabel: 'Gift cards',
    giftCardsTypesListLabel: 'Types',
    giftCardsTotal: 'Total',
    giftCardsInstancesEmpty: 'No gift cards found.',
    giftCardsTypesEmpty: 'No types found.',
    giftCardsInstancesLoading: 'Loading gift cards...',
    giftCardsTypesLoading: 'Loading types...',
    giftCardsInstancesLoadFailed: 'Unable to load gift cards.',
    giftCardsTypesLoadFailed: 'Unable to load types.',
    giftCardsDetailEmpty: 'Select a gift card to view details.',
    giftCardsTypeDetailEmpty: 'Select a type to view details.',
    giftCardsInstanceDetailTitle: 'Gift card details',
    giftCardsTypeDetailTitle: 'Type details',
    giftCardsDetailLoading: 'Loading gift card details...',
    giftCardsDetailLoadFailed: 'Unable to load gift card details.',
    giftCardsCodeLabel: 'Code',
    giftCardsTypeLabel: 'Type',
    giftCardsBalanceLabel: 'Balance',
    giftCardsCustomerLabel: 'Customer',
    giftCardsOpenCard: 'Open (unmapped)',
    giftCardsStatusLabel: 'Status',
    giftCardsExpiresLabel: 'Expires',
    giftCardsPurchaseAmountLabel: 'Purchase amount',
    giftCardsBatchLabel: 'Batch',
    giftCardsBatchPaid: 'Paid in system',
    giftCardsBatchUnpaid: 'Not ledgered',
    giftCardsUsageHistory: 'View usage history',
    giftCardsTitleLabel: 'Title',
    giftCardsAmountLabel: 'Amount',
    giftCardsAmountHoursLabel: 'Hours',
    giftCardsSalePriceLabel: 'Sale price',
    giftCardsExpiryDaysLabel: 'Expiry (days)',
    giftCardsDescriptionLabel: 'Description',
    giftCardsNoExpiry: 'No expiry',
    giftCardsNotSet: 'Not set',
    giftCardsActive: 'Active',
    giftCardsInactive: 'Inactive',
    giftCardsHoursUnit: 'hours',
    giftCardsMinutesShort: 'min',
    giftCardsSelectType: 'Select type',
    giftCardsCodeAutoHint: 'Leave blank to auto-generate',
    giftCardsIssueMode: 'Issue mode',
    giftCardsIssueSingle: 'Single card',
    giftCardsIssueBatch: 'Batch issue',
    giftCardsBatchCodesLabel: 'Codes (one per line)',
    giftCardsBatchCodesHint: 'Paste codes or leave empty to auto-generate',
    giftCardsBatchQuantityLabel: 'Quantity to generate',
    giftCardsBatchIsPaid: 'Batch is paid (ledger in system)',
    giftCardsBatchPaymentAmount: 'Total payment amount',
    giftCardsUsageTitle: 'Gift card usage',
    giftCardsUsageEmpty: 'No usage recorded yet.',
    giftCardsBalanceAfterPrefix: 'Balance after:',
    giftCardsFeatureLocked: 'Gift cards are not available on your plan.',
    navGiftCards: 'Gift cards',
    giftCardsPurchaseButton: 'Purchase gift card',
    giftCardsPurchaseTitle: 'Purchase gift card',
    giftCardsPurchaseSubmit: 'Purchase',
    giftCardsPurchaseSuccess: 'Gift card purchased.',
    giftCardsPurchaseFailed: 'Unable to purchase gift card.',
    giftCardsPaymentMethodGiftCard: 'Gift card',
    giftCardsPaymentMethodMoney: 'Cash / other',
    giftCardsSelectMappedCard: 'Select customer gift card',
    giftCardsRemaining: 'remaining',
    giftCardsEnterCode: 'Enter gift card code',
    giftCardsRedeemAction: 'Pay with gift card',
    giftCardsRedeemSubmitting: 'Redeeming...',
    giftCardsRedeemSuccess: 'Gift card applied.',
    giftCardsRedeemFailed: 'Unable to redeem gift card.',
    giftCardsRedeemTransactionMissing: 'No open transaction for this visit.',
    giftCardsRedeemTransactionClosed: 'This transaction is already closed.',
    giftCardsRedeemVisitNotReady: 'Visit is not ready for gift card payment.',
    giftCardsRedeemChildrenActive: 'Exit all children before paying with a gift card.',
    giftCardsRedeemAlreadySettled: 'This visit was already paid with a gift card.',
    giftCardsRedeemCustomerMismatch: 'This gift card belongs to another customer.',
    giftCardsRedeemReferenceRequired: 'Select a gift card or enter a code.',
    giftCardsRedeemInsufficientBalance: 'Gift card balance is not enough for this visit.',
    giftCardsRedeemNotFound: 'Gift card not found.',
    giftCardsRedeemCodeRequired: 'Enter a gift card code.',
    giftCardsRedeemInactive: 'This gift card is inactive.',
    giftCardsRedeemFullyRedeemed: 'This gift card has no balance left.',
    giftCardsRedeemExpired: 'This gift card has expired.',
    giftCardsRedeemCustomerNotFound: 'Customer not found.',
    giftCardsRedeemTransferForbidden: 'This gift card is already assigned to another customer.',
    giftCardsRedeemVisitNotStarted: 'Visit play time has not started yet.',
    giftCardsRedeemNoChildren: 'Visit has no children to bill.',
    giftCardsRedeemInvalidRequest: 'Invalid gift card payment request.',
    giftCardsRedeemIdempotencyConflict: 'Please try again.',
    giftCardsPurchaseCustomerNotFound: 'Selected customer was not found.',
    giftCardsPurchaseSalePriceMismatch: 'Sale price does not match the card type.',
    giftCardsPurchaseInvalidAmount: 'Purchase amount is invalid.',
    giftCardsPurchaseTypeInactive: 'Selected gift card type is inactive.',
    giftCardsPurchaseTypeNotFound: 'Gift card type not found.',
    giftCardsPurchaseCodeExists: 'This gift card code already exists.',
    giftCardsPurchaseInvalidRequest: 'Invalid gift card purchase request.',
    giftCardsDeductionPreview: 'Will deduct from card (party size × duration)',
    giftCardsNoMappedCards: 'No mapped cards for this customer.',
    discountCreateButton: 'Create discount',
    discountCreateTitle: 'Create discount',
    discountCreateCancel: 'Cancel',
    discountCreateConfirm: 'Create',
    discountCreateSubmitting: 'Creating...',
    discountCreateSuccess: 'Discount created.',
    discountCreateFailed: 'Unable to create discount.',
    discountCreateCodeExists: 'Discount code already exists.',
    discountCreateCustomerRequired: 'Select a customer for this discount.',
    discountCreateCustomerForbidden: 'Customer is not allowed for general discounts.',
    discountCreateCustomerNotFound: 'Selected customer was not found.',
    discountCreateInvalidAmount: 'Enter a valid discount amount.',
    discountCreateInvalidCode: 'Enter a discount code.',
    discountCreateInvalidDateRange: 'Invalid discount date range.',
    discountCreateInvalidTimeRange: 'Invalid discount time range.',
    discountCreateInvalidWeekdays: 'Select at least one weekday.',
    discountCreateInvalidMinBasePrice: 'Minimum base price must be greater than zero.',
    discountCreateMinBasePriceFixedOnly: 'Minimum base price is only available for fixed discounts.',
    discountCreateInvalidType: 'Select a discount type.',
    discountCreateInvalidScope: 'Select a discount scope.',
    discountCreateUsageLimitRequired: 'Usage limit is required for general discounts.',
    discountActivate: 'Activate',
    discountDeactivate: 'Deactivate',
    discountStatusActivated: 'Discount activated.',
    discountStatusDeactivated: 'Discount deactivated.',
    discountStatusFailed: 'Unable to update discount status.',
    discountStatusNotFound: 'Discount not found.',
    discountValidationCode: 'Enter a discount code.',
    discountValidationType: 'Select a discount type.',
    discountValidationAmount: 'Enter a valid amount.',
    discountValidationScope: 'Select a discount scope.',
    discountValidationCustomer: 'Select a customer.',
    discountValidationUsageLimit: 'Enter a usage limit for general discounts.',
    discountGeneratorTitle: 'Generate discount code',
    discountGeneratorAction: 'Generate',
    discountGeneratorLoading: 'Generating...',
    discountGeneratorNumbers: 'Include numbers',
    discountGeneratorLowercase: 'Include lowercase',
    discountGeneratorUppercase: 'Include uppercase',
    discountGeneratorPrefix: 'Prefix',
    discountGeneratorPrefixPlaceholder: 'Optional prefix',
    discountGeneratorLengthLabel: 'Code length',
    discountGeneratorLengthPlaceholder: '4-7',
    discountGeneratorMissingCharset: 'Select at least one character set.',
    discountGeneratorInvalid: 'Select at least one character set.',
    discountGeneratorLengthInvalid: 'Invalid code length.',
    discountGeneratorFailed: 'Unable to generate code.',
    discountCollapseShow: 'Show',
    discountCollapseHide: 'Hide',
    discountRulesTitle: 'Eligibility rules',
    discountValidFromLabel: 'Valid from',
    discountValidToLabel: 'Valid to',
    discountAllDayLabel: 'All day',
    discountStartTimeLabel: 'Start time',
    discountEndTimeLabel: 'End time',
    discountMinBasePricePlaceholder: 'Base price',
    discountOpenEndedWarning: 'Open-ended discounts are discouraged. Consider setting an end date.',
    paymentTypesTitle: 'Payment types',
    paymentTypesSubtitle: 'Configure payment methods available at checkout.',
    paymentTypesListLabel: 'Payment types',
    paymentTypesTotalLabel: 'Total',
    paymentTypesEmpty: 'No payment types configured.',
    paymentTypesLoading: 'Loading payment types...',
    paymentTypesLoadFailed: 'Unable to load payment types.',
    paymentTypeCreate: 'Create payment type',
    paymentTypeCreateTitle: 'Create payment type',
    paymentTypeEditTitle: 'Edit payment type',
    paymentTypeEdit: 'Edit',
    paymentTypeSave: 'Save',
    paymentTypeSaving: 'Saving...',
    paymentTypeCancel: 'Cancel',
    paymentTypeNameLabel: 'Name',
    paymentTypeNamePlaceholder: 'e.g., Cash desk',
    paymentTypeCategoryLabel: 'Category',
    paymentTypeCategoryPlaceholder: 'Select category',
    paymentTypeActiveLabel: 'Active',
    paymentTypeActive: 'Active',
    paymentTypeInactive: 'Inactive',
    paymentTypeCategoryCash: 'Cash',
    paymentTypeCategoryPos: 'POS',
    paymentTypeCategoryOnline: 'Online transfer',
    paymentTypeCategory_CASH: 'Cash',
    paymentTypeCategory_POS: 'POS',
    paymentTypeCategory_ONLINE_TRANSFER: 'Online transfer',
    paymentTypeFinancialAccountLabel: 'Financial account',
    paymentTypeFinancialAccountPlaceholder: 'Select account (optional)',
    paymentTypeFinancialAccountNone: 'No account',
    paymentTypeFinancialAccountShort: 'Account',
    paymentTypeFinancialAccountNote: 'Only active accounts can be assigned.',
    paymentTypeFinancialAccountLoadFailed: 'Unable to load financial accounts.',
    paymentTypeFinancialAccountNotFound: 'Financial account not found.',
    paymentTypeFinancialAccountInactive: 'Inactive financial account cannot be assigned.',
    paymentTypeFinancialAccountRequiredForActive: 'Active payment type requires a financial account.',
    paymentTypeCreateSubmitting: 'Creating...',
    paymentTypeCreateSuccess: 'Payment type created.',
    paymentTypeCreateFailed: 'Unable to create payment type.',
    paymentTypeUpdateSubmitting: 'Updating...',
    paymentTypeUpdateSuccess: 'Payment type updated.',
    paymentTypeUpdateFailed: 'Unable to update payment type.',
    paymentTypeNameExists: 'Payment type name already exists.',
    paymentTypeInvalidCategory: 'Select a valid category.',
    dailySalesSummaryTitle: 'Daily sales summary',
    dailySalesSummarySubtitle: 'Z-report style summary with required date range filters.',
    dailySalesSummaryStartDate: 'Start date',
    dailySalesSummaryEndDate: 'End date',
    dailySalesSummaryStaffLabel: 'Staff',
    dailySalesSummaryStaffAll: 'All staff',
    dailySalesSummaryPaymentTypeLabel: 'Payment type',
    dailySalesSummaryPaymentTypeAll: 'All payment types',
    dailySalesSummaryApply: 'Apply filters',
    dailySalesSummaryClear: 'Clear',
    dailySalesSummaryRevenue: 'Revenue',
    dailySalesSummaryTransactionCount: 'Transaction count',
    dailySalesSummaryDiscountTotal: 'Total discounts',
    dailySalesSummaryByPaymentType: 'Breakdown by payment type',
    dailySalesSummaryByAccount: 'Breakdown by financial account',
    dailySalesSummaryAccountLabel: 'Financial account',
    dailySalesSummaryLoadFailed: 'Unable to load daily sales summary.',
    dailySalesSummaryInvalidFilter: 'Date range is required and must be valid.',
    dailySalesSummaryEmpty: 'No matching payments found for selected filters.',
    paymentTypesMissingWarning: 'No active payment types configured. Payments are disabled.',
    transactionPaymentAmountLabel: 'Payment amount',
    transactionPaymentAmountPlaceholder: 'Enter amount',
    transactionPaymentAction: 'Record payment',
    transactionPaymentSubmitting: 'Recording...',
    transactionPaymentSuccess: 'Payment recorded.',
    transactionPaymentFailed: 'Unable to record payment.',
    transactionPaymentInvalidAmount: 'Payment amount must be positive.',
    transactionPaymentInactive: 'Payment type is inactive.',
    transactionPaymentAccountMissing: 'Payment type has no linked financial account.',
    transactionPaymentAccountInactive: 'Linked financial account is inactive.',
    transactionPaymentTypeMissing: 'Payment type not found.',
    transactionPaymentClosed: 'Transaction is already closed.',
    transactionPaymentMissing: 'No transaction available to record payment.',
    transactionPaymentsTitle: 'Charges & payment status',
    transactionPaymentsLoading: 'Loading payments...',
    transactionPaymentsLoadFailed: 'Unable to load payments.',
    transactionPaymentsEmpty: 'No payments recorded yet.',
    transactionPaymentsList: 'Payments',
    transactionPaymentsListToggle: 'Payment records',
    transactionPaymentsTotal: 'Total charge',
    transactionPaymentsDiscount: 'Discount',
    transactionPaymentsPaid: 'Paid so far',
    transactionPaymentsCreditAfterExit: 'Credit after this visit',
    transactionPaymentsRemaining: 'Payable now',
    transactionPaymentsPayableHint: 'The customer should pay the payable amount to close the visit.',
    transactionPaymentsType: 'Payment type',
    transactionPaymentsAmount: 'Amount',
    transactionPaymentsDate: 'Date',
    transactionPaymentsCategory: 'Category',
    discountUsageTitle: 'Discount usage',
    discountUsageClose: 'Close',
    discountUsageButton: 'Usage report',
    discountUsageLoading: 'Loading usage...',
    discountUsageEmpty: 'No usage data available.',
    discountUsageLoadFailed: 'Unable to load discount usage.',
    discountUsageCodeLabel: 'Code',
    discountUsageCountLabel: 'Uses',
    discountUsageTotalLabel: 'Total discounted',
    entryDiscountCodeRequired: 'Enter a discount code.',
    entryDiscountEligible: 'Discount is eligible.',
    entryDiscountApplied: 'Discount applied.',
    entryDiscountAlreadyApplied: 'A discount is already applied to this visit.',
    entryDiscountInactive: 'Discount is inactive.',
    entryDiscountNotFound: 'Discount not found.',
    entryDiscountDateMismatch: 'Discount is not active on this date.',
    entryDiscountWeekdayMismatch: 'Discount is not active on this weekday.',
    entryDiscountTimeMismatch: 'Discount is not active at this time.',
    entryDiscountDurationRequired: 'Select expected duration to check this discount.',
    entryDiscountDurationTooShort: 'Expected duration does not meet the minimum.',
    entryDiscountBasePriceRequired: 'Base price is required to check this discount.',
    entryDiscountMinPriceUnmet: 'Minimum base price is not met for this discount.',
    entryDiscountCustomerRequired: 'Select a customer for this discount.',
    entryDiscountCustomerMismatch: 'Discount does not apply to this customer.',
    entryDiscountUsageLimitReached: 'Discount usage limit has been reached.',
    entryDiscountCheckFailed: 'Unable to check discount.',
    entryPaymentAmountLabel: 'Payment amount',
    entryPaymentAmountPlaceholder: 'Enter amount',
    entryPaymentTypeRequired: 'Select a payment type.',
    entryPaymentAmountRequired: 'Enter a valid payment amount.',
    priceCorrectionTitle: 'Adjust price',
    priceCorrectionBaselineLabel: 'Calculated total before adjustment',
    priceCorrectionAllowedRangeIntro: 'Allowed range:',
    priceCorrectionAdjustedLabel: 'Final amount',
    priceCorrectionReasonLabel: 'Reason (optional)',
    priceCorrectionApply: 'Apply',
    priceCorrectionCancel: 'Cancel',
    entryAdjustPriceButton: 'Adjust price',
    entryAutoRoundButton: 'Round down',
    entryAutoRoundRevertButton: 'Undo round',
    autoRoundSubmitFailed: 'Could not apply price rounding.',
    autoRoundNoChange:
      'Nothing changed. The amount is already a whole multiple of your “round-to” value, or that value is still 1. In settings, under round-down, set “Round down to a multiple of” to e.g. 5,000.',
    autoRoundWillApplyOnExit: 'Round-down is set and will apply when you complete exit.',
    autoRoundAppliedSuccess: 'Round-down applied.',
    autoRoundRevertedSuccess: 'Round-down reverted.',
    autoRoundPendingCleared: 'Pending round-down cleared.',
    systemSettingsAutoRoundSectionTitle: 'Round-down button (staff)',
    systemSettingsAutoRoundSectionSubtitle:
      'Staff can lower a line to the next “nice” total. Only setting below: the line is floored downward to a multiple of this amount (same unit as prices). Example: multiple 5,000 turns 610,166 into 610,000.',
    systemSettingsAutoRoundEnabled: 'Show the “Round down” / “Undo round” buttons where allowed',
    systemSettingsAutoRoundIncrementLabel: 'Round down to a multiple of (Rials)',
    systemSettingsAutoRoundIncrementHint:
      'The payable total moves down to the nearest multiple of this value. Example: 5,000 → 610,166 becomes 610,000. If this stays 1, whole-Rial amounts usually do not change; use 1,000 / 5,000 / 10,000 for cleaner totals.',
    systemSettingsAutoRoundIncrementError: 'Enter a valid multiple between 1 and 100000000.',
    systemSettingsAutoRoundMinRoleLabel: 'Minimum role allowed to use the round-down button',
    priceCorrectionInvalidAmount: 'Enter a valid amount.',
    priceCorrectionReasonRequired: 'Enter a reason for the adjustment.',
    priceCorrectionOutOfBounds: 'Amount is outside allowed bounds.',
    priceCorrectionAdminOverrideWarning:
      'This amount is outside the configured bounds. It may still be allowed for admins.',
    priceCorrectionSubmitFailed: 'Could not apply price correction.',
    priceCorrectionBlockedByAutoRound: 'Undo round-down before adjusting the price manually.',
    systemSettingsPriceCorrectionEnabled: 'Allow manual price correction before payment',
    systemSettingsPriceCorrectionBoundsLabel: 'Max deviation from calculated price (%)',
    systemSettingsPriceCorrectionBoundsHint:
      'Staff can set the final amount within this percentage above or below the calculated line total (0–100).',
    systemSettingsPriceCorrectionAdminOverride: 'Admins may exceed the deviation limit',
    systemSettingsPriceCorrectionMinRoleLabel: 'Minimum role to correct prices',
    systemSettingsPriceCorrectionSectionTitle: 'Price correction',
    systemSettingsPriceCorrectionSectionSubtitle:
      'Let staff change the final line amount before payment (entry and exit), within the limits below.',
    systemSettingsPriceCorrectionEnabledHint:
      'When enabled, eligible staff can open “Adjust price” on entry and checkout before a payment is recorded.',
    systemSettingsPriceCorrectionAdminOverrideHint:
      'If enabled, admins and superusers may still submit amounts outside the configured percentage range.',

    financialManagementTitle: 'Financial management',
    financialManagementSubtitle: 'Manage financial accounts and view account ledger summaries.',
    financialAccountCreateButton: 'New account',
    financialAccountCreate: 'Create account',
    financialAccountClose: 'Close',
    financialAccountReactivate: 'Reactivate',
    financialAccountClosed: 'Closed',
    financialAccountCreateSubmitting: 'Creating account...',
    financialAccountUpdateSubmitting: 'Updating account...',
    financialAccountCodeExists: 'Account code already exists.',
    financialAccountNameExists: 'Account name already exists.',
    financialAccountReactivateExpired: 'Closed accounts cannot be reactivated after 2 days.',
    financialAccountCreateTitle: 'Create financial account',
    financialAccountEditTitle: 'Edit financial account',
    financialAccountsListLabel: 'Financial accounts',
    financialAccountsTotal: 'Total:',
    financialAccountsLoading: 'Loading accounts...',
    financialAccountsEmpty: 'No financial accounts found.',
    financialAccountsLoadFailed: 'Failed to load financial accounts.',
    financialAccountDetailTitle: 'Account details',
    financialAccountDetailLoading: 'Loading account details...',
    financialAccountDetailEmpty: 'Select an account to view details.',
    financialAccountDetailLoadFailed: 'Failed to load account details.',
    financialAccountActive: 'Active',
    financialAccountInactive: 'Inactive',
    financialAccountEdit: 'Edit',
    financialAccountActivate: 'Activate',
    financialAccountDeactivate: 'Deactivate',
    financialAccountCodeLabel: 'Account code',
    financialAccountCodePlaceholder: 'e.g. ACC-CASH',
    financialAccountNameLabel: 'Account name',
    financialAccountNamePlaceholder: 'e.g. Cash Account',
    financialAccountStatusLabel: 'Status',
    financialAccountCreatedAtLabel: 'Created',
    financialAccountUpdatedAtLabel: 'Last updated',
    financialAccountActiveLabel: 'Active',
    financialAccountSave: 'Save',
    financialAccountSaving: 'Saving...',
    financialAccountCancel: 'Cancel',
    financialAccountCreateSuccess: 'Financial account created.',
    financialAccountCreateFailed: 'Failed to create financial account.',
    financialAccountUpdateSuccess: 'Financial account updated.',
    financialAccountUpdateFailed: 'Failed to update financial account.',
    ledgerSummaryTitle: 'Account ledger summary',
    ledgerSummarySubtitle: 'Inflow totals per financial account for a selected period.',
    ledgerSummaryStartDate: 'Start date',
    ledgerSummaryEndDate: 'End date',
    ledgerSummaryDatePlaceholder: 'YYYY-MM-DD',
    ledgerSummaryGenerate: 'Generate report',
    ledgerSummaryGenerating: 'Generating...',
    ledgerSummaryLoadFailed: 'Failed to load ledger summary.',
    ledgerSummaryColCode: 'Code',
    ledgerSummaryColName: 'Account name',
    ledgerSummaryColInflow: 'Total inflow',
    ledgerSummaryColTransactions: 'Transactions',
    ledgerSummaryGrandTotal: 'Grand total',
    ledgerSummaryEmpty: 'No data for the selected period.',

    dailySalesTitle: 'Daily sales summary',
    dailySalesSubtitle: 'End-of-day sales report with totals, breakdowns, and charts.',
    dailySalesStartDate: 'Start date',
    dailySalesEndDate: 'End date',
    dailySalesDatePlaceholder: 'YYYY-MM-DD',
    dailySalesStaffFilter: 'Staff',
    dailySalesStaffAll: 'All staff',
    dailySalesPaymentTypeFilter: 'Payment type',
    dailySalesPaymentTypeAll: 'All types',
    dailySalesBranchFilter: 'Branch',
    dailySalesBranchAll: 'All branches',
    dailySalesGenerate: 'Generate report',
    dailySalesGenerating: 'Generating...',
    dailySalesLoadFailed: 'Failed to load daily sales summary.',
    dailySalesEmpty: 'Select a date range and generate the report.',
    dailySalesTotalRevenue: 'Total revenue',
    dailySalesTransactionCount: 'Transactions',
    dailySalesTotalDiscounts: 'Total discounts',
    dailySalesByPaymentType: 'Breakdown by payment type',
    dailySalesByAccount: 'Breakdown by financial account',
    dailySalesByBranch: 'Breakdown by branch',
    dailySalesColPaymentType: 'Payment type',
    dailySalesColAccount: 'Account',
    dailySalesColBranch: 'Branch',
    dailySalesColCode: 'Code',
    dailySalesColTransactions: 'Transactions',
    dailySalesColRevenue: 'Revenue',
    dailySalesCategoryCash: 'Cash',
    dailySalesCategoryPos: 'POS',
    dailySalesCategoryOnline: 'Online',
    dailySalesChartByPaymentType: 'Revenue by payment type',
    dailySalesChartByAccount: 'Revenue by financial account',
    dailySalesNoData: 'No data for the selected filters.',

    reportsTabDailySales: 'Daily sales',
    reportsTabTimeBasedRevenue: 'Time-based revenue',

    timeBasedRevenueTitle: 'Time-based revenue & utilization',
    timeBasedRevenueSubtitle: 'Revenue and utilization by hour and day of week.',
    timeBasedRevenueStartDate: 'Start date',
    timeBasedRevenueEndDate: 'End date',
    timeBasedRevenueDatePlaceholder: 'YYYY-MM-DD',
    timeBasedRevenueStaffFilter: 'Staff',
    timeBasedRevenueStaffAll: 'All staff',
    timeBasedRevenuePaymentTypeFilter: 'Payment type',
    timeBasedRevenuePaymentTypeAll: 'All types',
    timeBasedRevenueGenerate: 'Generate report',
    timeBasedRevenueGenerating: 'Generating...',
    timeBasedRevenueLoadFailed: 'Failed to load time-based revenue report.',
    timeBasedRevenueEmpty: 'Select a date range and generate the report.',
    timeBasedRevenueTotalRevenue: 'Total revenue',
    timeBasedRevenueTotalEntries: 'Entry count',
    timeBasedRevenueAvgStay: 'Avg stay duration',
    timeBasedRevenueMinutes: 'min',
    timeBasedRevenueByHour: 'By hour',
    timeBasedRevenueByDayOfWeek: 'By day of week',
    timeBasedRevenueColHour: 'Hour',
    timeBasedRevenueColDay: 'Day',
    timeBasedRevenueColRevenue: 'Revenue',
    timeBasedRevenueColEntries: 'Entries',
    timeBasedRevenueColAvgStay: 'Avg stay',
    timeBasedRevenueNoData: 'No data for the selected filters.',
    timeBasedRevenueChartByHour: 'Revenue by hour',
    timeBasedRevenueChartByDay: 'Revenue by day of week',
    timeBasedRevenueDay1: 'Sunday',
    timeBasedRevenueDay2: 'Monday',
    timeBasedRevenueDay3: 'Tuesday',
    timeBasedRevenueDay4: 'Wednesday',
    timeBasedRevenueDay5: 'Thursday',
    timeBasedRevenueDay6: 'Friday',
    timeBasedRevenueDay7: 'Saturday',

    reportsTabVisitsSales: 'Visits sales',
    reportsTabVisitsNotClosed: 'Visits not closed',
    visitsReportLoadFailed: 'Failed to load visits report.',
    visitsReportEmpty: 'Select a date range and generate the report.',
    visitsReportMinutes: 'min',
    visitsReportNoData: 'No data for the selected filters.',
    visitsSalesTitle: 'Visits sales report',
    visitsSalesSubtitle: 'Visit counts, stay duration, and locker usage.',
    visitsSalesVisitCount: 'Visit count',
    visitsSalesChildrenCount: 'Children count',
    visitsSalesAvgChildren: 'Avg children per visit',
    visitsSalesAvgStay: 'Avg stay duration',
    visitsSalesMedianStay: 'Median stay duration',
    visitsSalesLockerUsage: 'Locker usage',
    visitsSalesLockerAssignments: 'Locker assignments',
    visitsSalesLockerDistinct: 'Distinct lockers',
    visitsSalesLockerVisits: 'Visits with locker',
    visitsSalesByDay: 'By day',
    visitsSalesByHour: 'By hour',
    visitsSalesByDayOfWeek: 'By day of week',
    visitsSalesByBranch: 'By branch',
    visitsSalesColDate: 'Date',
    visitsSalesColHour: 'Hour',
    visitsSalesColDay: 'Day',
    visitsSalesColBranch: 'Branch',
    visitsSalesColVisits: 'Visits',
    visitsSalesColChildren: 'Children',
    visitsSalesColAvgStay: 'Avg stay',
    visitsSalesChartByHour: 'Visits by hour',
    visitsSalesChartByDayOfWeek: 'Visits by day of week',
    visitsSalesChartByDay: 'Visits per day',
    visitsSalesChartByBranch: 'Visits by branch',
    visitsNotClosedTitle: 'Visits not closed',
    visitsNotClosedSubtitle: 'Open and unpaid visits with expected and charged amounts.',
    visitsNotClosedOpenCount: 'Open visits',
    visitsNotClosedUnpaidCount: 'Unpaid visits',
    visitsNotClosedOutstanding: 'Outstanding',
    visitsNotClosedByStatus: 'By status',
    visitsNotClosedColStatus: 'Status',
    visitsNotClosedColCount: 'Count',
    visitsNotClosedColAvgElapsed: 'Avg elapsed',
    visitsNotClosedColWithExpected: 'With expected',
    visitsNotClosedColAvgExpected: 'Avg expected',
    visitsNotClosedColOverExpected: 'Over expected',
    visitsNotClosedColCharged: 'Charged',
    visitsNotClosedColPaid: 'Paid',
    visitsNotClosedColOutstanding: 'Outstanding',
    visitsNotClosedUnpaidSummary: 'Unpaid summary',
    visitsNotClosedStatusActive: 'Active',
    visitsNotClosedStatusPendingTransaction: 'Pending transaction',
    visitsNotClosedStatusLeftUnpaid: 'Left unpaid',
    navSupport: 'Support',
    supportTitle: 'Support',
    supportNewTicket: 'New ticket',
    supportSubject: 'Subject',
    supportCategory: 'Category',
    supportCategoryBilling: 'Billing',
    supportCategoryTechnicalIssue: 'Technical issue',
    supportCategoryFeatureRequest: 'Feature request',
    supportCategoryOther: 'Other',
    supportBody: 'Message',
    supportStatusNew: 'New',
    supportStatusOpen: 'Open',
    supportStatusInProgress: 'In progress',
    supportStatusWaitingOnTenant: 'Waiting for response',
    supportStatusResolved: 'Resolved',
    supportStatusClosed: 'Closed',
    supportPriorityLow: 'Low',
    supportPriorityNormal: 'Normal',
    supportPriorityHigh: 'High',
    supportPriorityCritical: 'Critical',
    supportReply: 'Reply',
    supportInternalNote: 'Internal note',
    supportInternalNoteHint: 'Visible only to staff',
    supportReplyInternal: 'Reply internally',
    supportAttachments: 'Attachments',
    supportUpload: 'Upload',
    supportAttachmentTooLarge: 'Attachment too large',
    supportAttachmentCountExceeded: 'Attachment limit exceeded',
    supportUnassigned: 'Unassigned',
    supportAssignToMe: 'Assign to me',
    supportEmpty: 'No tickets',
    supportNoMessages: 'No messages',
    supportOperator: 'Support',
    supportUnreadBadge: 'Unread tickets',
    supportCategories: 'Categories',
    supportAddCategory: 'Add category',
    supportArchiveCategory: 'Archive category',
    supportManageCategories: 'Manage categories',
    supportFilterAll: 'All',
    supportFilterStatus: 'Status',
    supportFilterPriority: 'Priority',
    supportPriorityLabel: 'Priority',
    supportMarkRead: 'Mark read',
  },
  fa: {
    appName: 'خانه بازی',
    accessTitle: 'کنترل دسترسی',
    accessSubtitle: 'ورود امن برای کارکنان و مدیران.',
    usernameLabel: 'نام کاربری',
    passwordLabel: 'رمز عبور',
    usernamePlaceholder: 'نام کاربری را وارد کنید',
    passwordPlaceholder: 'رمز عبور را وارد کنید',
    signIn: 'ورود',
    signingIn: 'در حال ورود...',
    loginSuccess: 'ورود با موفقیت انجام شد.',
    logoutSuccess: 'خارج شدید.',
    loginInvalid: 'نام کاربری یا رمز عبور نادرست است.',
    loginMissing: 'نام کاربری و رمز عبور را وارد کنید.',
    loginFailed: 'ورود ناموفق بود. دوباره تلاش کنید.',
    renewPasswordTitle: 'تعیین رمز عبور جدید',
    renewPasswordSubtitle: 'قبل از ادامه، باید رمز عبور حساب خود را تغییر دهید.',
    newPasswordLabel: 'رمز عبور جدید',
    newPasswordPlaceholder: 'رمز عبور جدید را وارد کنید',
    confirmPasswordLabel: 'تایید رمز عبور',
    confirmPasswordPlaceholder: 'رمز عبور جدید را دوباره وارد کنید',
    renewPasswordSubmit: 'به‌روزرسانی رمز عبور',
    renewingPassword: 'در حال به‌روزرسانی رمز عبور...',
    renewPasswordSuccess: 'رمز عبور با موفقیت به‌روزرسانی شد.',
    renewPasswordMissing: 'رمز عبور جدید را وارد و تایید کنید.',
    renewPasswordMismatch: 'رمزهای عبور یکسان نیستند.',
    renewPasswordInvalid: 'رمز عبور شرایط لازم را ندارد.',
    renewPasswordFailed: 'به‌روزرسانی رمز عبور ناموفق بود. دوباره تلاش کنید.',
    toastDismiss: 'بستن اعلان',
    toastRegionLabel: 'اعلان‌ها',
    checkingSession: 'در حال بررسی نشست...',
    activeSession: 'نشست فعال',
    logout: 'خروج',
    openMenu: 'باز کردن منو',
    closeMenu: 'بستن منو',
    navAccountMenu: 'منوی حساب کاربری',
    backToList: 'بازگشت به فهرست',
    cancel: 'لغو',
    roleStaff: 'کارمند',
    roleManager: 'مدیر',
    roleAdmin: 'ادمین',
    roleSuperuser: 'سوپریوزر',
    rbacTitle: 'دسترسی مبتنی بر نقش',
    rbacSubtitle: 'برای بررسی دسترسی، یک بخش را انتخاب کنید.',
    rbacStaffTitle: 'فضای کار کارکنان',
    rbacStaffDescription: 'پذیرش روزانه، بازدیدها و پشتیبانی مهمانان.',
    rbacManagerTitle: 'کنسول مدیر',
    rbacManagerDescription: 'نظارت بر تیم، برنامه‌ها و تاییدها.',
    rbacAdminTitle: 'تنظیمات مدیر سیستم',
    rbacAdminDescription: 'پیکربندی سامانه و مجوزها.',
    rbacSuperuserTitle: 'کنترل‌های سوپریوزر',
    rbacSuperuserDescription: 'کنترل‌های سراسری و دسترسی سطح بالا.',
    rbacOpen: 'باز کردن',
    rbacRestricted: 'محدود',
    rbacCheckingAccess: 'در حال بررسی دسترسی...',
    rbacAccessGranted: 'دسترسی تایید شد.',
    rbacAccessDenied: 'به این بخش دسترسی ندارید.',
    rbacAccessFailed: 'بررسی دسترسی ناموفق بود. دوباره تلاش کنید.',
    rbacSelectedLabel: 'بخش انتخاب‌شده',
    bootstrapTitle: 'راه‌اندازی اولیه',
    bootstrapSubtitle:
      'حساب ادمین و پروفایل کسب‌وکار را بسازید تا راه‌اندازی تکمیل شود.',
    bootstrapSectionAdmin: 'حساب مدیر سیستم',
    bootstrapSectionOrganization: 'پروفایل کسب‌وکار',
    bootstrapOrgName: 'نام کسب‌وکار',
    bootstrapOrgNamePlaceholder: 'در نوار کنار صفحه به کارکنان نمایش داده می‌شود',
    bootstrapBusinessType: 'نوع کسب‌وکار',
    bootstrapOwnerName: 'مالک یا مدیر مسئول',
    bootstrapOwnerNamePlaceholder: 'مخاطب اصلی مجموعه',
    bootstrapOrgEmail: 'ایمیل کسب‌وکار (اختیاری)',
    bootstrapOrgEmailPlaceholder: 'contact@example.com',
    bootstrapOrgPhone: 'تلفن (اختیاری)',
    bootstrapOrgPhonePlaceholder: 'با پیش‌شماره در صورت نیاز',
    bootstrapOrgWebsite: 'وب‌سایت (اختیاری)',
    bootstrapOrgWebsitePlaceholder: 'https://example.com',
    bootstrapOrgAddress: 'آدرس (اختیاری)',
    bootstrapOrgAddressPlaceholder: 'خیابان، شهر',
    organizationBusinessType_children_playhouse: 'خانه بازی کودک',
    organizationBusinessType_gym: 'باشگاه / تناسب اندام',
    organizationBusinessType_game_nets: 'ترامپولین و تور بازی',
    organizationBusinessType_workspace: 'فضای کار اشتراکی',
    organizationBusinessType_boardgame_cafe: 'کافه بازی فکری',
    organizationSettingsTitle: 'پروفایل کسب‌وکار',
    organizationSettingsSubtitle: 'برند مجموعه، مالکیت و راه تماس عمومی.',
    organizationLogoLabel: 'لوگو',
    organizationLogoUpload: 'بارگذاری لوگو',
    organizationLogoUploading: 'در حال بارگذاری…',
    organizationLogoHint: 'JPEG یا PNG یا WebP؛ حداکثر ۲ مگابایت.',
    organizationLogoUploadFailed: 'بارگذاری لوگو ناموفق بود.',
    organizationBusinessTypeLabel: 'نوع کسب‌وکار',
    organizationBusinessTypeChoose: 'نوع را انتخاب کنید…',
    organizationBusinessTypeUnset: 'تعیین نشده',
    organizationBusinessTypeLockedHint: 'پس از راه‌اندازی اولیه قابل تغییر نیست.',
    organizationBusinessTypeFirstHint: 'یک‌بار انتخاب کنید — پس از ذخیره قفل می‌شود.',
    organizationNameLabel: 'نام کسب‌وکار',
    organizationOwnerLabel: 'مالک / مدیر مسئول',
    organizationEmailLabel: 'ایمیل',
    organizationPhoneLabel: 'تلفن',
    organizationWebsiteLabel: 'وب‌سایت',
    organizationAddressLabel: 'آدرس',
    organizationSave: 'ذخیره پروفایل کسب‌وکار',
    bootstrapEmailLabel: 'ایمیل (اختیاری)',
    bootstrapEmailPlaceholder: 'name@example.com',
    bootstrapCreate: 'ایجاد سوپریوزر',
    bootstrapCreating: 'در حال ایجاد...',
    bootstrapSuccess: 'سوپریوزر ایجاد شد. لطفا وارد شوید.',
    bootstrapAlreadyExists: 'سوپریوزر قبلا ایجاد شده است. لطفا وارد شوید.',
    bootstrapUsernameTaken: 'این نام کاربری قبلا استفاده شده است.',
    bootstrapInvalid: 'فرم را بررسی کنید و دوباره تلاش کنید.',
    bootstrapFailed: 'راه‌اندازی ناموفق بود. دوباره تلاش کنید.',
    bootstrapStatusFailed: 'بررسی وضعیت راه‌اندازی ناموفق بود.',
    bootstrapRequiredNotice: 'برای مدیریت ادمین، راه‌اندازی اولیه لازم است.',
    bootstrapStart: 'شروع راه‌اندازی',
    bootstrapBackToLogin: 'بازگشت به ورود',
    branchInitPageSubtitle: 'برای ادامه، اولین شعبه را بسازید.',
    branchInitWaitingSubtitle: 'قبل از استفاده از برنامه باید شعبه راه‌اندازی شود.',
    branchInitWaitingTitle: 'در انتظار راه‌اندازی شعبه',
    branchInitWaitingMessage: 'مدیر سیستم باید اولین شعبه را ایجاد کند تا بتوانید ادامه دهید.',
    branchInitTitle: 'اولین شعبه',
    branchInitSubtitle: 'قبل از استفاده از برنامه، حداقل یک شعبه لازم است.',
    branchInitNameLabel: 'نام شعبه',
    branchInitNamePlaceholder: 'مثلاً شعبه مرکزی',
    branchInitCreate: 'ایجاد شعبه',
    branchInitCreating: 'در حال ایجاد...',
    branchInitSuccess: 'شعبه ایجاد شد. خوش آمدید!',
    branchInitFailed: 'ایجاد شعبه ناموفق بود. دوباره تلاش کنید.',
    branchInitNameRequired: 'نام شعبه را وارد کنید.',
    branchInitNameExists: 'شعبه‌ای با این نام وجود دارد.',
    branchSelectorTitle: 'انتخاب شعبه',
    branchSelectorSubtitle: 'شعبه‌ای را که می‌خواهید در آن کار کنید انتخاب کنید.',
    branchSelectorListLabel: 'شعب شما',
    branchSelectorLoading: 'در حال بارگذاری شعب...',
    branchSelectorLoadFailed: 'بارگذاری شعب ناموفق بود.',
    branchSelectorEmpty: 'شعبه‌ای در دسترس نیست.',
    branchSelectorSelecting: 'در حال تغییر شعبه...',
    branchAccessWaitingTitle: 'دسترسی به شعبه لازم است',
    branchAccessWaitingSubtitle: 'مدیر باید شما را به یک شعبه اختصاص دهد تا بتوانید ادامه دهید.',
    branchAccessWaitingHeading: 'در انتظار دسترسی به شعبه',
    branchAccessWaitingMessage:
      'وارد شده‌اید، اما هنوز شعبه‌ای به حساب شما اختصاص داده نشده است. با مدیر تماس بگیرید.',
    navActiveBranch: 'شعبه فعال',
    branchesTitle: 'شعب',
    branchesSubtitle: 'مدیریت مکان‌ها و وضعیت شعب.',
    branchesListLabel: 'شعب',
    branchesTotal: 'مجموع',
    branchesEmpty: 'هنوز شعبه‌ای ثبت نشده است.',
    branchesLoading: 'در حال بارگذاری شعب...',
    branchesListLoadFailed: 'بارگذاری شعب ناموفق بود.',
    branchesStatusLoadFailed: 'بارگذاری وضعیت شعب ناموفق بود.',
    branchesCreateButton: 'افزودن شعبه',
    branchesCreateTitle: 'شعبه جدید',
    branchesNameLabel: 'نام شعبه',
    branchesNamePlaceholder: 'نام شعبه',
    branchesStatusLabel: 'وضعیت',
    branchesStatusActive: 'فعال',
    branchesStatusInactive: 'غیرفعال',
    branchesSaveButton: 'ذخیره',
    branchesSaving: 'در حال ذخیره...',
    branchesCreateSuccess: 'شعبه ایجاد شد.',
    branchesCreateFailed: 'ایجاد شعبه ناموفق بود.',
    branchesUpdateSuccess: 'شعبه به‌روزرسانی شد.',
    branchesUpdateFailed: 'به‌روزرسانی شعبه ناموفق بود.',
    branchesDeleteButton: 'حذف',
    branchesDeleting: 'در حال حذف...',
    branchesDeleteConfirm: 'این شعبه حذف شود؟ این عمل قابل بازگشت نیست.',
    branchesDeleteSuccess: 'شعبه حذف شد.',
    branchesDeleteFailed: 'حذف شعبه ناموفق بود.',
    branchesDeleteLastBranch: 'آخرین شعبه قابل حذف نیست. حداقل یک شعبه باید باقی بماند.',
    branchesDeactivateButton: 'غیرفعال‌سازی',
    branchesDeactivating: 'در حال غیرفعال‌سازی...',
    branchesDeactivateSuccess: 'شعبه غیرفعال شد.',
    branchesDeactivateFailed: 'غیرفعال‌سازی شعبه ناموفق بود.',
    branchesActivateButton: 'فعال‌سازی',
    branchesActivating: 'در حال فعال‌سازی...',
    branchesActivateSuccess: 'شعبه فعال شد.',
    branchesActivateFailed: 'فعال‌سازی شعبه ناموفق بود.',
    branchesNameExists: 'شعبه‌ای با این نام وجود دارد.',
    branchesDetailEmpty: 'برای مشاهده جزئیات یک شعبه را انتخاب کنید.',
    branchSettingsEyebrow: 'شعبه فعال',
    branchSettingsTitle: 'تنظیمات شعبه',
    branchSettingsSubtitle: 'گزینه‌های شعبه‌ای را که در حال حاضر فعال است پیکربندی کنید.',
    branchSettingsTabGeneral: 'عمومی',
    branchSettingsTabCounters: 'پیشخوان‌ها',
    branchSettingsTabPaymentTypes: 'روش‌های پرداخت',
    branchSettingsTabDevices: 'دستگاه‌ها',
    branchScopeLabel: 'دسترسی شعبه‌ای',
    branchScopeAll: 'همه شعب',
    branchScopeThisBranch: 'فقط این شعبه',
    branchScopeFilterActiveBranch: 'نمایش موارد مربوط به شعبه فعال',
    branchSettingsGeneralTitle: 'نمای کلی شعبه',
    branchSettingsGeneralSubtitle:
      'این تنظیمات فقط برای شعبه‌ای که هم‌اکنون در آن کار می‌کنید اعمال می‌شود.',
    branchSettingsOperationalTitle: 'تنظیمات عملیاتی',
    branchSettingsOperationalSubtitle:
      'ساعات فعال، محدودیت کمد و ورودی بارکد خروج برای این شعبه.',
    branchSettingsLoading: 'در حال بارگذاری تنظیمات شعبه...',
    branchSettingsLoadFailed: 'بارگذاری تنظیمات شعبه ناموفق بود.',
    branchSettingsSaveFailed: 'ذخیره تنظیمات شعبه ناموفق بود.',
    branchSettingsSaveSuccess: 'تنظیمات شعبه ذخیره شد.',
    branchSettingsExitBarcodeInputModeLabel: 'حالت ورودی بارکد خروج',
    branchSettingsExitBarcodeInputModeHint:
      'نحوه تأیید بارکد ویزیت هنگام خروج در این شعبه (نه ورود).',
    branchSettingsChildExitModeLabel: 'حالت خروج کودک',
    branchSettingsChildExitModeHint:
      'اینکه خروج کودک جداگانه یا همراه با خروج ویزیت ثبت شود',
    branchSettingsChildExitModeOptSeparate: 'جداگانه',
    branchSettingsChildExitModeOptWithVisit: 'همراه با ویزیت',
    branchSettingsExitPaymentModeLabel: 'حالت خروج / پرداخت',
    branchSettingsExitPaymentModeHint:
      'اینکه خروج از پرداخت جدا باشد یا همراه با پرداخت ثبت شود',
    branchSettingsExitPaymentModeOptMultiStep: 'پرداخت چندمرحله‌ای',
    branchSettingsExitPaymentModeOptExitOnPayment: 'خروج هنگام پرداخت',
    branchSettingsBranchNameLabel: 'نام شعبه',
    branchSettingsManageBranchesLink: 'مدیریت همه شعب',
    branchSettingsManageBranchesHint:
      'شعب را ایجاد کنید، نام آن‌ها را تغییر دهید یا وضعیت آن‌ها را در سطح سازمان مدیریت کنید.',
    branchSettingsPaymentTypesTitle: 'روش‌های پرداخت',
    branchSettingsPaymentTypesPlaceholder:
      'روش‌های پرداخت اختصاصی هر شعبه در به‌روزرسانی بعدی در اینجا پیکربندی می‌شود.',
    branchSettingsDevicesTitle: 'دستگاه‌ها',
    branchSettingsDevicesPlaceholder:
      'اتصال دستگاه‌های این شعبه پس از در دسترس بودن یکپارچه‌سازی دستگاه در اینجا پیکربندی می‌شود.',
    branchDevicesTabSubtitle: 'سخت‌افزار کشف‌شده را به پیشخوان‌های این شعبه متصل کنید.',
    branchDevicesCreateButton: 'افزودن اتصال',
    branchDevicesCreateTitle: 'اتصال دستگاه جدید',
    branchDevicesEditTitle: 'ویرایش اتصال دستگاه',
    branchDevicesEditButton: 'ویرایش',
    branchDevicesDeleteButton: 'حذف',
    branchDevicesDeleteConfirm: 'این اتصال دستگاه حذف شود؟ این عمل قابل بازگشت نیست.',
    branchDevicesSaveButton: 'ذخیره',
    branchDevicesSaving: 'در حال ذخیره...',
    branchDevicesCreating: 'در حال ایجاد...',
    branchDevicesLoading: 'در حال بارگذاری اتصال دستگاه‌ها...',
    branchDevicesEmpty: 'هنوز اتصال دستگاهی وجود ندارد.',
    branchDevicesListLoadFailed: 'بارگذاری اتصال دستگاه‌ها ناموفق بود.',
    branchDevicesCreateSuccess: 'اتصال دستگاه ایجاد شد.',
    branchDevicesCreateFailed: 'ایجاد اتصال دستگاه ناموفق بود.',
    branchDevicesUpdateSuccess: 'اتصال دستگاه به‌روزرسانی شد.',
    branchDevicesUpdateFailed: 'به‌روزرسانی اتصال دستگاه ناموفق بود.',
    branchDevicesDeleteSuccess: 'اتصال دستگاه حذف شد.',
    branchDevicesDeleteFailed: 'حذف اتصال دستگاه ناموفق بود.',
    branchDevicesCounterLabel: 'پیشخوان',
    branchDevicesCounterRequired: 'یک پیشخوان انتخاب کنید.',
    branchDevicesNoCounters: 'پیشخوان فعالی وجود ندارد',
    branchDevicesRoleLabel: 'نقش',
    branchDevicesRolePrinter: 'چاپگر',
    branchDevicesRoleLockerset: 'کمد',
    branchDevicesRolePos: 'صندوق',
    branchDevicesDeviceLabel: 'دستگاه',
    branchDevicesDeviceRequired: 'یک دستگاه انتخاب کنید.',
    branchDevicesNoDevices: 'دستگاه کشف‌شده‌ای در دسترس نیست',
    branchDevicesSharedLabel: 'اتصال مشترک (همان دستگاه روی چند پیشخوان)',
    branchDevicesSharedBadge: 'مشترک',
    branchDevicesFilterCounterLabel: 'فیلتر بر اساس پیشخوان',
    branchDevicesFilterAllCounters: 'همه پیشخوان‌ها',
    branchDevicesUnknownCounter: 'پیشخوان نامشخص',
    branchDevicesStatusActive: 'فعال',
    branchDevicesStatusUnbound: 'متصل نشده',
    branchDevicesStatusMissing: 'غایب',
    branchDevicesTypePrinter: 'چاپگر',
    branchDevicesTypeLockersetController: 'کنترل‌کننده کمد',
    branchDevicesTypePos: 'صندوق',
    branchDevicesInventoryTitle: 'موجودی کشف‌شده',
    branchDevicesInventorySubtitle:
      'دستگاه‌های گزارش‌شده توسط درایورهای شعبه. آن‌ها را در بالا به پیشخوان متصل کنید.',
    branchDevicesInventoryLoading: 'در حال بارگذاری دستگاه‌های کشف‌شده...',
    branchDevicesInventoryEmpty:
      'هنوز دستگاهی کشف نشده است. یک درایور متصل کنید و منتظر موجودی بمانید.',
    branchDevicesInventoryLoadFailed: 'بارگذاری دستگاه‌های کشف‌شده ناموفق بود.',
    branchDevicesRediscoverButton: 'کشف مجدد دستگاه‌ها',
    branchDevicesRediscovering: 'در حال کشف مجدد...',
    branchDevicesRediscoverSuccess: 'موجودی دستگاه از درایورهای متصل به‌روزرسانی شد.',
    branchDevicesRediscoverFailed:
      'کشف مجدد دستگاه‌ها ناموفق بود. مطمئن شوید یک درایور متصل است.',
    branchDevicesRediscoverNoDrivers: 'درایور متصلی برای این شعبه وجود ندارد.',
    branchDevicesDiscoveredBadge: 'از گزارش درایور',
    branchesQuotaExceeded: 'سقف شعب تکمیل شده — برای افزودن شعبه پلن را ارتقا دهید.',
    counterSetupBannerTitle: 'پیشخوانی پیکربندی نشده است',
    counterSetupBannerMessage:
      'ورود و خروج تا زمانی که حداقل یک پیشخوان فعال برای این شعبه تعریف نشود، مسدود است.',
    counterSetupBannerAdminAction: 'مدیریت پیشخوان‌ها',
    counterSetupBannerStaffHint: 'از مدیر بخواهید برای این شعبه پیشخوان اضافه کند.',
    activeCounterLabel: 'پیشخوان فعال',
    activeCounterChangeButton: 'تغییر',
    counterSelectionTitle: 'انتخاب پیشخوان',
    counterSelectionSubtitle: 'پیشخوانی را که در آن کار می‌کنید انتخاب کنید.',
    counterSelectionLoading: 'در حال بارگذاری پیشخوان‌ها...',
    counterSelectionLoadFailed: 'بارگذاری پیشخوان‌ها ناموفق بود.',
    counterSelectionEmpty: 'پیشخوان فعالی در دسترس نیست.',
    counterSelectionSelecting: 'در حال تنظیم پیشخوان...',
    counterGateHintNoCounters:
      'ورود و خروج تا زمانی که پیشخوان برای این شعبه پیکربندی نشود، در دسترس نیست.',
    counterGateHintSelectCounter: 'قبل از شروع ورود یا خروج، پیشخوان فعال خود را انتخاب کنید.',
    counterGateHintInactiveCounter:
      'پیشخوان انتخاب‌شده غیرفعال است. برای شروع ورود یا خروج یک پیشخوان فعال انتخاب کنید.',
    countersTabTitle: 'پیشخوان‌ها',
    countersTabSubtitle: 'ایستگاه‌های پذیرش این شعبه را تعریف کنید.',
    countersCreateButton: 'افزودن پیشخوان',
    countersCreateTitle: 'پیشخوان جدید',
    countersEditTitle: 'ویرایش پیشخوان',
    countersEditButton: 'ویرایش',
    countersNameLabel: 'نام پیشخوان',
    countersNamePlaceholder: 'مثلاً پیشخوان اصلی',
    countersNameRequired: 'نام پیشخوان را وارد کنید.',
    countersStatusLabel: 'وضعیت',
    countersStatusActive: 'فعال',
    countersStatusInactive: 'غیرفعال',
    countersSaveButton: 'ذخیره',
    countersSaving: 'در حال ذخیره...',
    countersCreating: 'در حال ایجاد...',
    countersLoading: 'در حال بارگذاری پیشخوان‌ها...',
    countersEmpty: 'هنوز پیشخوانی ثبت نشده است.',
    countersListLoadFailed: 'بارگذاری پیشخوان‌ها ناموفق بود.',
    countersCreateSuccess: 'پیشخوان ایجاد شد.',
    countersCreateFailed: 'ایجاد پیشخوان ناموفق بود.',
    countersUpdateSuccess: 'پیشخوان به‌روزرسانی شد.',
    countersUpdateFailed: 'به‌روزرسانی پیشخوان ناموفق بود.',
    countersDeleteButton: 'حذف',
    countersDeleteConfirm: 'این پیشخوان حذف شود؟ این عمل قابل بازگشت نیست.',
    countersDeleteSuccess: 'پیشخوان حذف شد.',
    countersDeleteFailed: 'حذف پیشخوان ناموفق بود.',
    countersDeleteInUse: 'پیشخوان در حال استفاده است و قابل حذف نیست.',
    countersDeactivateButton: 'غیرفعال‌سازی',
    countersActivateButton: 'فعال‌سازی',
    countersNameExists: 'پیشخوانی با این نام در این شعبه وجود دارد.',
    adminUsersTitle: 'مدیریت ادمین‌ها',
    adminUsersSubtitle: 'ایجاد، ویرایش و غیرفعال‌سازی حساب‌های ادمین.',
    adminUsersUsername: 'نام کاربری ادمین',
    adminUsersUsernamePlaceholder: 'مثلا admin.jane',
    adminUsersPassword: 'رمز عبور ادمین',
    adminUsersPasswordPlaceholder: 'یک رمز موقت تعیین کنید',
    adminUsersEmail: 'ایمیل ادمین',
    adminUsersEmailPlaceholder: 'name@example.com',
    adminUsersActive: 'فعال',
    adminUsersCreate: 'ایجاد ادمین',
    adminUsersCreating: 'در حال ایجاد...',
    adminUsersListLabel: 'ادمین‌ها',
    adminUsersTotalLabel: 'مجموع',
    adminUsersEmpty: 'هنوز ادمینی وجود ندارد.',
    adminUsersEdit: 'ویرایش',
    adminUsersDeactivate: 'غیرفعال',
    adminUsersActivate: 'فعال‌سازی',
    adminUsersSave: 'ذخیره تغییرات',
    adminUsersCancel: 'لغو',
    adminUsersPasswordReset: 'بازنشانی رمز عبور',
    adminUsersPasswordResetPlaceholder: 'برای حفظ رمز فعلی خالی بگذارید',
    adminUsersStatusActive: 'فعال',
    adminUsersStatusInactive: 'غیرفعال',
    adminUsersStatusAll: 'همه وضعیت‌ها',
    adminUsersStatusLabel: 'وضعیت',
    adminUsersSearchLabel: 'جستجو',
    adminUsersSearchPlaceholder: 'جستجو بر اساس نام کاربری',
    adminUsersFilterApply: 'اعمال فیلترها',
    adminUsersFilterClear: 'پاک کردن فیلترها',
    adminUsersNoEmail: 'ایمیلی ثبت نشده است',
    adminUsersCreated: 'ادمین ایجاد شد.',
    adminUsersUpdated: 'ادمین به‌روزرسانی شد.',
    adminUsersDeactivated: 'ادمین غیرفعال شد.',
    adminUsersFailed: 'مدیریت ادمین‌ها ناموفق بود.',
    adminUsersInvalid: 'فرم ادمین را بررسی کنید و دوباره تلاش کنید.',
    adminUsersUsernameTaken: 'این نام کاربری قبلا استفاده شده است.',
    adminUsersNotFound: 'ادمین پیدا نشد.',
    teamUsersTitle: 'مدیریت کارکنان و مدیران',
    teamUsersSubtitle: 'ایجاد، ویرایش و غیرفعال‌سازی حساب‌های کارکنان و مدیران.',
    teamUsersUsername: 'نام کاربری',
    teamUsersUsernamePlaceholder: 'مثلا staff.sam',
    teamUsersPassword: 'رمز عبور',
    teamUsersPasswordPlaceholder: 'یک رمز موقت تعیین کنید',
    teamUsersEmail: 'ایمیل',
    teamUsersEmailPlaceholder: 'name@example.com',
    teamUsersRole: 'نقش',
    teamUsersRoleStaff: 'کارمند',
    teamUsersRoleManager: 'مدیر',
    teamUsersActive: 'فعال',
    teamUsersCreate: 'ایجاد کاربر',
    teamUsersCreating: 'در حال ایجاد...',
    teamUsersListLabel: 'کاربران',
    teamUsersTotalLabel: 'مجموع',
    teamUsersEmpty: 'هنوز کاربر کارمند یا مدیر وجود ندارد.',
    teamUsersEdit: 'ویرایش',
    teamUsersDeactivate: 'غیرفعال',
    teamUsersActivate: 'فعال‌سازی',
    teamUsersSave: 'ذخیره تغییرات',
    teamUsersCancel: 'لغو',
    teamUsersPasswordReset: 'بازنشانی رمز عبور',
    teamUsersPasswordResetPlaceholder: 'برای حفظ رمز فعلی خالی بگذارید',
    teamUsersStatusActive: 'فعال',
    teamUsersStatusInactive: 'غیرفعال',
    teamUsersStatusAll: 'همه وضعیت‌ها',
    teamUsersStatusLabel: 'وضعیت',
    teamUsersRoleLabel: 'نقش',
    teamUsersRoleAll: 'همه نقش‌ها',
    teamUsersSearchLabel: 'جستجو',
    teamUsersSearchPlaceholder: 'جستجو بر اساس نام کاربری',
    teamUsersFilterApply: 'اعمال فیلترها',
    teamUsersFilterClear: 'پاک کردن فیلترها',
    teamUsersNoEmail: 'ایمیلی ثبت نشده است',
    teamUsersCreated: 'کاربر ایجاد شد.',
    teamUsersUpdated: 'کاربر به‌روزرسانی شد.',
    teamUsersDeactivated: 'کاربر غیرفعال شد.',
    teamUsersFailed: 'مدیریت کاربران ناموفق بود.',
    teamUsersInvalid: 'فرم کاربر را بررسی کنید و دوباره تلاش کنید.',
    teamUsersUsernameTaken: 'این نام کاربری قبلا استفاده شده است.',
    teamUsersNotFound: 'کاربر پیدا نشد.',
    teamUsersInvalidRole: 'یک نقش معتبر انتخاب کنید.',
    teamUsersForbidden: 'به مدیریت کاربران دسترسی ندارید.',
    branchAccessLabel: 'دسترسی به شعبه',
    branchAccessHint: 'شعبه‌هایی را که این کاربر به آن‌ها دسترسی دارد انتخاب کنید.',
    branchAccessLoading: 'در حال بارگذاری شعبه‌ها...',
    branchAccessEmpty: 'شعبه فعالی موجود نیست.',
    branchAccessLoadFailed: 'بارگذاری دسترسی شعبه ناموفق بود.',
    branchAccessAdminImplicit: 'کاربران ادمین به‌صورت خودکار به همه شعبه‌ها دسترسی دارند.',
    branchAccessInvalidBranch: 'یک یا چند شعبه انتخاب‌شده نامعتبر است.',
    auditLogsTitle: 'ثبت رویدادها',
    auditLogsSubtitle: 'اقدام‌های مهم را در سامانه بررسی کنید.',
    auditLogsStartDate: 'تاریخ شروع',
    auditLogsEndDate: 'تاریخ پایان',
    auditLogsUser: 'کاربر',
    auditLogsUserPlaceholder: 'مثلا admin.user',
    auditLogsAction: 'اقدام',
    auditLogsActionPlaceholder: 'مثلا user_password_reset',
    auditLogsModule: 'ماژول',
    auditLogsModulePlaceholder: 'مثلا users',
    auditLogsUserAll: 'همه کاربران',
    auditLogsActionAll: 'همه اقدام‌ها',
    auditLogsModuleAll: 'همه ماژول‌ها',
    auditLogsApply: 'اعمال فیلترها',
    auditLogsClear: 'پاک کردن',
    auditLogsListLabel: 'رویدادها',
    auditLogsTotalLabel: 'مجموع',
    auditLogsEmpty: 'هیچ رویدادی یافت نشد.',
    auditLogsDate: 'زمان',
    auditLogsActor: 'عامل',
    auditLogsActionType: 'اقدام',
    auditLogsModuleLabel: 'ماژول',
    auditLogsEntity: 'موجودیت',
    auditLogsUnknownUser: 'سامانه',
    auditLogsUnknownDate: 'زمان نامشخص',
    auditLogsFailed: 'بارگذاری رویدادها ناموفق بود.',
    auditLogsInvalid: 'مقادیر فیلتر را بررسی کنید.',
    auditLogsForbidden: 'به رویدادها دسترسی ندارید.',
    auditActionAdminUserCreated: 'ادمین ایجاد شد',
    auditActionAdminUserUpdated: 'ادمین به‌روزرسانی شد',
    auditActionAdminUserDeactivated: 'ادمین غیرفعال شد',
    auditActionStaffManagerUserCreated: 'کاربر کارمند/مدیر ایجاد شد',
    auditActionStaffManagerUserUpdated: 'کاربر کارمند/مدیر به‌روزرسانی شد',
    auditActionStaffManagerUserDeactivated: 'کاربر کارمند/مدیر غیرفعال شد',
    auditActionUserPasswordReset: 'رمز عبور بازنشانی شد',
    auditActionSessionTimeoutUpdated: 'مدت نشست به‌روزرسانی شد',
    auditActionCustomerCreated: 'مشتری ایجاد شد',
    auditActionCustomerUpdated: 'مشتری به‌روزرسانی شد',
    auditActionCustomerDeleted: 'مشتری حذف شد',
    auditActionCustomerBanned: 'مشتری مسدود شد',
    auditActionCustomerUnbanned: 'مسدودیت مشتری برداشته شد',
    auditActionCustomerImportedBulk: 'واردسازی دسته‌ای مشتریان',
    auditActionChildCreated: 'کودک ایجاد شد',
    auditActionChildUpdated: 'کودک به‌روزرسانی شد',
    auditActionChildDeleted: 'کودک حذف شد',
    auditActionVisitCreated: 'ورود ایجاد شد',
    auditActionVisitStarted: 'شروع بازی ثبت شد',
    auditActionVisitSessionCreated: 'نشست ورود ایجاد شد',
    auditActionVisitOpened: 'ورود باز شد',
    auditActionVisitChildExited: 'خروج کودک ثبت شد',
    auditActionVisitChildAdded: 'افزودن کودک در میانهٔ بازدید',
    auditActionVisitExited: 'خروج از بازی ثبت شد',
    auditActionVisitSessionExited: 'خروج نشست ثبت شد',
    auditActionPricingPlanCreated: 'طرح قیمت‌گذاری ایجاد شد',
    auditActionPricingPlanUpdated: 'طرح قیمت‌گذاری به‌روزرسانی شد',
    auditActionPricingPlanDeleted: 'طرح قیمت‌گذاری حذف شد',
    auditActionDiscountCreated: 'تخفیف ایجاد شد',
    auditActionDiscountActivated: 'تخفیف فعال شد',
    auditActionDiscountDeactivated: 'تخفیف غیرفعال شد',
    auditActionPaymentTypeCreated: 'روش پرداخت ایجاد شد',
    auditActionPaymentTypeUpdated: 'روش پرداخت به‌روزرسانی شد',
    auditActionPaymentTypeActivated: 'روش پرداخت فعال شد',
    auditActionPaymentTypeDeactivated: 'روش پرداخت غیرفعال شد',
    auditActionPaymentTypeDeleted: 'روش پرداخت حذف شد',
    auditActionPaymentRecorded: 'پرداخت ثبت شد',
    auditActionReceiptPrinted: 'رسید چاپ شد',
    auditActionTransactionChargePriceCorrected: 'اصلاح قیمت هزینه تراکنش',
    auditActionTransactionChargeAutoRounded: 'گرد کردن خودکار هزینه تراکنش',
    auditActionTransactionChargeAutoRoundReverted: 'بازگردانی گرد کردن خودکار هزینه',
    auditActionSystemSettingsUpdated: 'تنظیمات سیستم به‌روزرسانی شد',
    auditActionVisitChildBarcodeVerified: 'تأیید بارکد کودک',
    auditActionVisitChildBarcodeBypass: 'عبور از بارکد کودک',
    auditActionDiscountApplied: 'تخفیف اعمال شد',
    auditActionFinancialAccountCreated: 'حساب مالی ایجاد شد',
    auditActionFinancialAccountUpdated: 'حساب مالی به‌روزرسانی شد',
    auditActionFinancialAccountActivated: 'حساب مالی فعال شد',
    auditActionFinancialAccountDeactivated: 'حساب مالی غیرفعال شد',
    auditActionUtilitySetCreated: 'مجموعه تجهیزات ایجاد شد',
    auditActionUtilitySetUpdated: 'مجموعه تجهیزات به‌روزرسانی شد',
    auditActionUtilitySetDeleted: 'مجموعه تجهیزات حذف شد',
    auditActionUtilityCreated: 'تجهیزات ایجاد شد',
    auditActionUtilityUpdated: 'تجهیزات به‌روزرسانی شد',
    auditActionUtilityDeactivated: 'تجهیزات غیرفعال شد',
    auditActionUtilityActivated: 'تجهیزات فعال شد',
    auditActionUtilityDeleted: 'تجهیزات حذف شد',
    auditActionIntegrationCreated: 'یکپارچه‌سازی ایجاد شد',
    auditActionIntegrationUpdated: 'یکپارچه‌سازی به‌روزرسانی شد',
    auditActionIntegrationDeleted: 'یکپارچه‌سازی حذف شد',
    auditActionDriverSetupCodeCreated: 'کد راه‌اندازی درایور ایجاد شد',
    auditActionDriverSetupCodeRevoked: 'کد راه‌اندازی درایور لغو شد',
    auditActionDriverRegistered: 'درایور ثبت شد',
    auditActionDriverDisabled: 'درایور غیرفعال شد',
    auditActionDriverEnabled: 'درایور فعال شد',
    auditActionDriverDeleted: 'درایور حذف شد',
    auditActionDriverApiKeyRotated: 'کلید API درایور چرخانده شد',
    auditActionDriverHealthStatusChanged: 'وضعیت سلامت درایور تغییر کرد',
    auditActionGiftCardTypeCreated: 'نوع کارت هدیه ایجاد شد',
    auditActionGiftCardTypeUpdated: 'نوع کارت هدیه به‌روزرسانی شد',
    auditActionGiftCardInstanceIssued: 'کارت هدیه صادر شد',
    auditActionGiftCardBatchIssued: 'صدور دسته‌ای کارت هدیه',
    auditActionGiftCardPurchased: 'کارت هدیه خریداری شد',
    auditActionGiftCardInstanceMapped: 'کارت هدیه به مشتری اختصاص یافت',
    auditActionBranchCreated: 'شعبه ایجاد شد',
    auditActionBranchUpdated: 'شعبه به‌روزرسانی شد',
    auditActionBranchDeleted: 'شعبه حذف شد',
    auditActionCounterCreated: 'پیشخوان ایجاد شد',
    auditActionCounterUpdated: 'پیشخوان به‌روزرسانی شد',
    auditActionCounterDeleted: 'پیشخوان حذف شد',
    auditActionUserBranchAccessUpdated: 'دسترسی کاربر به شعب به‌روزرسانی شد',
    auditModuleUsers: 'کاربران',
    auditModuleCustomers: 'مشتریان',
    auditModuleVisits: 'ورودها',
    auditModuleSettings: 'تنظیمات',
    auditModulePricing: 'قیمت‌گذاری',
    auditModuleDiscounts: 'تخفیف‌ها',
    auditModuleFinancial: 'تنظیمات مالی',
    auditModuleUtilities: 'تجهیزات',
    auditModuleIntegrations: 'یکپارچه‌سازی‌ها',
    auditModuleBranches: 'شعب',
    entryStartTitle: 'ورود مشتری',
    entryStartButton: 'ورود مشتری',
    entryModalTitle: 'شروع فرایند ورود',
    entryStageCustomer: 'مشتری',
    entryStageChildren: 'کودکان',
    entryStagePricing: 'قیمت و پرداخت',
    entryStageLockers: 'قفل‌ها',
    receiptTitle: 'رسید ورود',
    receiptCustomer: 'مشتری:',
    receiptPhone: 'تلفن:',
    receiptEntryTime: 'ورود:',
    receiptExpectedExit: 'خروج مورد انتظار:',
    receiptChildrenSection: 'کودکان',
    receiptVisitQrSection: 'QR ویزیت',
    receiptPaymentSection: 'پرداخت هنگام ورود',
    receiptLockersSection: 'قفل‌ها',
    receiptLockersLoadFailed: 'بارگذاری فهرست قفل‌ها برای رسید ناموفق بود.',
    receiptPreviewLoading: 'در حال بارگذاری پیش‌نمایش رسید…',
    receiptPreviewLoadFailed: 'بارگذاری پیش‌نمایش رسید از سرور ناموفق بود.',
    receiptThermalRequiresDriver:
      'چاپ رسید حرارتی از طریق درایور یکپارچه‌سازی حضوری است. در تنظیمات → ورود و ویزیت، چاپگر را روی درایور بگذارید.',
    receiptFooter: 'این رسید را تا خروج همه کودکان نگه دارید.',
    receiptExitTitle: 'رسید خروج',
    receiptActualExit: 'خروج واقعی:',
    receiptSettlementSection: 'تسویه',
    receiptExitLockersSection: 'تجهیزات آزاد شده',
    receiptExitFooter: 'با تشکر. این رسید را برای سوابق نگه دارید.',
    receiptExitChildStay: 'مدت حضور:',
    receiptExitTableName: 'نام',
    receiptExitTableAge: 'سن',
    receiptExitTableStay: 'مدت',
    receiptEntryTableNotes: 'یادداشت',
    exitReceiptPreviewHint:
      'رسید حرارتی روی چاپگر ایستگاه (از طریق درایور حضوری) چاپ می‌شود. هنگام آماده بودن «چاپ» را بزنید.',
    receiptQrMissing: 'QR در دسترس نیست',
    entryReceiptTitle: 'چاپ رسید',
    entryReceiptSubtitle: 'رسید با یک QR برای ویزیت چاپ کنید (جستجوی سریع‌تر هنگام خروج).',
    entryReceiptPrint: 'چاپ',
    entryReceiptSkip: 'رد کردن',
    entryReceiptPrinting: 'در حال آماده‌سازی چاپ…',
    exitBarcodeLabel: 'اسکن یا چسباندن QR ویزیت',
    exitBarcodePlaceholder: 'بارکد را اسکن یا بچسبانید…',
    exitBarcodeVerified: 'تأیید شد',
    exitBarcodeScan: 'تأیید',
    exitBarcodeBypass: 'عبور (مدیر)',
    exitBarcodeBypassTitle: 'بدون اسکن بارکد؟',
    exitBarcodeBypassBody:
      'فقط در صورت اطمینان هویت به روش دیگر استفاده کنید. این اقدام ثبت می‌شود.',
    exitBarcodeBypassReasonLabel: 'دلیل (الزامی)',
    exitBarcodeBypassConfirm: 'تأیید عبور',
    exitBarcodeBypassCancel: 'انصراف',
    activeSessionsChildExitNeedBarcode: 'قبل از خروج بارکد را تأیید کنید.',
    exitBarcodeMismatch: 'بارکد با این کودک مطابقت ندارد.',
    exitBarcodeVerifyFailed: 'تأیید بارکد ناموفق بود. دوباره تلاش کنید.',
    exitBarcodeEmpty: 'ابتدا بارکد را وارد یا اسکن کنید.',
    exitChildScanTitle: 'تأیید خروج',
    exitChildScanSubtitle: 'روش خواندن QR این کودک را انتخاب کنید.',
    exitChildScanChooseCamera: 'استفاده از دوربین',
    exitChildScanChooseBarcode: 'اسکن‌گر بارکد / چسباندن',
    exitChildScanBack: 'بازگشت',
    exitChildScanCameraHint: 'دوربین را به سمت QR روی رسید بگیرید.',
    exitChildScanCameraPermissionDenied:
      'دسترسی به دوربین رد شد. در تنظیمات مرورگر اجازه دهید یا در صورت فعال بودن از اسکن‌گر بارکد استفاده کنید.',
    exitChildScanCameraNoDevice: 'دوربینی روی این دستگاه یافت نشد.',
    exitChildScanVerifying: 'در حال تأیید…',
    exitChildScanVerifiedExitFailedIntro:
      'بارکد تأیید شد، اما تکمیل خروج ممکن نشد:',
    exitChildScanExitRetryHint: 'این پنجره را ببندید و دوباره «خروج» را بزنید.',
    exitChildScanVerifyChildNotFound: 'این کودک در این بازدید یافت نشد.',
    exitChildScanExitChildNotFound: 'کودک برای خروج یافت نشد.',
    exitChildScanExitNeedsVerify: 'قبل از خروج هنوز تأیید بارکد لازم است.',
    exitChildScanExitBypassNotAllowed: 'برای عبور در خروج تأیید مدیر لازم است.',
    exitLookupByQr: 'اسکن QR ویزیت',
    exitLookupByQrBack: 'بازگشت به جستجو',
    exitLookupByQrHint: 'دوربین را به QR ویزیت روی رسید ورود بگیرید.',
    exitCustomerQrLookupFailed: 'جستجو با این QR انجام نشد. دوباره تلاش کنید یا از تلفن استفاده کنید.',
    exitCustomerQrInvalid: 'این QR معتبر نیست.',
    exitCustomerQrNotFound: 'ویزیت پیدا نشد.',
    exitCustomerQrNotActive: 'جلسه فعالی برای این QR نیست.',
    exitCustomerQrMismatch: 'QR با شماره تلفن مشتری هم‌خوانی ندارد.',
    entryProgressLabel: 'مراحل ورود',
    entryClose: 'بستن',
    entryPhoneLabel: 'تلفن مشتری',
    entryLookupLabel: 'تلفن یا نام',
    entryLookupPlaceholder: 'جستجو با تلفن یا نام مشتری',
    entryLookupQueryRequired: 'برای جستجو شماره تلفن یا نام را وارد کنید.',
    entryLookupHint:
      'شماره تلفن یا نام/نام‌خانوادگی را بنویسید. از پیشنهادها انتخاب کنید یا «جستجو» را بزنید.',
    entryMultipleMatches:
      'چند مشتری مطابق است. یکی را از فهرست انتخاب کنید یا عبارت را دقیق‌تر کنید.',
    entryTooManyMatches: 'مطابق‌ها زیاد است. حروف یا ارقام بیشتری وارد کنید.',
    entryPhonePlaceholder: 'شماره تلفن را وارد کنید',
    entryLookupButton: 'ادامه',
    entryLookupLoading: 'در حال جستجو...',
    entryLookupFound: 'مشتری پیدا شد.',
    entryLookupNotFound: 'مشتری یافت نشد. برای ادامه مشتری جدید بسازید.',
    entryLookupFailed: 'یافتن مشتری ناموفق بود. دوباره تلاش کنید.',
    entryPhoneRequired: 'شماره تلفن را وارد کنید.',
    entryPhoneInvalid: 'شماره تلفن معتبر وارد کنید (۱۱ رقم با شروع از ۰، یا ۱۰ رقم).',
    entryCustomerFound: 'مشتری آماده است',
    entryCustomerReady: 'جزئیات را پیش از انتخاب کودک بررسی کنید.',
    entryCustomerReviewBeforeChildren:
      'جزئیات را بررسی کنید و کودکان را انتخاب کنید. پس از تکمیل قیمت‌گذاری ذخیره می‌شود.',
    entryCustomerNameLabel: 'نام',
    entryCustomerPhoneLabel: 'تلفن',
    entryCustomerCodeLabel: 'شناسه مشتری',
    entryContinueButton: 'ادامه ورود',
    entryCreateButton: 'ایجاد مشتری',
    entryCreateTitle: 'ایجاد مشتری',
    entryCreateSubtitle: 'پیش از شروع ورود، مشتری را ثبت کنید.',
    entryCreateSubmit: 'ذخیره مشتری',
    entryCreateSaving: 'در حال ذخیره...',
    entryCreateSuccess: 'مشتری ایجاد شد.',
    entryCreateFailed: 'ایجاد مشتری ناموفق بود.',
    entryCreatePhoneExists: 'این تلفن قبلا ثبت شده است.',
    entryCreateMissing: 'همه فیلدهای ضروری را تکمیل کنید.',
    entryBackToLookup: 'بازگشت به جستجو',
    exitStartTitle: 'خروج مشتری',
    exitStartButton: 'خروج مشتری',
    exitStartSearchByPhone: 'جستجو با تلفن یا نام',
    exitLookupLabel: 'تلفن یا نام',
    exitLookupPlaceholder: 'جستجو با تلفن یا نام مشتری',
    exitStartScanQr: 'اسکن QR',
    exitModalTitle: 'جریان خروج',
    exitLookupNotFound: 'هیچ بازدید فعالی برای این تلفن یا نام یافت نشد.',
    exitLookupFailed: 'جستجو ناموفق بود. دوباره تلاش کنید.',
    exitPhoneRequired: 'شماره تلفن یا نام را وارد کنید.',
    entryEditButton: 'ویرایش مشتری',
    entryEditTitle: 'ویرایش مشتری',
    entryEditSubtitle: 'جزئیات را پیش از ادامه به‌روزرسانی کنید.',
    entryEditSave: 'ذخیره تغییرات',
    entryEditSaving: 'در حال ذخیره...',
    entryEditSuccess: 'مشتری به‌روزرسانی شد.',
    entryEditFailed: 'به‌روزرسانی مشتری ناموفق بود.',
    entryEditPhoneExists: 'این تلفن قبلا ثبت شده است.',
    entryEditMissing: 'نام خانوادگی و تلفن ضروری است.',
    entryEditCancel: 'انصراف',
    entryChildrenTitle: 'انتخاب کودکان',
    entryChildrenSubtitle: 'اگر کودک همراه است، او را به این ورود اضافه کنید.',
    entryDurationTitle: 'مدت زمان مورد انتظار',
    entryDurationBack: 'بازگشت به کودکان',
    entryDurationContinue: 'شروع ورود',
    entryDurationMinutesSuffix: 'دقیقه',
    entryPaymentPaid: 'پرداخت شد',
    entryEnteredButton: 'ورود بدون پرداخت',
    entryEnteredSubmitting: 'در حال ثبت ورود...',
    entryEnteredSuccess: 'ورود بدون پرداخت ثبت شد.',
    entryEnteredActionsHint: 'بازدید را بدون دریافت وجه در پیشخوان ثبت می‌کند.',
    entryCustomerBannedBlocked: 'این مشتری مسدود است. نمی‌توانید بازدید را شروع کنید.',
    entryCustomerOpenVisitBlocked:
      'این مشتری بازدید باز دارد. پیش از شروع بازدید جدید، همان را ببندید.',
    entryLockersTitle: 'تخصیص کمد',
    entryLockersSubtitle:
      'محل کمد و تعداد موردنیاز را انتخاب کنید. خلاصه را ببینید و انجام را بزنید—یا در صورت عدم نیاز این مرحله را رد کنید.',
    entryLockersPrepareHint:
      'قبل از پرداخت کمدها را انتخاب کنید؛ با شروع بازدید در بخش زیر به‌صورت خودکار تخصیص داده می‌شوند.',
    entryLockersAssignedDone: 'کمدها برای این بازدید تخصیص داده شد.',
    entryLockersLoading: 'در حال بارگذاری مجموعه کمدها...',
    entryLockersNoSets: 'مجموعه‌ای برای کمد تعریف نشده است.',
    entryLockersSetLabel: 'مجموعه کمد',
    entryLockersSetPlaceholder: 'انتخاب مجموعه',
    entryLockersSetFallback: 'مجموعه کمد {id}',
    entryLockersSetAvailable: 'موجود: {count}',
    entryLockersQuantityDecrease: 'کاهش تعداد',
    entryLockersQuantityIncrease: 'افزایش تعداد',
    entryLockersSummaryTitle: 'خلاصه تخصیص',
    entryLockersSummaryTotal: 'جمع: {count} کمد از {sets} محل',
    entryLockersSummaryTotalSingleLocker: 'جمع: {count} کمد از {sets} محل',
    entryLockersSummaryTotalSingleArea: 'جمع: {count} کمد از {sets} محل',
    entryLockersSummaryTotalSingleLockerSingleArea: 'جمع: {count} کمد از {sets} محل',
    entryLockersWarningInsufficient:
      'بیش از ظرفیت {set} انتخاب کرده‌اید (فقط {available} عدد موجود است).',
    entryLockersCountLabel: 'تعداد',
    entryLockersAddSet: 'افزودن مجموعه',
    entryLockersRemoveRow: 'حذف',
    entryLockersSkip: 'رد کردن',
    entryLockersDone: 'انجام',
    entryLockersAssigning: 'در حال تخصیص...',
    entryLockersErrorMaxExceeded: 'حداکثر کمد به ازای هر مشتری رعایت نشد.',
    entryLockersErrorInsufficient: 'تعداد کمد موجود در این مجموعه کافی نیست.',
    entryLockersErrorVisitNotFound: 'بازدید یافت نشد.',
    entryLockersErrorNoContiguous: 'در این مجموعه بلوک متوالی کمد خالی موجود نیست.',
    entryLockersErrorGeneric: 'تخصیص کمد ناموفق بود.',
    entryDiscountLabel: 'کد تخفیف',
    entryDiscountPlaceholder: 'کد تخفیف را وارد کنید',
    entryDiscountApply: 'اعمال',
    entryDiscountRemove: 'حذف تخفیف',
    entryPriceLabel: 'قیمت محاسبه‌شده',
    entryPricePlaceholder: '—',
    entryPriceLoading: 'در حال محاسبه...',
    entryPriceUnavailable: 'نامشخص',
    entryDiscountedPriceLabel: 'قیمت با تخفیف',
    entryDiscountedPricePlaceholder: '—',
    entryFinalPriceLabel: 'قیمت نهایی',
    entryFinalPricePlaceholder: '—',
    entryPaymentTypeLabel: 'نوع پرداخت',
    entryPaymentTypePlaceholder: 'روش پرداخت را انتخاب کنید',
    entryPaymentTypeCash: 'نقدی',
    entryPaymentTypeCard: 'کارت',
    entryPaymentTypeOnline: 'آنلاین',
    entryPaymentTypeOther: 'سایر',
    entryDurationOption30: '۳۰ دقیقه',
    entryDurationOption45: '۴۵ دقیقه',
    entryDurationOption60: '۱ ساعت',
    entryDurationOption120: '۲ ساعت',
    entryExpectedDurationLabel: 'مدت زمان مورد انتظار (دقیقه)',
    entryExpectedDurationPlaceholder: 'مثلا ۹۰',
    entryExpectedDurationRequired: 'برای ادامه مدت زمان مورد انتظار را وارد کنید.',
    entryChildrenEmpty: 'هنوز کودکی ثبت نشده است. می‌توانید بدون افزودن ادامه دهید.',
    entryChildrenLoading: 'در حال دریافت کودکان...',
    entryChildrenLoadFailed: 'دریافت کودکان ناموفق بود.',
    entryChildAddButton: 'افزودن کودک',
    entryChildEditButton: 'ویرایش',
    entryChildAgeYears: '{age} ساله',
    entryChildAgeMonths: '{months} ماهه',
    entryChildAgeMonthSingular: '{months} ماهه',
    entryChildAgeYearSingular: '{age} ساله',
    entryChildAgeYearSingularMonthSingular: '{age} سال و {months} ماهه',
    entryChildAgeYearSingularMonthPlural: '{age} سال و {months} ماهه',
    entryChildAgeYearsMonthSingular: '{age} سال و {months} ماهه',
    entryChildAgeYearsMonthPlural: '{age} سال و {months} ماهه',
    entryChildSelectionRequired: 'برای ادامه حداقل یک کودک را انتخاب کنید.',
    entryVisitRequiresCustomer: 'پیش از شروع بازدید، مشتری را انتخاب یا ایجاد کنید.',
    entryVisitEntryPrerequisites:
      'پیش از شروع بازدید (با پرداخت یا بدون آن)، مشتری و حداقل یک کودک را انتخاب کنید.',
    entryChildSpecialConditionsBadge: 'شرایط خاص',
    entryChildFormTitle: 'افزودن کودک',
    entryChildFormEditTitle: 'ویرایش کودک',
    entryChildFormSubtitle: 'پیش از شروع ورود، کودک را اضافه کنید.',
    entryChildFormEditSubtitle: 'پیش از شروع ورود، جزئیات کودک را اصلاح کنید.',
    entryChildFormSave: 'ذخیره کودک',
    entryChildFormCancel: 'انصراف',
    entryChildFormMissing: 'نام، نام خانوادگی و تاریخ تولد ضروری است.',
    entryChildCreating: 'در حال ذخیره...',
    entryChildEditing: 'در حال ذخیره...',
    entryChildCreateSuccess: 'کودک اضافه شد.',
    entryChildCreateFailed: 'افزودن کودک ناموفق بود.',
    entryChildUpdateFailed: 'به‌روزرسانی کودک ناموفق بود.',
    entryChildFirstNameLabel: 'نام',
    entryChildLastNameLabel: 'نام خانوادگی',
    entryChildGenderLabel: 'جنسیت',
    entryChildGenderPlaceholder: 'انتخاب جنسیت',
    entryChildGenderMale: 'پسر',
    entryChildGenderFemale: 'دختر',
    entryChildGenderOther: 'سایر',
    entryChildGenderUnspecified: 'نامشخص',
    entryChildGenderRequired: 'جنسیت این کودک را انتخاب کنید.',
    entryChildBirthdayLabel: 'تاریخ تولد',
    entryChildSpecialConditionsLabel: 'شرایط خاص (اختیاری)',
    entryFirstNameLabel: 'نام',
    entryLastNameLabel: 'نام خانوادگی',
    entryEmergencyNameLabel: 'نام تماس اضطراری',
    entryEmergencyPhoneLabel: 'تلفن تماس اضطراری',
    entryEmergencyPhoneInvalid:
      'شماره تلفن تماس اضطراری معتبر وارد کنید (۱۱ رقم با شروع از ۰، یا ۱۰ رقم).',
    entryOptionalSuffix: ' (اختیاری)',
    entryNotesLabel: 'یادداشت (اختیاری)',
    entrySuggestionsLabel: 'پیشنهادها',
    entrySuggestionsLoading: 'در حال دریافت پیشنهادها...',
    entrySuggestionsEmpty: 'هنوز موردی یافت نشد.',
    entrySessionStarting: 'در حال شروع ورود...',
    entrySessionStarted: 'نشست ورود آغاز شد.',
    entrySessionFailed: 'شروع ورود ناموفق بود. دوباره تلاش کنید.',
    entrySessionActiveExists: 'یک نشست فعال برای این ورود وجود دارد.',
    entryVisitOpening: 'در حال باز کردن ورود...',
    entryVisitOpenFailed: 'باز کردن ورود ناموفق بود. دوباره تلاش کنید.',
    entryVisitTimeNotAllowed:
      'در این ساعت امکان شروع ورود نیست؛ خارج از بازهٔ مجاز «ورود و بازدید» در تنظیمات سیستم است.',
    entryVisitPending: 'برای باز شدن ورود، پرداخت اولیه لازم است.',
    entryVisitCreateFailed: 'در حال حاضر امکان شروع ورود وجود ندارد.',
    activeSessionsTitle: 'نشست‌های فعال',
    activeSessionsSubtitle: 'حضورهای فعال را در لحظه بررسی کنید.',
    activeSessionsGuestsInside: 'مهمانان حاضر',
    activeSessionsChildrenInside: 'کودکان حاضر',
    activeSessionsListLabel: 'نشست‌های فعال',
    activeSessionsTotalLabel: 'مجموع',
    activeSessionsLoading: 'در حال بارگذاری نشست‌های فعال...',
    activeSessionsEmpty: 'در حال حاضر نشستی فعال نیست.',
    activeSessionsLoadFailed: 'بارگذاری نشست‌های فعال ناموفق بود.',
    activeSessionsCustomerLabel: 'مشتری',
    activeSessionsPhoneLabel: 'تلفن',
    activeSessionsEntryCounterLabel: 'پیشخوان ورود',
    activeSessionsEntryLabel: 'زمان ورود',
    activeSessionsLockersLabel: 'کمدها',
    activeSessionsWristbandLabel: 'دست‌بند',
    activeSessionsStatusLabel: 'وضعیت ورود',
    activeSessionsActionsLabel: 'اقدام‌ها',
    activeSessionsManageLockers: 'مدیریت کمد',
    activeSessionsManageWristband: 'مدیریت دست‌بند',
    activeSessionsManageChildren: 'مدیریت کودکان',
    activeSessionsExitAction: 'خروج',
    activeSessionsViewProfile: 'مشاهده پروفایل',
    activeSessionsCaptionLockers: 'کمدها',
    activeSessionsCaptionWristband: 'دستبند',
    activeSessionsCaptionChildren: 'کودکان',
    activeSessionsCaptionProfile: 'پروفایل',
    activeSessionsCaptionExit: 'خروج',
    activeSessionsModalClose: 'بستن',
    activeSessionsLockersModalTitle: 'مدیریت کمد',
    activeSessionsLockersAssignLabel: 'تخصیص کمد',
    activeSessionsLockersRelease: 'آزاد کردن',
    activeSessionsLockersPlaceholder: 'مدیریت کمدها در این بخش اضافه می‌شود.',
    sessionLockersSummaryMain: '{total} کمد',
    sessionLockersSummaryMainSingular: '{total} کمد',
    sessionLockersSummaryAvailable: '{total} قابل تخصیص',
    sessionLockersAddMore: 'افزودن',
    sessionLockersHideAdd: 'بستن بخش افزودن',
    sessionLockersReleaseAll: 'آزاد کردن همه',
    sessionLockersReleaseAllConfirm:
      'همه کمدهای تخصیص‌یافته به این بازدید آزاد شوند؟ این عمل از اینجا قابل بازگشت نیست.',
    sessionLockersReleaseAllSuccess: 'همه کمدها آزاد شدند.',
    sessionLockersReleaseAllError: 'آزاد کردن همه کمدها ناموفق بود.',
    sessionLockersReleaseOneError: 'آزاد کردن کمد ناموفق بود.',
    sessionLockersReleaseOneSuccess: 'کمد آزاد شد.',
    sessionLockersNoAssignments: 'هنوز کمدی به این بازدید تخصیص داده نشده است.',
    sessionLockersAssignedSectionTitle: 'کمدهای تخصیص‌یافته',
    sessionLockersAddSectionTitle: 'افزودن کمد',
    sessionLockersAssignSelected: 'تخصیص انتخاب‌شده‌ها',
    sessionLockersGroupCount: '{count} کمد',
    sessionLockersGroupCountSingular: '{count} کمد',
    sessionLockersUnknownSet: 'ناحیه کمد',
    sessionLockersAssignPartialError:
      'ناقص: {done} از {total} مجموعه کمد قبل از خطا تخصیص داده شد. {detail}',
    sessionLockersDone: 'تأیید',
    activeSessionsWristbandModalTitle: 'مدیریت دست‌بند',
    activeSessionsWristbandPlaceholder: 'مدیریت دست‌بند در این بخش اضافه می‌شود.',
    activeSessionsChildrenModalTitle: 'مدیریت کودکان',
    activeSessionsChildrenPlaceholder: 'مدیریت کودکان نشست در این بخش اضافه می‌شود.',
    activeSessionsChildrenLoading: 'در حال بارگذاری کودکان نشست...',
    activeSessionsChildrenEmpty: 'هیچ کودکی برای این بازدید ثبت نشده است.',
    activeSessionsChildrenLoadFailed: 'بارگذاری کودکان نشست ناموفق بود.',
    sessionAddChildButton: 'افزودن کودک',
    sessionAddChildTitle: 'افزودن کودک به این بازدید',
    sessionAddChildFirstName: 'نام',
    sessionAddChildLastName: 'نام خانوادگی',
    sessionAddChildBirthday: 'تاریخ تولد',
    sessionAddChildBirthdayRequired: 'تاریخ تولد ضروری است.',
    sessionAddChildGenderRequired: 'جنسیت این کودک را انتخاب کنید.',
    sessionAddChildSpecialConditions: 'شرایط خاص (اختیاری)',
    sessionAddChildSubmit: 'افزودن کودک',
    sessionAddChildCancel: 'انصراف',
    sessionAddChildSaving: 'در حال ذخیره…',
    sessionAddChildSuccess: 'کودک به بازدید اضافه شد.',
    sessionAddChildFailed: 'افزودن کودک ناموفق بود.',
    sessionAddChildVisitNotPlay:
      'بازی برای این بازدید شروع نشده است (یا نشست تمام شده).',
    sessionAddChildMismatch: 'کودک انتخاب‌شده قابل افزودن نیست.',
    sessionAddChildVisitNotFound: 'بازدید یافت نشد.',
    sessionAddChildValidation: 'نام و نام خانوادگی را بررسی کنید.',
    sessionAddChildTabRegistered: 'کودک ثبت‌شده',
    sessionAddChildTabNew: 'کودک جدید',
    sessionAddChildLoadingRegistered: 'در حال بارگذاری کودکان ثبت‌شده…',
    sessionAddChildRegisteredLoadFailed: 'بارگذاری کودکان این مشتری ناموفق بود.',
    sessionAddChildRegisteredAllOnVisit:
      'تمام کودکان ثبت‌شده قبلاً در این بازدید هستند. برای فرد دیگر از «کودک جدید» استفاده کنید.',
    sessionAddChildRegisteredHint:
      'یکی از نمایه‌های ذخیره‌شده را انتخاب کنید که در این بازدید فعال نیست.',
    activeSessionsChildActive: 'فعال',
    activeSessionsChildExited: 'خارج شده',
    activeSessionsChildExitAction: 'ثبت خروج',
    activeSessionsChildExitLoading: 'در حال ذخیره...',
    activeSessionsChildAlreadyExited: 'کودک قبلا خارج شده است.',
    activeSessionsChildSessionInactive: 'نشست دیگر فعال نیست.',
    activeSessionsChildExitSuccess: 'خروج کودک ثبت شد.',
    activeSessionsChildExitFailed: 'ثبت خروج کودک ناموفق بود.',
    childCardAgeLabel: 'سن',
    childCardGenderLabel: 'جنسیت',
    childCardSpecialConditionsLabel: 'شرایط خاص',
    childCardNoSpecialConditions: 'ندارد',
    childCardNotSpecified: 'مشخص نشده',
    childrenListNameColumn: 'کودک',
    childrenListStatusColumn: 'وضعیت',
    activeSessionsExitModalTitle: 'خروج از نشست',
    activeSessionsExitPlaceholder: 'فرایند خروج در این بخش اضافه می‌شود.',
    activeSessionsExitExpected: 'مدت مورد انتظار',
    activeSessionsExitTotal: 'مدت حضور',
    activeSessionsExitExtra: 'زمان اضافه',
    activeSessionsExitPricingBase: 'هزینه ورود',
    activeSessionsExitPricingBasePaid: 'هزینه ورود (پرداخت‌شده)',
    activeSessionsExitPricingBasePending: 'هزینه ورود (درانتظار)',
    activeSessionsExitPricingBeforeDiscount: 'جمع قبل از تخفیف',
    activeSessionsExitPricingDiscount: 'تخفیف',
    activeSessionsExitPricingFinal: 'جمع پس از تخفیف',
    activeSessionsExitPricingAdditional: 'مابه‌التفاوت پس از ورود',
    activeSessionsExitPricingPaid: 'پرداخت‌شده',
    activeSessionsExitPricingRemaining: 'مانده',
    activeSessionsExitPricingBreakdown: 'ریز محاسبات',
    activeSessionsExitPricingPerChild: 'جمع به ازای کودک',
    activeSessionsExitPricingMinutes: 'دقایق',
    activeSessionsExitPricingBilledMinutesHint: 'دقیقه در محاسبه',
    activeSessionsExitPricingTier: 'سطح',
    activeSessionsExitPricingChildren: 'کودکان',
    activeSessionsExitPricingAmount: 'مبلغ',
    activeSessionsExitPricingLoading: 'در حال محاسبه قیمت...',
    exitFlowContinueToPayment: 'ادامه به پرداخت',
    exitFlowBackToDetails: 'بازگشت',
    activeSessionsExitConfirm: 'تایید خروج',
    activeSessionsExitSubmitting: 'در حال خروج...',
    activeSessionsExitRequiresPayment: 'این ویزیت باید همراه با پرداخت تسویه شود.',
    activeSessionsExitPaymentDoesNotSettle: 'پرداخت مانده حساب ویزیت را تسویه نمی‌کند.',
    activeSessionsExitCheckoutConfirm: 'ثبت پرداخت و خروج',
    activeSessionsExitCheckoutSubmitting: 'در حال ثبت پرداخت و خروج…',
    activeSessionsExitCompleted: 'خروج ثبت شد.',
    activeSessionsExitSuccess: 'خروج نشست ثبت شد.',
    activeSessionsExitLockersOpened: 'کمدهای باز و آزاد شده',
    activeSessionsExitFailed: 'ثبت خروج نشست ناموفق بود.',
    activeSessionsExitPreviewFailed: 'امکان دریافت قیمت خروج نیست.',
    activeSessionsExitPlanMissing: 'طرح پیش‌فرض فعال یافت نشد.',
    activeSessionsExitPlanMultiple: 'چند طرح قیمت‌گذاری با این زمان منطبق است.',
    activeSessionsExitMissingEntry: 'زمان ورود ثبت نشده است.',
    activeSessionsExitStepsMissing: 'مراحل قیمت‌گذاری تعریف نشده است.',
    activeSessionsExitChildrenActive: 'ابتدا خروج همه کودکان را ثبت کنید.',
    sessionExitChildActionsColumn: 'اقدام',
    exitPaymentsPricingDetailsToggle: 'جزئیات قیمت (ریز و به ازای کودک)',
    exitAssignedUtilitiesTitle: 'تجهیزات تخصیص‌یافته',
    exitUtilitiesLoading: 'در حال بارگذاری تجهیزات...',
    exitUtilitiesEmpty: 'تجهیزاتی برای این بازدید تخصیص داده نشده است.',
    exitUtilitiesLoadFailed: 'بارگذاری تخصیص تجهیزات ناموفق بود.',
    exitReviewTitle: 'بازبینی و تأیید',
    exitReviewBack: 'بازگشت',
    exitReviewPrintReceipt: 'چاپ رسید',
    exitReceiptTitle: 'خروج انجام شد',
    exitReceiptDisabledHint:
      'رسید خروج در تنظیمات غیرفعال است. پس از اتمام کار این مرحله را ببندید — رسیدی چاپ نمی‌شود.',
    systemSettingsExitReceiptEnabledLabel: 'نمایش و چاپ رسید خروج پس از تسویه',
    systemSettingsExitReceiptEnabledHint:
      'در صورت غیرفعال، پس از بستن ویزیت مرحلهٔ پیش‌نمایش و چاپ رسید خروج نمایش داده نمی‌شود. رسید ورود تغییری نمی‌کند.',
    systemSettingsReceiptPreviewEnabledLabel: 'تأیید رسید پیش از چاپ',
    systemSettingsReceiptPreviewEnabledHint:
      'در صورت فعال، قبل از ارسال کار چاپ رسید به درایور چاپگر حضوری، مرحلهٔ تأیید نمایش داده می‌شود.',
    entryReceiptAutoPrintHint: 'رسید به‌صورت خودکار چاپ می‌شود. در صورت عدم نیاز می‌توانید رد کنید.',
    receiptAutoPrinting: 'در حال چاپ…',
    exitReceiptReportIntro:
      'نشست با موفقیت بسته شد. در ادامه مبلغ نهایی، پرداخت‌ها و تجهیزات آزادشده آمده است.',
    exitReceiptPaymentsSum: 'جمع پرداخت‌ها',
    exitReceiptDone: 'بستن',
    exitFreedUtilitiesTitle: 'تجهیزات آزاد شده',
    exitFreedUtilitiesEmpty: 'آزادسازی تجهیزاتی برای این خروج ثبت نشده است.',
    exitFlowNextButton: 'ادامه',
    activeSessionsExitInactive: 'نشست از قبل بسته شده است.',
    activeSessionsValuePlaceholder: '—',
    activeSessionsCustomerFallback: 'نامشخص',
    activeSessionsReprintEntry: 'چاپ مجدد رسید ورود',
    activeSessionsCaptionReprintEntry: 'چاپ مجدد',
    activeSessionsReprintEntrySuccess: 'رسید ورود به چاپگر ارسال شد.',
    activeSessionsReprintEntryFailed: 'چاپ مجدد رسید ورود ناموفق بود.',
    customersTitle: 'مدیریت مشتریان',
    customersSubtitle: 'مشتریان و سابقه بازدید آن‌ها را بررسی کنید.',
    customersListLabel: 'مشتریان',
    customersListLoading: 'در حال بارگذاری مشتریان...',
    customersListEmpty: 'مشتری ثبت نشده است.',
    customersListError: 'بارگذاری مشتریان ناموفق بود.',
    customersListTotal: 'مجموع',
    customersListEmptyFiltered: 'هیچ مشتری با فیلترهای فعلی در این صفحه نیست.',
    customersImportButton: 'ورود مشتریان',
    customersImportTitle: 'ورود مشتریان',
    customersImportIntro: 'فایل اکسل شامل نام، نام خانوادگی و شماره تلفن مشتریان را بارگذاری کنید.',
    customersImportLimitHint: 'حداکثر {limit} مشتری در هر بار ورود.',
    customersImportDownloadTemplate: 'دانلود قالب اکسل',
    customersImportDownloading: 'در حال دانلود قالب...',
    customersImportDownloadFailed: 'دانلود قالب ورود ناموفق بود.',
    customersImportDropTitle: 'فایل اکسل را اینجا بکشید و رها کنید',
    customersImportDropHint: 'یا برای انتخاب فایل کلیک کنید (فقط .xlsx)',
    customersImportPhoneHint: 'ستون تلفن را در اکسل روی Text بگذارید تا صفر ابتدایی حفظ شود.',
    customersImportSelectedFile: 'انتخاب‌شده: {name}',
    customersImportInvalidFile: 'لطفاً یک فایل اکسل معتبر (.xlsx) انتخاب کنید.',
    customersImportFileLabel: 'فایل اکسل (.xlsx)',
    customersImportSubmit: 'ورود',
    customersImportImporting: 'در حال ورود...',
    customersImportCancel: 'بستن',
    customersImportFailed: 'ورود مشتریان ناموفق بود.',
    customersImportSuccessSummary: '{accepted} مشتری وارد شد. {skipped} مورد تکراری نادیده گرفته شد.',
    customersImportSkippedDetails: 'ردیف‌های نادیده گرفته‌شده',
    customersImportSkippedRow: 'ردیف {row}: {reason}',
    customersFilterSearch: 'جستجو',
    customersSearchAction: 'جستجو',
    customersFilterSearchPlaceholder: 'نام، کد یا تلفن…',
    customersFilterStatus: 'وضعیت',
    customersFilterStatusAll: 'همه',
    customersFilterStatusActive: 'فعال',
    customersFilterStatusBanned: 'مسدود',
    customersFilterClear: 'پاک کردن فیلترها',
    customersNameFallback: 'مشتری بدون نام',
    customersProfileTitle: 'پروفایل مشتری',
    customersProfileLoading: 'در حال بارگذاری پروفایل...',
    customersProfileLoadFailed: 'بارگذاری پروفایل مشتری ناموفق بود.',
    customersBack: 'بازگشت به فهرست',
    customersTabDetails: 'پروفایل',
    customersTabVisits: 'بازدیدها',
    customersTabPendingPayments: 'پرداخت‌نشده و معلّق',
    customersVisitStatusLeftUnpaid: 'ترک با مانده حساب',
    customersPendingTitle: 'تراکنش‌های پرداخت‌نشده و معلّق',
    customersPendingLoading: 'در حال بارگذاری مانده‌ها...',
    customersPendingEmpty: 'ماندهٔ پرداخت‌نشده‌ای ثبت نیست.',
    customersPendingFailed: 'بارگذاری مانده‌های پرداخت‌نشده ناموفق بود.',
    customersPendingExpand: 'جزئیات و پرداخت',
    customersPendingCollapse: 'بستن',
    customersPendingTxnLabel: 'تراکنش',
    customersPendingVisitShort: 'ویزیت',
    customersPendingAutoBadge: 'بستن خودکار',
    customersPendingChargesToggle: 'ردیف هزینه‌ها',
    pendingTransactionAdjustPriceButton: 'تنظیم قیمت',
    pendingTransactionChargeNotAdjustable:
      'این ردیف قابل اصلاح نیست (مثلاً پس از آن پرداختی ثبت شده است).',
    pendingTransactionChargeNotFound: 'ردیف هزینه یافت نشد.',
    pendingTransactionPriceCorrectionDisabled: 'اصلاح قیمت در تنظیمات غیرفعال است.',
    pendingTransactionPriceCorrectionForbidden: 'مجوز اصلاح قیمت را ندارید.',
    customersChildrenTitle: 'کودکان',
    customersChildrenEmpty: 'کودکی ثبت نشده است.',
    customersChildEdit: 'ویرایش',
    customersChildDelete: 'حذف',
    customersChildDeleteConfirm: 'این کودک حذف شود؟',
    customersChildEditTitle: 'ویرایش کودک',
    customersChildEditSave: 'ذخیره تغییرات',
    customersChildEditCancel: 'انصراف',
    customersChildUpdateSuccess: 'کودک به‌روزرسانی شد.',
    customersChildUpdateFailed: 'به‌روزرسانی کودک ناموفق بود.',
    customersChildDeleteSuccess: 'کودک حذف شد.',
    customersChildDeleteFailed: 'حذف کودک ناموفق بود.',
    customersChildBirthdayUnknown: 'تاریخ تولد ثبت نشده',
    customersDeleteButton: 'حذف مشتری',
    customersDeleteTitle: 'حذف مشتری',
    customersDeletePrompt:
      'این اقدام مشتری {name} و تمام اطلاعات او را حذف می‌کند و قابل بازگشت نیست.',
    customersDeleteCancel: 'انصراف',
    customersDeleteConfirm: 'حذف',
    customersDeleteDeleting: 'در حال حذف...',
    customersDeleteSuccess: 'مشتری حذف شد.',
    customersDeleteFailed: 'حذف مشتری ناموفق بود.',
    customersBanButton: 'مسدود کردن مشتری',
    customersUnbanButton: 'رفع مسدودیت مشتری',
    customersBanTitle: 'مسدود کردن مشتری',
    customersBanPrompt: 'دلیل مسدود کردن {name} را وارد کنید.',
    customersBanReasonLabel: 'دلیل مسدودیت',
    customersBanReasonPlaceholder: 'دلیل مسدودیت را توضیح دهید',
    customersBanConfirm: 'مسدود کردن',
    customersBanCancel: 'لغو',
    customersBanSubmitting: 'در حال مسدودسازی...',
    customersBanSuccess: 'مشتری مسدود شد.',
    customersBanFailed: 'مسدودسازی مشتری ناموفق بود.',
    customersUnbanSuccess: 'مسدودیت مشتری برداشته شد.',
    customersUnbanFailed: 'رفع مسدودیت مشتری ناموفق بود.',
    customersStatusLabel: 'وضعیت',
    customersStatusAllowed: 'مجاز',
    customersStatusBanned: 'مسدود',
    customersEmergencyContact: 'تماس اضطراری',
    customersNotes: 'یادداشت‌ها',
    customersNotesEmpty: 'یادداشتی ثبت نشده است.',
    customersMetadata: 'ابرداده',
    customersCreatedAtLabel: 'ایجاد',
    customersUpdatedAtLabel: 'به‌روزرسانی',
    customersDetailsShowMore: 'نمایش جزئیات بیشتر',
    customersDetailsShowLess: 'نمایش جزئیات کمتر',
    customersBanReasonMissing: 'دلیلی ثبت نشده است',
    customersVisitsLabel: 'بازدیدها',
    customersVisitsLoading: 'در حال بارگذاری بازدیدها...',
    customersVisitsFailed: 'بارگذاری بازدیدها ناموفق بود.',
    customersVisitsEmpty: 'بازدیدی ثبت نشده است.',
    customersVisitIdLabel: 'شناسه بازدید',
    customersVisitStatusLabel: 'وضعیت',
    customersVisitOpenedLabel: 'شروع',
    customersVisitClosedLabel: 'پایان',
    customersVisitStatusPending: 'در انتظار پرداخت',
    customersVisitStatusOpen: 'باز',
    customersVisitStatusClosed: 'بسته',
    paginationPrevious: 'قبلی',
    paginationNext: 'بعدی',
    paginationPageLabel: 'صفحه',
    paginationPageSizeLabel: 'اندازه صفحه',
    dropdownNoOptions: 'گزینه‌ای یافت نشد',
    navDashboard: 'داشبورد',
    navEntryPage: 'ورود مشتری',
    navExitPage: 'خروج مشتری',
    entryPageTitle: 'ورود مشتری جدید',
    entryPageSubtitle: 'مشتری را پیدا کنید، سپس کودکان و پرداخت را در همین صفحه تکمیل کنید.',
    entryPageBackToDashboard: 'بازگشت به داشبورد',
    exitPageSubtitle: 'بازدید فعال را با تلفن پیدا کنید و تسویه را انجام دهید.',
    exitPageBackToDashboard: 'بازگشت به داشبورد',
    navFinancialManagement: 'مدیریت مالی',
    navDailySalesSummary: 'خلاصه فروش روزانه',
    navCustomers: 'مدیریت مشتریان',
    navPricing: 'قیمت‌گذاری',
    navDiscounts: 'تخفیف‌ها',
    navSalesReports: 'گزارش‌های فروش',
    navFinancialSettings: 'تنظیمات مالی',
    navUtilities: 'تجهیزات',
    navIntegrations: 'یکپارچه‌سازی‌ها',
    navDrivers: 'درایورها',
    navSystemSettings: 'تنظیمات سیستم',
    navUserManagement: 'مدیریت کاربران',
    navBranches: 'شعب',
    navBranchSettings: 'تنظیمات شعبه',
    navAuditLogs: 'گزارش رویدادها',
    navSectionBusiness: 'عملیاتی',
    navSectionAdmin: 'مدیریت',
    navAriaLabel: 'ناوبری اصلی',
    entitlementsUpgradeTitle: 'نیاز به ارتقای پلن',
    entitlementsLockedBadge: 'ارتقای پلن',
    entitlementsLockedNavHint: 'برای دسترسی به این بخش پلن خود را ارتقا دهید.',
    entitlementsQuotaLocked: 'سهمیه بندی تکمیل شد — برای افزودن موارد بیشتر پلن خود را ارتقا دهید.',
    entitlementsFeatureRequired: 'این قابلیت در پلن {plan} شما فعال نیست.',
    entitlementsQuotaReached:
      'به سقف مجاز ({current} از {cap}) در پلن {plan} رسیده‌اید.',
    entitlementsQuotaUsage: '{current} از {cap} استفاده شده',
    entitlementsUpgradeHint: 'برای ارتقای پلن با مدیر سیستم تماس بگیرید.',
    entitlementsPlanUnknown: 'فعلی',
    systemSettingsTitle: 'تنظیمات سیستم',
    systemSettingsSubtitle: 'پیکربندی‌ها و کنترل‌های عملیاتی.',
    systemSettingsThemeTitle: 'تم رابط کاربری',
    systemSettingsThemeSubtitle:
      'تم رنگ برای کنسول کارکنان؛ برای همه کاربران این سایت اعمال می‌شود.',
    systemSettingsThemeVibrantLabel: 'سبز و گل‌سرخی شاداب',
    systemSettingsThemeVibrantDescription:
      'سبزهای روشن، گل‌سرخی و مرجانی — ظاهر پرانرژی و تازهٔ پیش‌فرض.',
    systemSettingsThemeWarmLabel: 'قهوه‌ای گرم و کرمی',
    systemSettingsThemeWarmDescription:
      'پالت طلایی و کرم با حس گرم و آشنا.',
    systemSettingsThemeCoolLabel: 'آبی خنک و مرجانی',
    systemSettingsThemeCoolDescription:
      'آبی‌های آرام با لهجه‌های مرجانی نرم.',
    systemSettingsThemeVibrantDarkLabel: 'مرز شبگونه و سرخابی',
    systemSettingsThemeVibrantDarkDescription:
      'پس‌زمینه‌های خاکستری‌سبز نرم با لهجهٔ گلسرخی؛ کنتراست پایدار برای کار طولانی.',
    systemSettingsThemeWarmDarkLabel: 'گردوی برشته و کرم',
    systemSettingsThemeWarmDarkDescription:
      'پانل‌های قهوه‌ای گرم با طلای آرام؛ برای نور کمتر و کمتر شدن خستگی چشم.',
    systemSettingsThemeCoolDarkLabel: 'آبی گرگ‌ومیش و مرجان ملایم',
    systemSettingsThemeCoolDarkDescription:
      'پس‌زمینه آبی‌طوسی آرام با هایلایت اسطوخودوس و مرجان.',
    systemSettingsHint: 'تنظیمات بیشتری به‌زودی در این بخش اضافه می‌شود.',
    systemSettingsEntryVisitTitle: 'ورود و بازدید',
    systemSettingsEntryVisitSubtitle: 'مدت پیش‌فرض و بازه مجاز برای بازدید.',
    systemSettingsFlowTypeTitle: 'چیدمان جریان ورود و خروج',
    systemSettingsFlowTypeSubtitle: 'انتخاب بین مرحله‌به‌مرحله یا یک صفحه برای کارکنان.',
    systemSettingsEntryFlowTypeLabel: 'جریان ورود',
    systemSettingsExitFlowTypeLabel: 'جریان خروج',
    systemSettingsFlowTypeWizard: 'مرحله‌ای',
    systemSettingsFlowTypeSinglePage: 'تک‌صفحه',
    systemSettingsEntryFlowTypeHint:
      'در حالت مرحله‌ای صفحه‌ها پشت‌سرهم هستند. در تک‌صفحه جستجوی مشتری و جزئیات بازدید در یک صفحه است.',
    systemSettingsExitFlowTypeHint:
      'در حالت مرحله‌ای جستجو و تسویه جدا هستند. در تک‌صفحه با هم نمایش داده می‌شوند.',
    systemSettingsFinancialTitle: 'اعتبار و نمایش قابل پرداخت',
    systemSettingsFinancialSubtitle:
      'کیف پول اعتباری مشتری و نحوهٔ نمایش «قابل پرداخت اکنون» وقتی اعتبار خاموش است.',
    systemSettingsCreditSystemEnabledLabel: 'کیف پول اعتباری مشتری',
    systemSettingsCreditSystemEnabledHint:
      'در صورت فعال بودن، پرداخت اضافه به اعتبار کیف پول تبدیل می‌شود و در تسویه قابل استفاده است. در صورت غیرفعال، اعتباری صادر یا مصرف نمی‌شود.',
    systemSettingsCreditSystemEnabled: 'فعال',
    systemSettingsCreditSystemDisabled: 'غیرفعال',
    systemSettingsPayableOverpayDisplayLabel: 'قابل پرداخت هنگام پرداخت اضافه (اعتبار خاموش)',
    systemSettingsPayableOverpayDisplayHint:
      'اگر مشتری بیش از مبلغ ویزیت پرداخت کرده و اعتبار غیرفعال است، در «قابل پرداخت اکنون» صفر یا ماندهٔ منفی خاموش نمایش داده شود.',
    systemSettingsPayableOverpayDisplayHintWhenCreditOn:
      'وقتی کیف پول اعتباری فعال است استفاده نمی‌شود.',
    systemSettingsPayableOverpayDisplayZero: 'نمایش صفر',
    systemSettingsPayableOverpayDisplayNegative: 'نمایش ماندهٔ منفی',
    entrySinglePageSectionCustomer: 'مشتری',
    entrySinglePageSectionChildren: 'کودکان',
    entrySinglePageSectionPayment: 'مدت و پرداخت (در صورت پرداخت زودهنگام)',
    entrySinglePageChangeCustomer: 'تغییر مشتری',
    systemSettingsExpectedDurationLabel: 'مدت زمان پیش‌فرض (دقیقه)',
    systemSettingsExpectedDurationHint: 'هنگام شروع نشست جدید استفاده می‌شود.',
    systemSettingsChildGenderRequiredLabel: 'الزام جنسیت کودک هنگام ورود',
    systemSettingsChildGenderRequiredHint:
      'در صورت فعال بودن، کارکنان باید پسر یا دختر را انتخاب کنند؛ در صورت غیرفعال بودن، کودکان بدون جنسیت مشخص ذخیره می‌شوند.',
    systemSettingsDurationOptionsLabel: 'گزینه‌های مدت زمان (دقیقه)',
    systemSettingsDurationOptionsHint: 'مقادیر با ویرگول جدا شوند.',
    systemSettingsActiveTimeLabel: 'بازه زمانی مجاز',
    systemSettingsActiveTimeStartLabel: 'زمان شروع',
    systemSettingsActiveTimeEndLabel: 'زمان پایان',
    systemSettingsActiveTimeAllDay: 'مجاز بودن در تمام روز',
    systemSettingsReceiptSectionTitle: 'رسیدها',
    systemSettingsReceiptSectionSubtitle:
      'چاپ هنگام ورود و خروج، اندازهٔ کاغذ، مرورگر یا درایور محلی و نمایش اختیاری پیش‌نمایش قبل از چاپ.',
    systemSettingsExitVisitQrSectionTitle: 'QR ویزیت هنگام خروج',
    systemSettingsExitVisitQrSectionIntro:
      'هنگام تسویهٔ بازدید، کارمند ویزیت را با اسکن QR ویزیت (از رسید ورود یا گوشی مشتری) پیدا می‌کند. نحوهٔ ثبت اسکن را انتخاب کنید.',
    systemSettingsEntryVisitQrSectionTitle: 'QR ویزیت هنگام ورود',
    systemSettingsEntryVisitQrSectionIntro:
      'هنگام تخصیص کمد در ورود، QR ویزیت روی رسید بعداً در خروج قابل اسکن است. نحوهٔ ثبت آن QR در جریان ورود را انتخاب کنید.',
    systemSettingsEntryBarcodeInputModeLabel: 'نحوهٔ اسکن QR ویزیت هنگام ورود',
    systemSettingsEntryBarcodeInputModeHint:
      'دوربین برای QR روی گوشی، اسکن‌گر USB یا ورود دستی برای رسید کاغذی، یا هر دو تا کارمند هر بار انتخاب کند.',
    systemSettingsReceiptGenerationLabel: 'چاپ رسید پس از ورود (QR ویزیت)',
    systemSettingsReceiptGenerationHint:
      'در صورت فعال بودن، پس از مرحله کمد مرحلهٔ چاپ نمایش داده می‌شود. رسید یک QR ویزیت دارد (شناسه ویزیت، تلفن و زمان) برای جستجوی خروج — نه QR جدا برای هر کودک.',
    systemSettingsReceiptPaperSizeLabel: 'کاغذ / چیدمان رسید',
    systemSettingsReceiptPaperSizeHint:
      'عرض و اندازه متن هنگام چاپ رسید ورود را تعیین می‌کند (چاپ مرورگر). با کاغذ چاپگر هماهنگ کنید.',
    systemSettingsReceiptPaperSizeOptTHERMAL_80: 'کاغذ حرارتی ۸۰ میلی‌متر',
    systemSettingsReceiptPaperSizeOptTHERMAL_58: 'کاغذ حرارتی ۵۸ میلی‌متر',
    systemSettingsReceiptPaperSizeOptA4: 'A4 / تمام‌عرض',
    systemSettingsReceiptPrintMethodLabel: 'نحوهٔ چاپ رسید',
    systemSettingsReceiptPrintMethodHint:
      'چاپ مرورگر از پنجرهٔ چاپ سیستم استفاده می‌کند. چاپ درایور رسید را به درایور محلی Pilche می‌فرستد (نسخهٔ نمایشی فعلاً در سرور صف می‌کند).',
    systemSettingsReceiptPrintBrowser: 'چاپ مرورگر',
    systemSettingsReceiptPrintDriver: 'درایور محلی (حرارتی)',
    systemSettingsReceiptRenderingModeLabel: 'رندر رسید',
    systemSettingsReceiptRenderingModeHint:
      'هنگام چاپ با درایور: «سرور» مسیر HTML→PDF (قدیمی) است. «درایور» رسید را از JSON محلی رسم می‌کند (پیشنهادی).',
    systemSettingsReceiptRenderingServer: 'رندر روی سرور (قدیمی)',
    systemSettingsReceiptRenderingDriver: 'رندر روی درایور (قالب JSON)',
    systemSettingsReceiptFooterTextLabel: 'متن پاورقی رسید',
    systemSettingsReceiptFooterTextPlaceholder: 'متن سفارشی پاورقی رسید (حداکثر ۲ خط)',
    systemSettingsReceiptFooterTextHint: 'حداکثر ۲ خط، {lines}/۲ خط، {chars}/۳۰۰ نویسه',
    systemSettingsReceiptFooterTextTooLong: 'متن پاورقی رسید باید حداکثر ۳۰۰ نویسه باشد.',
    systemSettingsReceiptFooterTextTooManyLines: 'متن پاورقی رسید باید حداکثر ۲ خط باشد.',
    receiptPrintFailed: 'ارسال رسید به چاپگر ناموفق بود.',
    receiptPrintFallbackPrompt:
      'چاپ از طریق درایور ناموفق بود. با مرورگر چاپ شود؟',
    systemSettingsBarcodeInputModeLabel: 'نحوهٔ اسکن QR ویزیت هنگام خروج',
    systemSettingsBarcodeInputModeHint:
      'دوربین برای QR روی گوشی، اسکن‌گر USB یا ورود دستی برای رسید کاغذی، یا هر دو تا کارمند هر بار انتخاب کند.',
    systemSettingsBarcodeInputModeOptCamera: 'فقط دوربین',
    systemSettingsBarcodeInputModeOptUsbScanner: 'فقط اسکن‌گر USB / ورود دستی',
    systemSettingsBarcodeInputModeOptBoth: 'دوربین و اسکن‌گر USB / ورود دستی (انتخاب کارمند)',
    systemSettingsPricingTitle: 'قیمت‌گذاری',
    systemSettingsPricingSubtitle: 'تنظیم سطح‌های قیمت‌گذاری برای طرح‌های ورود آزاد.',
    systemSettingsPricingTierLabel: 'تعداد سطح‌های قیمت‌گذاری',
    systemSettingsPricingTierHint: 'سطح آخر به صورت N+ در نظر گرفته می‌شود.',
    systemSettingsPricingTierBasisLabel: 'مبنای سطح‌بندی',
    systemSettingsPricingTierBasisHint: 'مشخص کنید هر سطح بر چه اساسی است.',
    systemSettingsExpectedDurationError: 'مدت زمان معتبر وارد کنید.',
    systemSettingsDurationOptionsError: 'حداقل یک مدت زمان معتبر وارد کنید.',
    systemSettingsPricingTierError: 'تعداد سطح‌ها باید بین ۱ تا ۴ باشد.',
    systemSettingsPriceCorrectionBoundsError: 'درصد انحراف باید بین ۰ تا ۱۰۰ باشد.',
    systemSettingsPricingTierBasisError: 'یک مبنا برای سطح‌بندی انتخاب کنید.',
    systemSettingsUtilitiesTitle: 'تجهیزات (کمدها)',
    systemSettingsUtilitiesSubtitle: 'محدودیت‌های تخصیص کمد.',
    systemSettingsUtilitiesMaxLockersLabel: 'حداکثر کمد به ازای هر مشتری',
    systemSettingsUtilitiesMaxLockersHint: 'حداکثر تعداد کمدی که هم‌زمان به یک مشتری تخصیص داده می‌شود. برای بدون محدودیت «نامحدود» را انتخاب کنید.',
    systemSettingsUtilitiesMaxLockersUnlimited: 'نامحدود',
    systemSettingsUtilitiesMaxLockersError: 'حداقل ۱ وارد کنید.',
    systemSettingsActiveTimeError: 'زمان شروع و پایان الزامی است.',
    systemSettingsActiveTimeOrderError: 'زمان پایان باید بعد از شروع باشد.',
    systemSettingsSave: 'ذخیره تنظیمات',
    systemSettingsSaving: 'در حال ذخیره...',
    systemSettingsSaveSuccess: 'تنظیمات به‌روزرسانی شد.',
    systemSettingsSaveFailed: 'ذخیره تنظیمات ناموفق بود.',
    systemSettingsLoadFailed: 'بارگذاری تنظیمات ناموفق بود.',
    systemSettingsLoading: 'در حال بارگذاری تنظیمات...',
    integrationsTitle: 'یکپارچه‌سازی‌ها',
    integrationsSubtitle: 'مدیریت اتصالات سخت‌افزاری برای مجموعه‌های تجهیزات و برای تجهیزات تکی.',
    integrationsListLabel: 'یکپارچه‌سازی‌ها',
    integrationsTotal: 'مجموع',
    integrationsListLoading: 'در حال بارگذاری...',
    integrationsListEmpty: 'یکپارچه‌سازی‌ای یافت نشد.',
    integrationsListLoadFailed: 'بارگذاری یکپارچه‌سازی‌ها ناموفق بود.',
    integrationsAddButton: 'افزودن یکپارچه‌سازی',
    integrationsCreateTitle: 'افزودن یکپارچه‌سازی',
    integrationsEditTitle: 'ویرایش یکپارچه‌سازی',
    integrationsCreateSuccess: 'یکپارچه‌سازی اضافه شد.',
    integrationsCreateFailed: 'افزودن یکپارچه‌سازی ناموفق بود.',
    integrationsUpdateSuccess: 'یکپارچه‌سازی به‌روزرسانی شد.',
    integrationsUpdateFailed: 'به‌روزرسانی یکپارچه‌سازی ناموفق بود.',
    integrationsDeleteSuccess: 'یکپارچه‌سازی حذف شد.',
    integrationsDeleteFailed: 'حذف یکپارچه‌سازی ناموفق بود.',
    integrationsEditButton: 'ویرایش',
    integrationsDeleteButton: 'حذف',
    integrationsSaving: 'در حال ذخیره...',
    integrationsSave: 'ذخیره',
    integrationsTargetLabel: 'هدف',
    integrationsTargetTypeLabel: 'نوع هدف',
    integrationsTargetSet: 'مجموعه تجهیزات',
    integrationsTargetUtility: 'تجهیزات تکی',
    integrationsUtilitySetLabel: 'مجموعه',
    integrationsUtilitySetPlaceholder: 'انتخاب مجموعه',
    integrationsUtilityLabel: 'تجهیزات',
    integrationsUtilityPlaceholder: 'انتخاب از تجهیزات',
    integrationsUtilitySearchPlaceholder: 'جستجو بر اساس مجموعه یا شماره...',
    integrationsProtocolTypeLabel: 'پروتکل',
    integrationsProtocolRest: 'REST',
    integrationsProtocolRestByServer: 'REST توسط سرور',
    integrationsProtocolRestByDevice: 'REST توسط دستگاه',
    integrationsProtocolWebSocket: 'WebSocket (درایور محلی)',
    integrationsWebSocketDriverTitle: 'درایور محلی',
    integrationsSelectDriverLabel: 'درایور',
    integrationsSelectDriverPlaceholder: 'یک درایور انتخاب کنید',
    integrationsDriverLabel: 'درایور',
    integrationsDriversLoading: 'در حال بارگذاری درایورها...',
    integrationsDriversLoadFailed: 'بارگذاری درایورها ناموفق بود.',
    integrationsDriversEmptyHelp:
      'هنوز درایوری ثبت نشده است. ابتدا با کد راه‌اندازی درایور را جفت کنید، سپس اینجا انتخاب کنید.',
    integrationsDriverStatusOnline: 'آنلاین',
    integrationsDriverStatusOffline: 'آفلاین',
    integrationsDriverStatusUnhealthy: 'ناسالم',
    integrationsDriverStatusDisabled: 'غیرفعال',
    integrationsDriverStatusPending: 'در انتظار',
    integrationsDriverStatusDeleted: 'حذف‌شده',
    integrationsCommandOptionsLabel: 'گزینه‌های فرمان',
    integrationsCommandTimeoutLabel: 'مهلت فرمان',
    integrationsCommandTimeoutHelp: 'ثانیه انتظار برای پاسخ درایور (۱–۱۲۰).',
    integrationsTypeLabel: 'نوع یکپارچه‌سازی',
    integrationsTypeLockerRest: 'قفل REST',
    integrationsNameLabel: 'نام',
    integrationsNamePlaceholder: 'برچسب اختیاری',
    integrationsLockerConfigTitle: 'پیکربندی قفل',
    integrationsProtocolLabel: 'پروتکل',
    integrationsBaseUrlLabel: 'آدرس پایه',
    integrationsBaseUrlPlaceholder: 'https://locker-api.example.com',
    integrationsUrlPatternOpen: 'الگوی آدرس (باز کردن)',
    integrationsUrlPatternPing: 'الگوی آدرس (ping)',
    integrationsRangeMinLabel: 'بازه شماره قفل (کم)',
    integrationsRangeMaxLabel: 'بازه شماره قفل (زیاد)',
    integrationsEnabledActionsLabel: 'عملیات‌های فعال',
    integrationsEnabledActions: 'فعال',
    integrationsActionOpen: 'باز کردن',
    integrationsActionPing: 'Ping',
    integrationsDetailLoading: 'در حال بارگذاری...',
    integrationsDetailEmpty: 'یک یکپارچه‌سازی انتخاب کنید.',
    integrationsAddWizardTitle: 'افزودن یکپارچه‌سازی',
    integrationsAddWizardStep1Title: 'مرحله ۱ از ۲: هدف و جزئیات',
    integrationsAddWizardStep2Title: 'مرحله ۲ از ۲: پیکربندی',
    integrationsConnectionTypeLabel: 'نوع اتصال',
    integrationsWizardNext: 'بعدی',
    integrationsWizardBack: 'بازگشت',
    integrationsDriverNameFallback: 'درایور ناشناخته (شناسه {id})',
    integrationsNoDriver: 'بدون درایور (حذف‌شده یا بدون اتصال). برای اتصال درایور، ویرایش را بزنید.',
    driversTitle: 'درایورها',
    driversSubtitle:
      'ثبت درایورهای محلی با کد راه‌اندازی، بررسی سلامت و چرخش کلید API.',
    driversListLabel: 'درایورها',
    driversTotal: 'مجموع',
    driversListLoading: 'در حال بارگذاری درایورها...',
    driversListEmpty: 'هنوز درایوری ثبت نشده است.',
    driversIntegrationsCount: 'یکپارچه‌سازی',
    driversDetailLoading: 'در حال بارگذاری جزئیات درایور...',
    driversDetailEmpty: 'یک درایور انتخاب کنید.',
    driversDetailLoadFailed: 'بارگذاری جزئیات درایور ناموفق بود.',
    driversGenerateSetupCode: 'ایجاد کد راه‌اندازی',
    driversSetupModalTitle: 'ایجاد کد راه‌اندازی درایور',
    driversSetupNameLabel: 'برچسب (اختیاری)',
    driversSetupNamePlaceholder: 'مثال: میز پذیرش',
    driversSetupExpiresLabel: 'انقضا (ساعت، ۱–۱۶۸)',
    driversSetupSubmit: 'ایجاد',
    driversSetupSubmitting: 'در حال ایجاد...',
    driversSetupCodeFailed: 'ایجاد کد راه‌اندازی ناموفق بود.',
    driversSetupResultTitle: 'کد راه‌اندازی آماده است',
    driversSetupResultHint:
      'این کد را در درایور وارد کنید. زمان انقضا در پایین آمده است.',
    driversSetupCodeLabel: 'کد راه‌اندازی',
    driversSetupExpiresAt: 'انقضا',
    driversCopyButton: 'کپی',
    driversCopySuccess: 'در کلیپ‌بورد کپی شد.',
    driversCopyFailed: 'کپی ناموفق بود.',
    driversDone: 'بستن',
    driversRotateKeyButton: 'چرخش کلید API',
    driversRotating: 'در حال چرخش...',
    driversRotateKeyFailed: 'چرخش کلید API ناموفق بود.',
    driversRotateConfirmTitle: 'چرخش کلید API؟',
    driversRotateConfirmBody:
      'کلید فوری باطل می‌شود. باید درایور را با کلید جدید به‌روز کنید.',
    driversRotateConfirmButton: 'چرخش کلید',
    driversRotateResultTitle: 'کلید API جدید',
    driversNewApiKeyLabel: 'کلید API',
    driversDisableButton: 'غیرفعال‌سازی درایور',
    driversDisabling: 'در حال غیرفعال‌سازی...',
    driversDisableSuccess: 'درایور غیرفعال شد.',
    driversDisableFailed: 'غیرفعال‌سازی درایور ناموفق بود.',
    driversDisableConfirmTitle: 'این درایور غیرفعال شود؟',
    driversDisableConfirmBody:
      'درایور قطع می‌شود؛ می‌توانید از همین صفحه دوباره فعالش کنید. یکپارچه‌سازی‌های مرتبط ممکن است متوقف شوند.',
    driversDisableConfirmButton: 'غیرفعال‌سازی',
    driversPendingDetailHint:
      'این کد راه‌اندازی منتظر ثبت درایور است. پیش از انقضا آن را در درایور وارد کنید.',
    driversPendingExpiredWarning: 'این کد راه‌اندازی منقضی شده و دیگر قابل استفاده نیست.',
    driversPendingCreatedLabel: 'ایجاد',
    driversDeleteButton: 'حذف درایور',
    driversDeleting: 'در حال حذف...',
    driversDeleteSuccess: 'درایور از فهرست حذف شد.',
    driversDeleteFailed: 'حذف درایور ناموفق بود.',
    driversDeleteConfirmTitle: 'این درایور حذف شود؟',
    driversDeleteConfirmBody:
      'درایور از فهرست حذف می‌شود و دیگر نمی‌تواند وصل شود. این با غیرفعال‌سازی فرق دارد.',
    driversDeleteConfirmButton: 'حذف',
    driversPendingDeleteConfirmTitle: 'این کد راه‌اندازی حذف شود؟',
    driversPendingDeleteConfirmBody:
      'کد حذف می‌شود و دیگر برای ثبت درایور قابل استفاده نیست. می‌توانید هر زمان کد جدید بسازید.',
    driversPendingDeleteSuccess: 'کد راه‌اندازی حذف شد.',
    driversPendingDeleteFailed: 'حذف کد راه‌اندازی ناموفق بود.',
    driversEnableButton: 'فعال‌سازی درایور',
    driversEnabling: 'در حال فعال‌سازی...',
    driversEnableSuccess: 'درایور فعال شد تا وصل شود آفلاین نمایش داده می‌شود.',
    driversEnableFailed: 'فعال‌سازی درایور ناموفق بود.',
    driversStatusLabel: 'وضعیت اتصال',
    driversHealthyLabel: 'سالم',
    driversYes: 'بله',
    driversNo: 'خیر',
    driversHealthOverallLabel: 'سلامت کلی',
    driversHealthOverallOk: 'خوب',
    driversHealthOverallOffline: 'آفلاین',
    driversHealthOverallDegraded: 'نیازمند توجه',
    driversHealthOverallDisabled: 'غیرفعال',
    driversHeartbeatFreshLabel: 'ضربان اخیر',
    driversHeartbeatAgeLabel: 'قدمت ضربان',
    driversHealthReasonLabel: 'دلیل سلامت',
    driversIntegrationsCountLabel: 'یکپارچه‌سازی‌های مرتبط',
    driversApiKeyPrefixLabel: 'پیشوند کلید API',
    driversServerUrlLabel: 'آدرس سرور',
    driversDriverVersionLabel: 'نسخه درایور',
    driversRegisteredAtLabel: 'ثبت‌شده',
    driversLastHeartbeatLabel: 'آخرین ضربان',
    driversSetupCodeUsedLabel: 'کد راه‌اندازی استفاده‌شده',
    driversLastHealthReportLabel: 'آخرین گزارش سلامت',
    driversDownloadButton: 'دانلود درایور',
    driversDownloadModalTitle: 'دانلود درایور',
    driversDownloadOptionsLoading: 'در حال بارگذاری گزینه‌های دانلود...',
    driversDownloadOptionsEmpty: 'در حال حاضر دانلود درایوری در دسترس نیست.',
    driversDownloadOptionsFailed: 'بارگذاری گزینه‌های دانلود درایور ناموفق بود.',
    driversDownloadFailed: 'شروع دانلود درایور ناموفق بود.',
    driversDownloadVersionLabel: 'نسخه',
    driversFleetWarningHardTitle: 'نسخه درایور دیگر پشتیبانی نمی‌شود',
    driversFleetWarningHardMessage:
      '{count} درایور زیر حداقل نسخه پشتیبانی‌شده ({minSupported}) هستند. در اسرع وقت به‌روزرسانی کنید.',
    driversFleetWarningSoftTitle: 'به‌روزرسانی درایور موجود است',
    driversFleetWarningSoftMessage:
      '{count} درایور را می‌توان به نسخه {latest} به‌روز کرد.',
    driversFleetWarningDashboardAdminAction: 'مدیریت درایورها',
    driversFleetWarningDashboardStaffHint:
      'از مدیر بخواهید درایورهای یکپارچه‌سازی محلی را به‌روزرسانی کند.',
    driversFleetWarningDriversStaffHint:
      'از مدیر بخواهید آخرین نسخه درایور را دانلود و نصب کند.',
    driversFleetWarningDriversAdminHint:
      'از دکمه دانلود درایور در بالا برای دریافت آخرین نسخه استفاده کنید.',
    pricingPlansTitle: 'طرح‌های قیمت‌گذاری ورود آزاد',
    pricingPlansSubtitle: 'طرح‌های قیمت‌گذاری ورود آزاد و مراحل آن‌ها را بررسی کنید.',
    pricingPlansReadOnly: 'مدیران فقط امکان مشاهده دارند و نمی‌توانند ویرایش کنند.',
    pricingPlanChipViewOnly: 'فقط مشاهده',
    pricingPlanChipNoActiveDefault: 'بدون طرح پیش‌فرض فعال',
    pricingPlansListLabel: 'طرح‌ها',
    pricingPlansTotal: 'مجموع',
    pricingPlansLoading: 'در حال بارگذاری طرح‌ها...',
    pricingPlansEmpty: 'هیچ طرحی یافت نشد.',
    pricingPlansLoadFailed: 'بارگذاری طرح‌ها ناموفق بود.',
    pricingPlanCreateButton: 'ایجاد طرح',
    pricingPlanCreateTitle: 'ایجاد طرح ورود آزاد',
    pricingPlanCreateCancel: 'لغو',
    pricingPlanCreateConfirm: 'ایجاد طرح',
    pricingPlanCreateSubmitting: 'در حال ایجاد...',
    pricingPlanCreateSuccess: 'طرح قیمت‌گذاری ایجاد شد.',
    pricingPlanCreateFailed: 'ایجاد طرح ناموفق بود.',
    pricingPlanDefaultInactiveWarning:
      'قیمت‌گذاری خودکار تا فعال شدن طرح پیش‌فرض کار نخواهد کرد.',
    pricingPlanActiveConflict: 'فقط یک طرح قیمت‌گذاری پیش‌فرض می‌تواند فعال باشد.',
    pricingPlanActiveDefaultConflictTitle: 'طرح پیش‌فرض فعال از قبل وجود دارد',
    pricingPlanActiveDefaultConflictBody:
      'یک طرح پیش‌فرض فعال از قبل وجود دارد («{title}»). می‌توانید آن را با این طرح جایگزین کنید یا این طرح را غیرفعال ذخیره کنید.',
    pricingPlanActiveDefaultConflictReplace: 'جایگزینی طرح پیش‌فرض فعال',
    pricingPlanActiveDefaultConflictSaveInactive: 'ذخیره به‌صورت غیرفعال',
    pricingPlanActiveDefaultConflictCancel: 'بازگشت به ویرایش',
    pricingPlanCheckOverlap: 'بررسی تداخل',
    pricingPlanCheckOverlapChecking: 'در حال بررسی...',
    pricingPlanOverlapCheckClear: 'تداخلی یافت نشد.',
    pricingPlanOverlapCheckConflict: 'این طرح با طرح‌های دیگر تداخل دارد.',
    pricingPlanOverlapCheckConflictWith: 'تداخل با: {titles}.',
    pricingPlanOverlapCheckFailed: 'بررسی تداخل ناموفق بود.',
    pricingPlanEditButton: 'ویرایش طرح',
    pricingPlanCloneButton: 'کپی طرح',
    pricingPlanCloneTitle: 'کپی طرح ورود آزاد',
    pricingPlanCloneTitleSuffix: '(کپی)',
    pricingPlanBranchScopeLabel: 'محدوده شعبه',
    pricingPlanScopeTenantWide: 'همه شعب',
    pricingPlanScopeBranchOnly: 'فقط {branch}',
    pricingPlanScopeBranch: 'این شعبه',
    pricingPlanBranchScopedHint: 'این طرح فقط برای {branch} اعمال می‌شود.',
    pricingPlanTenantWideHint: 'این طرح برای همه شعب اعمال می‌شود.',
    pricingPlanDeleteButton: 'حذف طرح',
    pricingPlanEditTitle: 'ویرایش طرح ورود آزاد',
    pricingPlanEditCancel: 'انصراف',
    pricingPlanEditConfirm: 'ذخیره تغییرات',
    pricingPlanEditSubmitting: 'در حال ذخیره...',
    pricingPlanUpdateSuccess: 'طرح قیمت‌گذاری به‌روزرسانی شد.',
    pricingPlanUpdateFailed: 'به‌روزرسانی طرح ناموفق بود.',
    pricingPlanDeleteTitle: 'حذف طرح',
    pricingPlanDeletePrompt: 'آیا از حذف این طرح مطمئن هستید؟',
    pricingPlanDeleteConfirm: 'حذف طرح',
    pricingPlanDeleteCancel: 'انصراف',
    pricingPlanDeleteSubmitting: 'در حال حذف...',
    pricingPlanDeleteSuccess: 'طرح قیمت‌گذاری حذف شد.',
    pricingPlanDeleteFailed: 'حذف طرح ناموفق بود.',
    pricingPlanDeleteDefaultActive: 'طرح پیش‌فرض فعال قابل حذف نیست.',
    pricingPlanDefaultRequired: 'ابتدا یک طرح پیش‌فرض بسازید.',
    pricingPlanDefaultInvalid: 'طرح پیش‌فرض باید تمام زمان‌ها را پوشش دهد.',
    pricingPlanOverlap: 'این طرح با طرح دیگری تداخل دارد.',
    pricingPlanDetailLoading: 'در حال بارگذاری جزئیات طرح...',
    pricingPlanDetailEmpty: 'یک طرح را برای مشاهده جزئیات انتخاب کنید.',
    pricingPlanDetailFailed: 'بارگذاری جزئیات طرح ناموفق بود.',
    pricingPlanActive: 'فعال',
    pricingPlanInactive: 'غیرفعال',
    pricingPlanDefault: 'پیش‌فرض',
    pricingPlanTierBasisLabel: 'مبنای سطح‌بندی',
    pricingPlanTierBasisHint: 'مشخص می‌کند هر سطح چه چیزی را نشان می‌دهد.',
    pricingTierBasisLegendPartySize:
      'هر ستون یک بازه تعداد نفرات است؛ ستون آخر بازه باز است (مثلاً ۴ نفر به بالا).',
    pricingTierBasisLegendGeneric: 'هر ستون یک سطح قیمت‌گذاری است.',
    pricingDetailStepPrefix: 'مرحله',
    pricingDetailDurationFirst: 'اول',
    pricingDetailDurationNext: 'بعدی',
    pricingPlanTitleLabel: 'عنوان طرح',
    pricingPlanTitlePlaceholder: 'مثلا ورود آزاد آخر هفته',
    pricingPlanActiveLabel: 'طرح فعال',
    pricingPlanDefaultLabel: 'طرح پیش‌فرض',
    pricingPlanAllDayLabel: 'تمام روز',
    pricingPlanValidFromLabel: 'شروع اعتبار',
    pricingPlanValidToLabel: 'پایان اعتبار',
    pricingPlanStartTimeLabel: 'زمان شروع',
    pricingPlanEndTimeLabel: 'زمان پایان',
    pricingPlanDateRangeLabel: 'بازه زمانی',
    pricingPlanDateRangeAny: 'هر تاریخ',
    pricingPlanDateOpen: 'بدون پایان',
    pricingPlanWeekdaysLabel: 'روزهای هفته',
    pricingPlanTimeLabel: 'زمان',
    pricingPlanAllDay: 'تمام روز',
    pricingPlanTimeUnset: 'ثبت نشده',
    pricingPlanValidationTitle: 'عنوان طرح را وارد کنید.',
    pricingPlanValidationWeekdays: 'حداقل یک روز را انتخاب کنید.',
    pricingPlanValidationDates: 'تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد.',
    pricingPlanValidationValidFromToday: 'تاریخ شروع نمی‌تواند قبل از امروز باشد.',
    pricingPlanValidationTimes: 'زمان شروع و پایان الزامی است.',
    pricingPlanValidationTimesOrder: 'زمان شروع باید قبل از پایان باشد.',
    pricingPlanValidationStepsRequired: 'حداقل یک بلوک زمانی اضافه کنید.',
    pricingPlanValidationStepsLimit: 'حداکثر {limit} بلوک زمانی مجاز است.',
    pricingPlanValidationSteps: 'تمام فیلدهای بلوک زمانی را تکمیل کنید.',
    pricingPlanValidationTierBasis: 'یک مبنا برای سطح‌بندی انتخاب کنید.',
    pricingPlanStepsTitle: 'بلوک‌های زمانی',
    pricingPlanStepsEmpty: 'هیچ بلوک زمانی تعریف نشده است.',
    pricingPlanStepAdd: 'افزودن بلوک زمانی',
    pricingPlanStepRemove: 'حذف',
    pricingPlanStepActions: 'اقدامات',
    pricingPlanFinalStep: 'زمان باقی‌مانده (ساعتی)',
    pricingCurrencyRial: 'ریال',
    pricingStepOrder: 'بلوک',
    pricingStepDuration: 'مدت',
    pricingStepTimeUnit: 'واحد زمانی',
    pricingTierLabel: 'سطح',
    pricingTierPartyWordSingular: 'نفر',
    pricingTierPartyWordPlural: 'نفر',
    pricingTierBasisPartySize: 'تعداد نفرات',
    pricingTierBasisUtilities: 'تعداد تجهیزات',
    pricingTierBasisUnknown: 'نامشخص',
    pricingStepRate1: '۱ کودک',
    pricingStepRate2: '۲ کودک',
    pricingStepRate3: '۳+ کودک',
    pricingStepMinutes: 'دقیقه',
    pricingStepUnitHours: 'ساعت',
    pricingStepUnitMinutes: 'دقیقه',
    pricingStepBlockCost: 'هزینهٔ این بلوک',
    pricingPerMinuteUnit: 'دقیقه',
    pricingPreviewTitle: 'پیش‌نمایش هزینه',
    pricingPreviewNote: 'هزینهٔ تخمینی برای یک نفر بر اساس سطح‌های بالا.',
    pricingBillingUnit_PER_MINUTE: 'دقیقه‌ای',
    pricingBillingUnit_PER_HOUR: 'ساعتی',
    pricingWeekdayMon: 'دوشنبه',
    pricingWeekdayTue: 'سه‌شنبه',
    pricingWeekdayWed: 'چهارشنبه',
    pricingWeekdayThu: 'پنج‌شنبه',
    pricingWeekdayFri: 'جمعه',
    pricingWeekdaySat: 'شنبه',
    pricingWeekdaySun: 'یکشنبه',
    pricingWeekdaysNone: 'بدون روز',
    pricingPlanTierBasisImmutable: 'مبنای سطح‌بندی پس از ثبت قابل تغییر نیست.',
    pricingPlanTierBasisInvalid: 'مبنای سطح‌بندی نامعتبر است.',
    pricingWizardStageGeneralTitle: 'جزئیات طرح',
    pricingWizardStageTiersTitle: 'بلوک‌های زمانی و نرخ سطح‌ها',
    pricingWizardStepLabel: 'بلوک زمانی',
    pricingWizardStepOf: 'از',
    pricingWizardLastStepBadge: 'زمان باقی‌مانده',
    pricingWizardNext: 'ادامه',
    pricingWizardBack: 'بازگشت',
    pricingWizardProgressAria: 'پیشرفت ویزارد',
    pricingWizardFinalStepPerHourExplain:
      'بعد از بلوک‌های بالا، زمان باقی‌مانده ساعتی محاسبه می‌شود؛ نرخ ساعتی را در زیر وارد کنید.',
    pricingWizardNonFinalDurationExplain:
      'مدت این بلوک را مشخص کنید. مشتری به‌نسبت زمان استفاده پرداخت می‌کند: بلوک ۱ ساعته با نرخ ۱۲۰٬۰۰۰ برای ۳۰ دقیقه ۶۰٬۰۰۰ می‌شود. زمان بعد از همهٔ بلوک‌ها ساعتی محاسبه می‌شود.',
    pricingTierBasisLockedHint: 'مبنای سطح‌بندی فعلاً ثابت است (تعداد نفرات).',
    discountsTitle: 'تخفیف‌ها',
    discountsSubtitle: 'قواعد تخفیف و شرایط استفاده را بررسی کنید.',
    discountsListLabel: 'تخفیف‌ها',
    discountsTotal: 'مجموع',
    discountsLoading: 'در حال بارگذاری تخفیف‌ها...',
    discountsEmpty: 'تخفیفی ثبت نشده است.',
    discountsLoadFailed: 'بارگذاری تخفیف‌ها ناموفق بود.',
    discountDetailTitle: 'جزئیات تخفیف',
    discountDetailEmpty: 'برای مشاهده جزئیات یک تخفیف را انتخاب کنید.',
    discountDetailLoading: 'در حال بارگذاری جزئیات تخفیف...',
    discountDetailFailed: 'بارگذاری جزئیات تخفیف ناموفق بود.',
    discountCodeLabel: 'کد',
    discountTypeLabel: 'نوع',
    discountScopeLabel: 'دامنه',
    discountAmountLabel: 'مبلغ/درصد',
    discountStatusLabel: 'وضعیت',
    discountActive: 'فعال',
    discountInactive: 'غیرفعال',
    discountScopeGeneral: 'عمومی',
    discountScopeCustomer: 'اختصاصی مشتری',
    discountTypePercent: 'درصدی',
    discountTypeFixed: 'ثابت',
    discountCustomerLabel: 'مشتری',
    discountCustomerAll: 'همه مشتریان',
    discountDateRangeLabel: 'بازه تاریخ',
    discountDateOpen: 'باز',
    discountWeekdaysLabel: 'روزهای هفته',
    discountWeekdaysAll: 'تمام روزها',
    discountWeekdaysNone: 'بدون روز',
    discountTimeLabel: 'بازه زمانی',
    discountTimeAllDay: 'تمام روز',
    discountTimeUnset: 'ثبت نشده',
    discountMinBasePriceLabel: 'حداقل قیمت پایه',
    discountMinBasePriceNone: 'بدون حداقل',
    discountUsageLimitLabel: 'سقف استفاده',
    discountUsageLimitPlaceholder: 'تعداد استفاده',
    discountUsageLimitNone: 'بدون سقف',
    discountCodePlaceholder: 'کد تخفیف را وارد کنید',
    discountAmountPlaceholder: 'مبلغ را وارد کنید',
    discountTypePlaceholder: 'نوع را انتخاب کنید',
    discountScopePlaceholder: 'دامنه را انتخاب کنید',
    discountCustomerSearchPlaceholder: 'جستجوی مشتری با شماره تلفن',
    discountCustomerNoResults: 'مشتری‌ای یافت نشد',
    discountCustomerLoading: 'در حال بارگذاری مشتریان...',

    giftCardsTitle: 'کارت‌های هدیه',
    giftCardsSubtitle: 'مدیریت انواع و کارت‌های صادر شده.',
    giftCardsTabInstances: 'کارت‌ها',
    giftCardsTabTypes: 'انواع',
    giftCardsTabs: 'بخش‌های کارت هدیه',
    giftCardsCreateType: 'ایجاد نوع',
    giftCardsCreateInstance: 'افزودن کارت',
    giftCardsInstancesListLabel: 'کارت‌های هدیه',
    giftCardsTypesListLabel: 'انواع',
    giftCardsTotal: 'مجموع',
    giftCardsInstancesEmpty: 'کارتی یافت نشد.',
    giftCardsTypesEmpty: 'نوعی یافت نشد.',
    giftCardsInstancesLoading: 'در حال بارگذاری کارت‌ها...',
    giftCardsTypesLoading: 'در حال بارگذاری انواع...',
    giftCardsInstancesLoadFailed: 'بارگذاری کارت‌ها ناموفق بود.',
    giftCardsTypesLoadFailed: 'بارگذاری انواع ناموفق بود.',
    giftCardsDetailEmpty: 'یک کارت را برای جزئیات انتخاب کنید.',
    giftCardsTypeDetailEmpty: 'یک نوع را برای جزئیات انتخاب کنید.',
    giftCardsInstanceDetailTitle: 'جزئیات کارت',
    giftCardsTypeDetailTitle: 'جزئیات نوع',
    giftCardsDetailLoading: 'در حال بارگذاری جزئیات...',
    giftCardsDetailLoadFailed: 'بارگذاری جزئیات ناموفق بود.',
    giftCardsCodeLabel: 'کد',
    giftCardsTypeLabel: 'نوع',
    giftCardsBalanceLabel: 'مانده',
    giftCardsCustomerLabel: 'مشتری',
    giftCardsOpenCard: 'باز (بدون اختصاص)',
    giftCardsStatusLabel: 'وضعیت',
    giftCardsExpiresLabel: 'انقضا',
    giftCardsPurchaseAmountLabel: 'مبلغ خرید',
    giftCardsBatchLabel: 'دسته',
    giftCardsBatchPaid: 'پرداخت‌شده در سیستم',
    giftCardsBatchUnpaid: 'بدون ثبت مالی',
    giftCardsUsageHistory: 'مشاهده تاریخچه استفاده',
    giftCardsTitleLabel: 'عنوان',
    giftCardsAmountLabel: 'مقدار',
    giftCardsAmountHoursLabel: 'ساعت',
    giftCardsSalePriceLabel: 'قیمت فروش',
    giftCardsExpiryDaysLabel: 'انقضا (روز)',
    giftCardsDescriptionLabel: 'توضیحات',
    giftCardsNoExpiry: 'بدون انقضا',
    giftCardsNotSet: 'تنظیم نشده',
    giftCardsActive: 'فعال',
    giftCardsInactive: 'غیرفعال',
    giftCardsHoursUnit: 'ساعت',
    giftCardsMinutesShort: 'دقیقه',
    giftCardsSelectType: 'انتخاب نوع',
    giftCardsCodeAutoHint: 'خالی بگذارید تا خودکار ساخته شود',
    giftCardsIssueMode: 'نوع صدور',
    giftCardsIssueSingle: 'تک کارت',
    giftCardsIssueBatch: 'صدور دسته‌ای',
    giftCardsBatchCodesLabel: 'کدها (هر خط یک کد)',
    giftCardsBatchCodesHint: 'کدها را وارد کنید یا برای تولید خودکار خالی بگذارید',
    giftCardsBatchQuantityLabel: 'تعداد تولید',
    giftCardsBatchIsPaid: 'دسته پرداخت شده (ثبت مالی)',
    giftCardsBatchPaymentAmount: 'مبلغ کل پرداخت',
    giftCardsUsageTitle: 'تاریخچه استفاده',
    giftCardsUsageEmpty: 'هنوز استفاده‌ای ثبت نشده.',
    giftCardsBalanceAfterPrefix: 'مانده پس از:',
    giftCardsFeatureLocked: 'کارت هدیه در پلن شما فعال نیست.',
    navGiftCards: 'کارت‌های هدیه',
    giftCardsPurchaseButton: 'خرید کارت هدیه',
    giftCardsPurchaseTitle: 'خرید کارت هدیه',
    giftCardsPurchaseSubmit: 'خرید',
    giftCardsPurchaseSuccess: 'کارت هدیه خریداری شد.',
    giftCardsPurchaseFailed: 'خرید کارت هدیه ناموفق بود.',
    giftCardsPaymentMethodGiftCard: 'کارت هدیه',
    giftCardsPaymentMethodMoney: 'نقد / سایر',
    giftCardsSelectMappedCard: 'انتخاب کارت مشتری',
    giftCardsRemaining: 'مانده',
    giftCardsEnterCode: 'کد کارت هدیه',
    giftCardsRedeemAction: 'پرداخت با کارت هدیه',
    giftCardsRedeemSubmitting: 'در حال کسر...',
    giftCardsRedeemSuccess: 'کارت هدیه اعمال شد.',
    giftCardsRedeemFailed: 'کسر از کارت ناموفق بود.',
    giftCardsRedeemTransactionMissing: 'تراکنش بازی برای این بازدید یافت نشد.',
    giftCardsRedeemTransactionClosed: 'این تراکنش قبلاً بسته شده است.',
    giftCardsRedeemVisitNotReady: 'بازدید برای پرداخت با کارت هدیه آماده نیست.',
    giftCardsRedeemChildrenActive: 'قبل از پرداخت با کارت هدیه همه کودکان را خارج کنید.',
    giftCardsRedeemAlreadySettled: 'این بازدید قبلاً با کارت هدیه تسویه شده است.',
    giftCardsRedeemCustomerMismatch: 'این کارت هدیه متعلق به مشتری دیگری است.',
    giftCardsRedeemReferenceRequired: 'یک کارت انتخاب کنید یا کد وارد کنید.',
    giftCardsRedeemInsufficientBalance: 'مانده کارت هدیه برای این بازدید کافی نیست.',
    giftCardsRedeemNotFound: 'کارت هدیه یافت نشد.',
    giftCardsRedeemCodeRequired: 'کد کارت هدیه را وارد کنید.',
    giftCardsRedeemInactive: 'این کارت هدیه غیرفعال است.',
    giftCardsRedeemFullyRedeemed: 'مانده این کارت هدیه تمام شده است.',
    giftCardsRedeemExpired: 'این کارت هدیه منقضی شده است.',
    giftCardsRedeemCustomerNotFound: 'مشتری یافت نشد.',
    giftCardsRedeemTransferForbidden: 'این کارت هدیه قبلاً به مشتری دیگری اختصاص یافته است.',
    giftCardsRedeemVisitNotStarted: 'زمان بازی بازدید هنوز شروع نشده است.',
    giftCardsRedeemNoChildren: 'بازدید بدون کودک برای محاسبه وجود ندارد.',
    giftCardsRedeemInvalidRequest: 'درخواست پرداخت با کارت هدیه نامعتبر است.',
    giftCardsRedeemIdempotencyConflict: 'لطفاً دوباره تلاش کنید.',
    giftCardsPurchaseCustomerNotFound: 'مشتری انتخاب‌شده یافت نشد.',
    giftCardsPurchaseSalePriceMismatch: 'قیمت فروش با نوع کارت مطابقت ندارد.',
    giftCardsPurchaseInvalidAmount: 'مبلغ خرید نامعتبر است.',
    giftCardsPurchaseTypeInactive: 'نوع کارت هدیه انتخاب‌شده غیرفعال است.',
    giftCardsPurchaseTypeNotFound: 'نوع کارت هدیه یافت نشد.',
    giftCardsPurchaseCodeExists: 'این کد کارت هدیه قبلاً ثبت شده است.',
    giftCardsPurchaseInvalidRequest: 'درخواست خرید کارت هدیه نامعتبر است.',
    giftCardsDeductionPreview: 'از کارت کسر می‌شود (تعداد × مدت)',
    giftCardsNoMappedCards: 'کارت اختصاص‌یافته‌ای برای این مشتری نیست.',
    discountCreateButton: 'ایجاد تخفیف',
    discountCreateTitle: 'ایجاد تخفیف',
    discountCreateCancel: 'انصراف',
    discountCreateConfirm: 'ایجاد',
    discountCreateSubmitting: 'در حال ایجاد...',
    discountCreateSuccess: 'تخفیف ایجاد شد.',
    discountCreateFailed: 'ایجاد تخفیف ناموفق بود.',
    discountCreateCodeExists: 'کد تخفیف تکراری است.',
    discountCreateCustomerRequired: 'برای این تخفیف مشتری را انتخاب کنید.',
    discountCreateCustomerForbidden: 'برای تخفیف عمومی مشتری قابل انتخاب نیست.',
    discountCreateCustomerNotFound: 'مشتری انتخاب‌شده پیدا نشد.',
    discountCreateInvalidAmount: 'مبلغ تخفیف معتبر نیست.',
    discountCreateInvalidCode: 'کد تخفیف را وارد کنید.',
    discountCreateInvalidDateRange: 'بازه تاریخ تخفیف نامعتبر است.',
    discountCreateInvalidTimeRange: 'بازه زمانی تخفیف نامعتبر است.',
    discountCreateInvalidWeekdays: 'حداقل یک روز را انتخاب کنید.',
    discountCreateInvalidMinBasePrice: 'حداقل قیمت پایه باید بزرگ‌تر از صفر باشد.',
    discountCreateMinBasePriceFixedOnly: 'حداقل قیمت پایه فقط برای تخفیف ثابت مجاز است.',
    discountCreateInvalidType: 'نوع تخفیف را انتخاب کنید.',
    discountCreateInvalidScope: 'دامنه تخفیف را انتخاب کنید.',
    discountCreateUsageLimitRequired: 'برای تخفیف عمومی سقف استفاده الزامی است.',
    discountActivate: 'فعال‌سازی',
    discountDeactivate: 'غیرفعال‌سازی',
    discountStatusActivated: 'تخفیف فعال شد.',
    discountStatusDeactivated: 'تخفیف غیرفعال شد.',
    discountStatusFailed: 'به‌روزرسانی وضعیت تخفیف ناموفق بود.',
    discountStatusNotFound: 'تخفیف یافت نشد.',
    discountValidationCode: 'کد تخفیف را وارد کنید.',
    discountValidationType: 'نوع تخفیف را انتخاب کنید.',
    discountValidationAmount: 'مبلغ معتبر وارد کنید.',
    discountValidationScope: 'دامنه تخفیف را انتخاب کنید.',
    discountValidationCustomer: 'یک مشتری را انتخاب کنید.',
    discountValidationUsageLimit: 'برای تخفیف عمومی سقف استفاده را وارد کنید.',
    discountGeneratorTitle: 'تولید کد تخفیف',
    discountGeneratorAction: 'تولید',
    discountGeneratorLoading: 'در حال تولید...',
    discountGeneratorNumbers: 'شامل ارقام',
    discountGeneratorLowercase: 'شامل حروف کوچک',
    discountGeneratorUppercase: 'شامل حروف بزرگ',
    discountGeneratorPrefix: 'پیشوند',
    discountGeneratorPrefixPlaceholder: 'پیشوند اختیاری',
    discountGeneratorLengthLabel: 'طول کد',
    discountGeneratorLengthPlaceholder: '۴ تا ۷',
    discountGeneratorMissingCharset: 'حداقل یک مجموعه کاراکتر را انتخاب کنید.',
    discountGeneratorInvalid: 'حداقل یک مجموعه کاراکتر را انتخاب کنید.',
    discountGeneratorLengthInvalid: 'طول کد نامعتبر است.',
    discountGeneratorFailed: 'تولید کد ناموفق بود.',
    discountCollapseShow: 'نمایش',
    discountCollapseHide: 'پنهان',
    discountRulesTitle: 'قواعد شرایط استفاده',
    discountValidFromLabel: 'شروع اعتبار',
    discountValidToLabel: 'پایان اعتبار',
    discountAllDayLabel: 'تمام روز',
    discountStartTimeLabel: 'زمان شروع',
    discountEndTimeLabel: 'زمان پایان',
    discountMinBasePricePlaceholder: 'قیمت پایه',
    discountOpenEndedWarning: 'تخفیف بدون تاریخ پایان توصیه نمی‌شود. پایان اعتبار تعیین کنید.',
    paymentTypesTitle: 'انواع پرداخت',
    paymentTypesSubtitle: 'روش‌های پرداخت قابل استفاده را تنظیم کنید.',
    paymentTypesListLabel: 'روش‌های پرداخت',
    paymentTypesTotalLabel: 'مجموع',
    paymentTypesEmpty: 'هیچ روش پرداختی ثبت نشده است.',
    paymentTypesLoading: 'در حال بارگذاری روش‌های پرداخت...',
    paymentTypesLoadFailed: 'بارگذاری روش‌های پرداخت ناموفق بود.',
    paymentTypeCreate: 'ایجاد روش پرداخت',
    paymentTypeCreateTitle: 'ایجاد روش پرداخت',
    paymentTypeEditTitle: 'ویرایش روش پرداخت',
    paymentTypeEdit: 'ویرایش',
    paymentTypeSave: 'ذخیره',
    paymentTypeSaving: 'در حال ذخیره...',
    paymentTypeCancel: 'انصراف',
    paymentTypeNameLabel: 'نام',
    paymentTypeNamePlaceholder: 'مثلاً صندوق نقدی',
    paymentTypeCategoryLabel: 'دسته‌بندی',
    paymentTypeCategoryPlaceholder: 'انتخاب دسته‌بندی',
    paymentTypeActiveLabel: 'فعال',
    paymentTypeActive: 'فعال',
    paymentTypeInactive: 'غیرفعال',
    paymentTypeCategoryCash: 'نقدی',
    paymentTypeCategoryPos: 'کارتخوان',
    paymentTypeCategoryOnline: 'انتقال آنلاین',
    paymentTypeCategory_CASH: 'نقدی',
    paymentTypeCategory_POS: 'کارتخوان',
    paymentTypeCategory_ONLINE_TRANSFER: 'انتقال آنلاین',
    paymentTypeFinancialAccountLabel: 'حساب مالی',
    paymentTypeFinancialAccountPlaceholder: 'انتخاب حساب (اختیاری)',
    paymentTypeFinancialAccountNone: 'بدون حساب',
    paymentTypeFinancialAccountShort: 'حساب',
    paymentTypeFinancialAccountNote: 'فقط حساب‌های فعال قابل تخصیص هستند.',
    paymentTypeFinancialAccountLoadFailed: 'بارگذاری حساب‌های مالی ناموفق بود.',
    paymentTypeFinancialAccountNotFound: 'حساب مالی یافت نشد.',
    paymentTypeFinancialAccountInactive: 'حساب مالی غیرفعال قابل تخصیص نیست.',
    paymentTypeFinancialAccountRequiredForActive: 'روش پرداخت فعال باید حساب مالی داشته باشد.',
    paymentTypeCreateSubmitting: 'در حال ایجاد...',
    paymentTypeCreateSuccess: 'روش پرداخت ایجاد شد.',
    paymentTypeCreateFailed: 'ایجاد روش پرداخت ناموفق بود.',
    paymentTypeUpdateSubmitting: 'در حال به‌روزرسانی...',
    paymentTypeUpdateSuccess: 'روش پرداخت به‌روزرسانی شد.',
    paymentTypeUpdateFailed: 'به‌روزرسانی روش پرداخت ناموفق بود.',
    paymentTypeNameExists: 'نام روش پرداخت تکراری است.',
    paymentTypeInvalidCategory: 'دسته‌بندی معتبر نیست.',
    dailySalesSummaryTitle: 'خلاصه فروش روزانه',
    dailySalesSummarySubtitle: 'گزارش پایان روز با فیلتر الزامی بازه تاریخ.',
    dailySalesSummaryStartDate: 'تاریخ شروع',
    dailySalesSummaryEndDate: 'تاریخ پایان',
    dailySalesSummaryStaffLabel: 'کاربر',
    dailySalesSummaryStaffAll: 'همه کاربران',
    dailySalesSummaryPaymentTypeLabel: 'روش پرداخت',
    dailySalesSummaryPaymentTypeAll: 'همه روش‌های پرداخت',
    dailySalesSummaryApply: 'اعمال فیلترها',
    dailySalesSummaryClear: 'پاک کردن',
    dailySalesSummaryRevenue: 'درآمد',
    dailySalesSummaryTransactionCount: 'تعداد تراکنش',
    dailySalesSummaryDiscountTotal: 'جمع تخفیف',
    dailySalesSummaryByPaymentType: 'تفکیک بر اساس روش پرداخت',
    dailySalesSummaryByAccount: 'تفکیک بر اساس حساب مالی',
    dailySalesSummaryAccountLabel: 'حساب مالی',
    dailySalesSummaryLoadFailed: 'بارگذاری خلاصه فروش روزانه ناموفق بود.',
    dailySalesSummaryInvalidFilter: 'بازه تاریخ الزامی است و باید معتبر باشد.',
    dailySalesSummaryEmpty: 'برای فیلترهای انتخاب‌شده پرداختی یافت نشد.',
    paymentTypesMissingWarning: 'هیچ روش پرداخت فعالی تعریف نشده است. پرداخت غیرفعال شد.',
    transactionPaymentAmountLabel: 'مبلغ پرداخت',
    transactionPaymentAmountPlaceholder: 'مبلغ را وارد کنید',
    transactionPaymentAction: 'ثبت پرداخت',
    transactionPaymentSubmitting: 'در حال ثبت...',
    transactionPaymentSuccess: 'پرداخت ثبت شد.',
    transactionPaymentFailed: 'ثبت پرداخت ناموفق بود.',
    transactionPaymentInvalidAmount: 'مبلغ پرداخت باید مثبت باشد.',
    transactionPaymentInactive: 'روش پرداخت غیرفعال است.',
    transactionPaymentAccountMissing: 'روش پرداخت حساب مالی لینک‌شده ندارد.',
    transactionPaymentAccountInactive: 'حساب مالی لینک‌شده غیرفعال است.',
    transactionPaymentTypeMissing: 'روش پرداخت یافت نشد.',
    transactionPaymentClosed: 'تراکنش بسته شده است.',
    transactionPaymentMissing: 'تراکنشی برای ثبت پرداخت موجود نیست.',
    transactionPaymentsTitle: 'هزینه‌ها و وضعیت پرداخت',
    transactionPaymentsLoading: 'در حال بارگذاری پرداخت‌ها...',
    transactionPaymentsLoadFailed: 'بارگذاری پرداخت‌ها ناموفق بود.',
    transactionPaymentsEmpty: 'هیچ پرداختی ثبت نشده است.',
    transactionPaymentsList: 'پرداخت‌ها',
    transactionPaymentsListToggle: 'سوابق پرداخت',
    transactionPaymentsTotal: 'جمع کل',
    transactionPaymentsDiscount: 'تخفیف',
    transactionPaymentsPaid: 'پرداخت‌شده تاکنون',
    transactionPaymentsCreditAfterExit: 'اعتبار پس از خروج',
    transactionPaymentsRemaining: 'قابل پرداخت اکنون',
    transactionPaymentsPayableHint: 'برای بستن مراجعه، مشتری باید مبلغ قابل پرداخت را تسویه کند.',
    transactionPaymentsType: 'روش پرداخت',
    transactionPaymentsAmount: 'مبلغ',
    transactionPaymentsDate: 'تاریخ',
    transactionPaymentsCategory: 'دسته‌بندی',
    discountUsageTitle: 'گزارش استفاده تخفیف',
    discountUsageClose: 'بستن',
    discountUsageButton: 'گزارش استفاده',
    discountUsageLoading: 'در حال بارگذاری گزارش...',
    discountUsageEmpty: 'گزارشی برای استفاده ثبت نشده است.',
    discountUsageLoadFailed: 'بارگذاری گزارش استفاده ناموفق بود.',
    discountUsageCodeLabel: 'کد',
    discountUsageCountLabel: 'تعداد استفاده',
    discountUsageTotalLabel: 'مجموع تخفیف',
    entryDiscountCodeRequired: 'کد تخفیف را وارد کنید.',
    entryDiscountEligible: 'تخفیف قابل استفاده است.',
    entryDiscountApplied: 'تخفیف اعمال شد.',
    entryDiscountAlreadyApplied: 'یک تخفیف قبلاً برای این مراجعه ثبت شده است.',
    entryDiscountInactive: 'تخفیف غیرفعال است.',
    entryDiscountNotFound: 'تخفیف یافت نشد.',
    entryDiscountDateMismatch: 'تخفیف در این تاریخ فعال نیست.',
    entryDiscountWeekdayMismatch: 'تخفیف در این روز فعال نیست.',
    entryDiscountTimeMismatch: 'تخفیف در این بازه زمانی فعال نیست.',
    entryDiscountDurationRequired: 'برای بررسی تخفیف مدت زمان را انتخاب کنید.',
    entryDiscountDurationTooShort: 'مدت زمان مورد انتظار کمتر از حداقل است.',
    entryDiscountBasePriceRequired: 'برای بررسی این تخفیف، قیمت پایه لازم است.',
    entryDiscountMinPriceUnmet: 'حداقل قیمت پایه برای این تخفیف تامین نشده است.',
    entryDiscountCustomerRequired: 'برای این تخفیف مشتری را انتخاب کنید.',
    entryDiscountCustomerMismatch: 'این تخفیف برای این مشتری نیست.',
    entryDiscountUsageLimitReached: 'سقف استفاده تخفیف پر شده است.',
    entryDiscountCheckFailed: 'بررسی تخفیف ناموفق بود.',
    entryPaymentAmountLabel: 'مبلغ پرداخت',
    entryPaymentAmountPlaceholder: 'مبلغ را وارد کنید',
    entryPaymentTypeRequired: 'روش پرداخت را انتخاب کنید.',
    entryPaymentAmountRequired: 'مبلغ پرداخت معتبر وارد کنید.',
    priceCorrectionTitle: 'اصلاح قیمت',
    priceCorrectionBaselineLabel: 'جمع محاسبه‌شده قبل از اصلاح',
    priceCorrectionAllowedRangeIntro: 'محدوده مجاز:',
    priceCorrectionAdjustedLabel: 'مبلغ نهایی',
    priceCorrectionReasonLabel: 'دلیل (اختیاری)',
    priceCorrectionApply: 'اعمال',
    priceCorrectionCancel: 'انصراف',
    entryAdjustPriceButton: 'تنظیم قیمت',
    entryAutoRoundButton: 'گرد کردن رو به پایین',
    entryAutoRoundRevertButton: 'واگرد گرد کردن',
    autoRoundSubmitFailed: 'اعمال گرد کردن قیمت ناموفق بود.',
    autoRoundNoChange:
      'تغییری اعمال نشد: مبلغ از قبل مضرب «گرد کردن به» شماست، یا آن مقدار هنوز ۱ است. در تنظیمات، «گرد کردن به پایین تا مضربِ … ریال» را (مثلاً ۵٬۰۰۰) تنظیم کنید.',
    autoRoundWillApplyOnExit: 'گرد کردن ثبت شد و با اتمام خروج اعمال می‌شود.',
    autoRoundAppliedSuccess: 'گرد کردن اعمال شد.',
    autoRoundRevertedSuccess: 'گرد کردن لغو شد.',
    autoRoundPendingCleared: 'گرد کردن موقت لغو شد.',
    systemSettingsAutoRoundSectionTitle: 'دکمه گرد کردن به پایین (کارکنان)',
    systemSettingsAutoRoundSectionSubtitle:
      'کارکنان می‌توانند مبلغ را به نزدیک‌ترین «مبلغ تمیز» به پایین ببرند. فقط این مقدار را تنظیم کنید: جمع به نزدیک‌ترین مضرب این عدد از پایین گرد می‌شود (همان واحد قیمت). مثال: مضرب ۵٬۰۰۰ → ۶۱۰٬۱۶۶ می‌شود ۶۱۰٬۰۰۰.',
    systemSettingsAutoRoundEnabled: 'نمایش دکمه‌های «گرد کردن به پایین» و «واگرد» جایی که مجاز است',
    systemSettingsAutoRoundIncrementLabel: 'گرد کردن به پایین تا مضربِ (ریال)',
    systemSettingsAutoRoundIncrementHint:
      'مبلغ قابل پرداخت تا نزدیک‌ترین مضرب این مقدار از پایین کاهش می‌یابد. مثال: ۵٬۰۰۰ → ۶۱۰٬۱۶۶ می‌شود ۶۱۰٬۰۰۰. اگر روی ۱ باشد معمولا جمع ریالی تغییری نمی‌کند؛ برای مبلغ تمیز از ۱٬۰۰۰ / ۵٬۰۰۰ / ۱۰٬۰۰۰ استفاده کنید.',
    systemSettingsAutoRoundIncrementError: 'مقدار معتبر بین ۱ و ۱۰۰۰۰۰۰۰۰ وارد کنید.',
    systemSettingsAutoRoundMinRoleLabel: 'حداقل نقشی که می‌تواند از دکمه گرد کردن به پایین استفاده کند',
    priceCorrectionInvalidAmount: 'مبلغ معتبر وارد کنید.',
    priceCorrectionReasonRequired: 'دلیل اصلاح را وارد کنید.',
    priceCorrectionOutOfBounds: 'مبلغ خارج از محدوده مجاز است.',
    priceCorrectionAdminOverrideWarning:
      'این مبلغ خارج از محدوده تنظیم‌شده است؛ ممکن است برای مدیر همچنان مجاز باشد.',
    priceCorrectionSubmitFailed: 'اعمال اصلاح قیمت ناموفق بود.',
    priceCorrectionBlockedByAutoRound: 'ابتدا گرد کردن را واگرد کنید، سپس قیمت را دستی اصلاح کنید.',
    systemSettingsPriceCorrectionEnabled: 'اجازه اصلاح دستی قیمت قبل از پرداخت',
    systemSettingsPriceCorrectionBoundsLabel: 'حداکثر انحراف از قیمت محاسبه‌شده (٪)',
    systemSettingsPriceCorrectionBoundsHint:
      'کارکنان می‌توانند مبلغ نهایی را در این درصد بالا یا پایینِ جمع خط محاسبه‌شده تنظیم کنند (۰–۱۰۰).',
    systemSettingsPriceCorrectionAdminOverride: 'مدیران می‌توانند از محدودیت انحراف عبور کنند',
    systemSettingsPriceCorrectionMinRoleLabel: 'حداقل نقش برای اصلاح قیمت',
    systemSettingsPriceCorrectionSectionTitle: 'اصلاح قیمت',
    systemSettingsPriceCorrectionSectionSubtitle:
      'امکان تغییر مبلغ نهایی خط قبل از پرداخت (ورود و خروج) در چارچوب محدودیت‌های زیر.',
    systemSettingsPriceCorrectionEnabledHint:
      'در صورت فعال بودن، کارکنان واجد شرایط می‌توانند قبل از ثبت پرداخت در ورود و تسویه گزینه «تنظیم قیمت» را ببینند.',
    systemSettingsPriceCorrectionAdminOverrideHint:
      'در صورت فعال بودن، ادمین و سوپریوزر همچنان می‌توانند مبلغ خارج از محدوده درصدی ثبت کنند.',

    financialManagementTitle: 'مدیریت مالی',
    financialManagementSubtitle: 'مدیریت حساب‌های مالی و مشاهده خلاصه دفتر حساب.',
    financialAccountCreateButton: 'حساب جدید',
    financialAccountCreate: 'ایجاد حساب',
    financialAccountClose: 'بستن',
    financialAccountReactivate: 'فعال‌سازی مجدد',
    financialAccountClosed: 'بسته',
    financialAccountCreateSubmitting: 'در حال ایجاد حساب...',
    financialAccountUpdateSubmitting: 'در حال به‌روزرسانی حساب...',
    financialAccountCodeExists: 'کد حساب تکراری است.',
    financialAccountNameExists: 'نام حساب تکراری است.',
    financialAccountReactivateExpired: 'حساب‌های بسته بعد از ۲ روز قابل فعال‌سازی مجدد نیستند.',
    financialAccountCreateTitle: 'ایجاد حساب مالی',
    financialAccountEditTitle: 'ویرایش حساب مالی',
    financialAccountsListLabel: 'حساب‌های مالی',
    financialAccountsTotal: 'مجموع:',
    financialAccountsLoading: 'در حال بارگذاری حساب‌ها...',
    financialAccountsEmpty: 'حساب مالی یافت نشد.',
    financialAccountsLoadFailed: 'بارگذاری حساب‌های مالی ناموفق بود.',
    financialAccountDetailTitle: 'جزئیات حساب',
    financialAccountDetailLoading: 'در حال بارگذاری جزئیات...',
    financialAccountDetailEmpty: 'یک حساب را برای مشاهده جزئیات انتخاب کنید.',
    financialAccountDetailLoadFailed: 'بارگذاری جزئیات حساب ناموفق بود.',
    financialAccountActive: 'فعال',
    financialAccountInactive: 'غیرفعال',
    financialAccountEdit: 'ویرایش',
    financialAccountActivate: 'فعال‌سازی',
    financialAccountDeactivate: 'غیرفعال‌سازی',
    financialAccountCodeLabel: 'کد حساب',
    financialAccountCodePlaceholder: 'مثلاً ACC-CASH',
    financialAccountNameLabel: 'نام حساب',
    financialAccountNamePlaceholder: 'مثلاً حساب نقدی',
    financialAccountStatusLabel: 'وضعیت',
    financialAccountCreatedAtLabel: 'تاریخ ایجاد',
    financialAccountUpdatedAtLabel: 'آخرین بروزرسانی',
    financialAccountActiveLabel: 'فعال',
    financialAccountSave: 'ذخیره',
    financialAccountSaving: 'در حال ذخیره...',
    financialAccountCancel: 'انصراف',
    financialAccountCreateSuccess: 'حساب مالی ایجاد شد.',
    financialAccountCreateFailed: 'ایجاد حساب مالی ناموفق بود.',
    financialAccountUpdateSuccess: 'حساب مالی بروزرسانی شد.',
    financialAccountUpdateFailed: 'بروزرسانی حساب مالی ناموفق بود.',
    ledgerSummaryTitle: 'خلاصه دفتر حساب',
    ledgerSummarySubtitle: 'جمع ورودی‌ها به تفکیک حساب مالی برای دوره انتخابی.',
    ledgerSummaryStartDate: 'تاریخ شروع',
    ledgerSummaryEndDate: 'تاریخ پایان',
    ledgerSummaryDatePlaceholder: 'YYYY-MM-DD',
    ledgerSummaryGenerate: 'تولید گزارش',
    ledgerSummaryGenerating: 'در حال تولید...',
    ledgerSummaryLoadFailed: 'بارگذاری خلاصه دفتر ناموفق بود.',
    ledgerSummaryColCode: 'کد',
    ledgerSummaryColName: 'نام حساب',
    ledgerSummaryColInflow: 'مجموع ورودی',
    ledgerSummaryColTransactions: 'تراکنش‌ها',
    ledgerSummaryGrandTotal: 'جمع کل',
    ledgerSummaryEmpty: 'داده‌ای برای دوره انتخابی یافت نشد.',

    dailySalesTitle: 'خلاصه فروش روزانه',
    dailySalesSubtitle: 'گزارش فروش پایان روز با مجموع‌ها، جزئیات و نمودارها.',
    dailySalesStartDate: 'تاریخ شروع',
    dailySalesEndDate: 'تاریخ پایان',
    dailySalesDatePlaceholder: 'YYYY-MM-DD',
    dailySalesStaffFilter: 'کارمند',
    dailySalesStaffAll: 'همه کارکنان',
    dailySalesPaymentTypeFilter: 'روش پرداخت',
    dailySalesPaymentTypeAll: 'همه روش‌ها',
    dailySalesBranchFilter: 'شعبه',
    dailySalesBranchAll: 'همه شعب',
    dailySalesGenerate: 'تولید گزارش',
    dailySalesGenerating: 'در حال تولید...',
    dailySalesLoadFailed: 'بارگذاری خلاصه فروش روزانه ناموفق بود.',
    dailySalesEmpty: 'بازه زمانی را انتخاب و گزارش را تولید کنید.',
    dailySalesTotalRevenue: 'کل درآمد',
    dailySalesTransactionCount: 'تراکنش‌ها',
    dailySalesTotalDiscounts: 'کل تخفیف‌ها',
    dailySalesByPaymentType: 'تفکیک بر اساس روش پرداخت',
    dailySalesByAccount: 'تفکیک بر اساس حساب مالی',
    dailySalesByBranch: 'تفکیک بر اساس شعبه',
    dailySalesColPaymentType: 'روش پرداخت',
    dailySalesColAccount: 'حساب',
    dailySalesColBranch: 'شعبه',
    dailySalesColCode: 'کد',
    dailySalesColTransactions: 'تراکنش‌ها',
    dailySalesColRevenue: 'درآمد',
    dailySalesCategoryCash: 'نقدی',
    dailySalesCategoryPos: 'کارتخوان',
    dailySalesCategoryOnline: 'آنلاین',
    dailySalesChartByPaymentType: 'درآمد بر اساس روش پرداخت',
    dailySalesChartByAccount: 'درآمد بر اساس حساب مالی',
    dailySalesNoData: 'داده‌ای برای فیلترهای انتخابی یافت نشد.',

    reportsTabDailySales: 'فروش روزانه',
    reportsTabTimeBasedRevenue: 'درآمد بر اساس زمان',

    timeBasedRevenueTitle: 'درآمد و بهره‌وری بر اساس زمان',
    timeBasedRevenueSubtitle: 'درآمد و بهره‌وری بر اساس ساعت و روز هفته.',
    timeBasedRevenueStartDate: 'تاریخ شروع',
    timeBasedRevenueEndDate: 'تاریخ پایان',
    timeBasedRevenueDatePlaceholder: 'YYYY-MM-DD',
    timeBasedRevenueStaffFilter: 'کارمند',
    timeBasedRevenueStaffAll: 'همه کارکنان',
    timeBasedRevenuePaymentTypeFilter: 'روش پرداخت',
    timeBasedRevenuePaymentTypeAll: 'همه انواع',
    timeBasedRevenueGenerate: 'ایجاد گزارش',
    timeBasedRevenueGenerating: 'در حال ایجاد...',
    timeBasedRevenueLoadFailed: 'بارگذاری گزارش ناموفق بود.',
    timeBasedRevenueEmpty: 'بازه تاریخ را انتخاب کرده و گزارش را ایجاد کنید.',
    timeBasedRevenueTotalRevenue: 'کل درآمد',
    timeBasedRevenueTotalEntries: 'تعداد ورود',
    timeBasedRevenueAvgStay: 'میانگین مدت اقامت',
    timeBasedRevenueMinutes: 'دقیقه',
    timeBasedRevenueByHour: 'بر اساس ساعت',
    timeBasedRevenueByDayOfWeek: 'بر اساس روز هفته',
    timeBasedRevenueColHour: 'ساعت',
    timeBasedRevenueColDay: 'روز',
    timeBasedRevenueColRevenue: 'درآمد',
    timeBasedRevenueColEntries: 'ورودها',
    timeBasedRevenueColAvgStay: 'میانگین اقامت',
    timeBasedRevenueNoData: 'داده‌ای برای فیلترهای انتخابی یافت نشد.',
    timeBasedRevenueChartByHour: 'درآمد بر اساس ساعت',
    timeBasedRevenueChartByDay: 'درآمد بر اساس روز هفته',
    timeBasedRevenueDay1: 'یکشنبه',
    timeBasedRevenueDay2: 'دوشنبه',
    timeBasedRevenueDay3: 'سه‌شنبه',
    timeBasedRevenueDay4: 'چهارشنبه',
    timeBasedRevenueDay5: 'پنج‌شنبه',
    timeBasedRevenueDay6: 'جمعه',
    timeBasedRevenueDay7: 'شنبه',

    reportsTabVisitsSales: 'فروش بازدیدها',
    reportsTabVisitsNotClosed: 'بازدیدهای بسته‌نشده',
    visitsReportLoadFailed: 'بارگذاری گزارش بازدیدها ناموفق بود.',
    visitsReportEmpty: 'بازه تاریخ را انتخاب کرده و گزارش را ایجاد کنید.',
    visitsReportMinutes: 'دقیقه',
    visitsReportNoData: 'داده‌ای برای فیلترهای انتخابی یافت نشد.',
    visitsSalesTitle: 'گزارش فروش بازدیدها',
    visitsSalesSubtitle: 'تعداد بازدید، مدت اقامت و استفاده از کمد.',
    visitsSalesVisitCount: 'تعداد بازدید',
    visitsSalesChildrenCount: 'تعداد کودکان',
    visitsSalesAvgChildren: 'میانگین کودکان در هر بازدید',
    visitsSalesAvgStay: 'میانگین مدت اقامت',
    visitsSalesMedianStay: 'میانه مدت اقامت',
    visitsSalesLockerUsage: 'استفاده از کمد',
    visitsSalesLockerAssignments: 'تخصیص کمد',
    visitsSalesLockerDistinct: 'کمدهای متمایز',
    visitsSalesLockerVisits: 'بازدیدهای دارای کمد',
    visitsSalesByDay: 'بر اساس روز',
    visitsSalesByHour: 'بر اساس ساعت',
    visitsSalesByDayOfWeek: 'بر اساس روز هفته',
    visitsSalesByBranch: 'بر اساس شعبه',
    visitsSalesColDate: 'تاریخ',
    visitsSalesColHour: 'ساعت',
    visitsSalesColDay: 'روز',
    visitsSalesColBranch: 'شعبه',
    visitsSalesColVisits: 'بازدیدها',
    visitsSalesColChildren: 'کودکان',
    visitsSalesColAvgStay: 'میانگین اقامت',
    visitsSalesChartByHour: 'بازدیدها بر اساس ساعت',
    visitsSalesChartByDayOfWeek: 'بازدیدها بر اساس روز هفته',
    visitsSalesChartByDay: 'بازدیدها بر اساس روز',
    visitsSalesChartByBranch: 'بازدیدها بر اساس شعبه',
    visitsNotClosedTitle: 'بازدیدهای بسته‌نشده',
    visitsNotClosedSubtitle: 'بازدیدهای باز و پرداخت‌نشده همراه با مبالغ مورد انتظار و شارژشده.',
    visitsNotClosedOpenCount: 'بازدیدهای باز',
    visitsNotClosedUnpaidCount: 'بازدیدهای پرداخت‌نشده',
    visitsNotClosedOutstanding: 'مانده',
    visitsNotClosedByStatus: 'بر اساس وضعیت',
    visitsNotClosedColStatus: 'وضعیت',
    visitsNotClosedColCount: 'تعداد',
    visitsNotClosedColAvgElapsed: 'میانگین سپری‌شده',
    visitsNotClosedColWithExpected: 'دارای مبلغ مورد انتظار',
    visitsNotClosedColAvgExpected: 'میانگین مورد انتظار',
    visitsNotClosedColOverExpected: 'بیش از مورد انتظار',
    visitsNotClosedColCharged: 'شارژشده',
    visitsNotClosedColPaid: 'پرداخت‌شده',
    visitsNotClosedColOutstanding: 'مانده',
    visitsNotClosedUnpaidSummary: 'خلاصه پرداخت‌نشده',
    visitsNotClosedStatusActive: 'فعال',
    visitsNotClosedStatusPendingTransaction: 'در انتظار تراکنش',
    visitsNotClosedStatusLeftUnpaid: 'ترک‌شده بدون پرداخت',

    utilitiesTitle: 'تجهیزات',
    utilitiesSubtitle:
      'مدیریت منابع فیزیکی. انواع تجهیزات توسط سیستم تعریف می‌شوند؛ با انتخاب نوع، تجهیزات را اضافه و مدیریت کنید.',
    utilitiesTypesLabel: 'انواع تجهیزات',
    utilitiesTypesLoading: 'در حال بارگذاری انواع...',
    utilitiesTypesEmpty: 'هیچ نوعی یافت نشد.',
    utilitiesTypesLoadFailed: 'بارگذاری انواع ناموفق بود.',
    utilitiesTypesSchema: 'ویژگی‌ها',
    utilitiesTypeHardware: 'اتصال سخت‌افزار',
    utilitiesTypeNoHardware: 'بدون سخت‌افزار',
    utilitiesPropRequired: 'الزامی',
    utilitiesListLabel: 'تجهیزات',
    utilitiesSearchPlaceholder: 'جستجو بر اساس شماره یا مجموعه...',
    utilitiesListLoading: 'در حال بارگذاری تجهیزات...',
    utilitiesListEmpty: 'تجهیزاتی یافت نشد.',
    utilitiesListLoadFailed: 'بارگذاری تجهیزات ناموفق بود.',
    utilitiesTotal: 'مجموع',
    utilitiesCreateButton: 'افزودن تجهیزات',
    utilitiesCreateTitle: 'افزودن تجهیزات',
    utilitiesCreateSuccess: 'تجهیزات اضافه شد.',
    utilitiesCreateFailed: 'افزودن تجهیزات ناموفق بود.',
    utilitiesBulkCreateSuccess: '{{count}} مورد تجهیزات ایجاد شد.',
    utilitiesBulkCreateFailed: 'ایجاد تجهیزات ناموفق بود.',
    utilitiesAddSingleTab: 'تکی',
    utilitiesAddBulkTab: 'گروهی',
    utilitiesStartNumberLabel: 'شماره شروع',
    utilitiesEndNumberLabel: 'شماره پایان',
    utilitiesStartNumberPlaceholder: 'مثلاً ۱۰۱',
    utilitiesEndNumberPlaceholder: 'مثلاً ۱۲۰',
    utilitiesBulkRangeHint: '{{count}} مورد تجهیزات ایجاد خواهد شد.',
    utilitiesEditTitle: 'ویرایش تجهیزات',
    utilitiesEditButton: 'ویرایش',
    utilitiesUpdateSuccess: 'تجهیزات به‌روزرسانی شد.',
    utilitiesUpdateFailed: 'به‌روزرسانی تجهیزات ناموفق بود.',
    utilitiesDeactivateButton: 'غیرفعال',
    utilitiesDeactivating: 'در حال غیرفعال‌سازی...',
    utilitiesDeactivateSuccess: 'تجهیزات غیرفعال شد.',
    utilitiesDeactivateFailed: 'غیرفعال کردن تجهیزات ناموفق بود.',
    utilitiesActivateButton: 'فعال‌سازی',
    utilitiesActivating: 'در حال فعال‌سازی...',
    utilitiesActivateSuccess: 'تجهیزات فعال شد.',
    utilitiesActivateFailed: 'فعال کردن تجهیزات ناموفق بود.',
    utilitiesDeleteButton: 'حذف',
    utilitiesDeleting: 'در حال حذف...',
    utilitiesDeleteConfirm:
      'این مورد از تجهیزات برای همیشه حذف شود؟ این عمل قابل بازگشت نیست.',
    utilitiesDeleteSuccess: 'تجهیزات حذف شد.',
    utilitiesDeleteFailed: 'حذف تجهیزات ناموفق بود.',
    utilitiesOpenButton: 'باز کردن کمد',
    utilitiesOpening: 'در حال باز کردن...',
    utilitiesOpenSuccess: 'کمد باز شد.',
    utilitiesOpenFailed: 'باز کردن کمد ممکن نشد. یکپارچه‌سازی را بررسی کنید.',
    utilitiesOpenSentNoConfirm:
      'درخواست باز شدن ارسال شد. بسیاری از دستگاه‌ها به مرورگر تأیید نمی‌دهند (CORS). اگر کمد باز نشد، از REST توسط سرور استفاده کنید یا دستگاه را بررسی کنید.',
    utilitiesDetailLoading: 'در حال بارگذاری...',
    utilitiesDetailEmpty: 'برای مشاهدهٔ جزئیات، تجهیزاتی از فهرست انتخاب کنید.',
    utilitiesSetDropdownListSearchPlaceholder: 'فیلتر مجموعه‌ها…',
    utilitiesSetDropdownNoResults: 'مجموعه‌ای یافت نشد.',
    utilitiesTypeLabel: 'نوع',
    utilitiesTypePlaceholder: 'انتخاب نوع',
    utilitiesSetLabel: 'مجموعه',
    utilitiesSetPlaceholder: 'انتخاب مجموعه',
    utilitiesSetNoOptions: 'مجموعه‌ای نیست. ابتدا ایجاد کنید.',
    utilitiesNumberLabel: 'شماره',
    utilitiesNumberPlaceholder: 'مثلاً ۱۰۱',
    utilitiesStatusLabel: 'وضعیت',
    utilitiesStatusPlaceholder: 'انتخاب وضعیت',
    utilitiesStatusActive: 'فعال',
    utilitiesStatusInactive: 'غیرفعال',
    utilitiesStatusOutOfService: 'خارج از سرویس',
    utilitiesActiveLabel: 'فعال',
    utilitiesNoSet: '—',
    utilitiesCancel: 'انصراف',
    utilitiesSave: 'ذخیره',
    utilitiesSaving: 'در حال ذخیره...',
    utilitiesSetCreateButton: 'افزودن مجموعه',
    utilitiesSetsListLabel: 'مجموعه‌ها',
    utilitiesSetsEmpty: 'هنوز مجموعه‌ای وجود ندارد.',
    utilitiesSetsFilterAll: 'همه',
    utilitiesSetsFilterNoSet: 'بدون مجموعه',
    utilitiesSetEditButton: 'ویرایش',
    utilitiesSetDeleteButton: 'حذف',
    utilitiesTypeLocker: 'کمد',
    utilitiesSetCreateTitle: 'افزودن مجموعه تجهیزات',
    utilitiesSetCreateSuccess: 'مجموعه اضافه شد.',
    utilitiesSetCreateFailed: 'افزودن مجموعه ناموفق بود.',
    utilitiesSetCreating: 'در حال افزودن...',
    utilitiesSetEditTitle: 'ویرایش مجموعه',
    utilitiesSetUpdateSuccess: 'مجموعه به‌روزرسانی شد.',
    utilitiesSetUpdateFailed: 'به‌روزرسانی مجموعه ناموفق بود.',
    utilitiesSetDeleteConfirm:
      'این مجموعه حذف شود؟ تمام تجهیزات آن برای همیشه حذف می‌شوند.',
    utilitiesSetDeleteSuccess: 'مجموعه حذف شد.',
    utilitiesSetDeleteFailed: 'حذف مجموعه ناموفق بود.',
    utilitiesSetNameLabel: 'نام',
    utilitiesSetNamePlaceholder: 'مثلاً کمدهای اصلی',
    utilitiesSetsLoadFailed: 'بارگذاری مجموعه‌ها ناموفق بود.',
    utilitiesAddWizardTitle: 'افزودن تجهیزات',
    utilitiesAddWizardStep1Title: 'مرحله ۱ از ۲: مجموعه تجهیزات',
    utilitiesAddWizardStep1CreateSet: 'ایجاد مجموعه جدید',
    utilitiesAddWizardStep1ExistingSet: 'افزودن به مجموعه موجود',
    utilitiesAddWizardStep1Skip: 'رد کردن این مرحله',
    utilitiesAddWizardStep2Title: 'مرحله ۲ از ۲: افزودن تجهیزات',
    utilitiesAddWizardStep2SingleOnly:
      'بدون انتخاب مجموعه فقط می‌توانید یک مورد تجهیزات اضافه کنید (بدون ایجاد گروهی).',
    utilitiesAddWizardNext: 'بعدی',
    utilitiesAddWizardBack: 'بازگشت',
    integrationsOpenPageHint: 'باز کردن صفحه یکپارچه‌سازی‌ها',
    navSupport: 'پشتیبانی',
    supportTitle: 'پشتیبانی',
    supportNewTicket: 'تیکت جدید',
    supportSubject: 'موضوع',
    supportCategory: 'دسته‌بندی',
    supportCategoryBilling: 'صورتحساب',
    supportCategoryTechnicalIssue: 'مشکل فنی',
    supportCategoryFeatureRequest: 'درخواست قابلیت',
    supportCategoryOther: 'سایر',
    supportBody: 'متن پیام',
    supportStatusNew: 'جدید',
    supportStatusOpen: 'باز',
    supportStatusInProgress: 'در حال انجام',
    supportStatusWaitingOnTenant: 'در انتظار پاسخ',
    supportStatusResolved: 'حل‌شده',
    supportStatusClosed: 'بسته',
    supportPriorityLow: 'کم',
    supportPriorityNormal: 'عادی',
    supportPriorityHigh: 'زیاد',
    supportPriorityCritical: 'بحرانی',
    supportReply: 'پاسخ',
    supportInternalNote: 'یادداشت داخلی',
    supportInternalNoteHint: 'فقط برای کارکنان قابل مشاهده است',
    supportReplyInternal: 'پاسخ داخلی',
    supportAttachments: 'پیوست‌ها',
    supportUpload: 'بارگذاری',
    supportAttachmentTooLarge: 'پیوست بیش از حد بزرگ است',
    supportAttachmentCountExceeded: 'تعداد پیوست‌ها بیش از حد مجاز است',
    supportUnassigned: 'بدون تخصیص',
    supportAssignToMe: 'اختصاص به من',
    supportEmpty: 'تیکتی وجود ندارد',
    supportNoMessages: 'پیامی وجود ندارد',
    supportOperator: 'پشتیبانی',
    supportUnreadBadge: 'تیکت‌های خوانده‌نشده',
    supportCategories: 'دسته‌بندی‌ها',
    supportAddCategory: 'افزودن دسته‌بندی',
    supportArchiveCategory: 'بایگانی دسته‌بندی',
    supportManageCategories: 'مدیریت دسته‌بندی‌ها',
    supportFilterAll: 'همه',
    supportFilterStatus: 'وضعیت',
    supportFilterPriority: 'اولویت',
    supportPriorityLabel: 'اولویت',
    supportMarkRead: 'علامت‌گذاری به‌عنوان خوانده‌شده',
  },
};

export const getTranslations = (locale) => translations[locale] || translations.en;

export const isRtlLocale = (locale) => locale === 'fa';
